import React, { Component } from 'react';
import MobileWalletSection from './MobileWalletSection';
import SweetAlert from 'react-bootstrap-sweetalert';
//import Paoyingchub from './game/paoyingchub';

import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
//import './build/web/igame-index-lobby-wm/style.a57427aa.css';
import { isMobile } from 'react-device-detect';

import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import md5 from 'md5';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      mainsetting: [],
      rewardlist: [],
      activePage: 1,
      checkboxcookie: false,
      isActive: false,
      formData: {},
      errors: {},
      formSubmitted: false,
      loading: true,
      pagecount: 1,
      username: null,
      settingwheel: "",
      settingcheckin: "",
      userid: null,
      phoneNumber: "",
      balance: 0,
      mainacc: null,
      tabselect: 1,
      tabselectsec: 0,
      qrcode: null,
      stateregis: 1,
      checkboxacc: 0,
      products_page_count: 1,
      loginstate: false,
      fullname: null,
      lname: null,
      link: "",
      alert: null,
      depositstate: 0,
      stateforget: 1,
      depositamount: 0,
      stateopterror: "",
      btnisActive: true,
      otpphone: "",
      token: window.localStorage.getItem("token"),
      accnumber: null,
      accnumbertxt: null,
      withdrawDetailTab: 'bank',
      // ===== ฟอร์มเพิ่มบัญชีธนาคาร (แบบ bk8) =====
      addBankCode: '',
      addBankName: '',
      addAccName: '',
      addAccNumber: '',
      showBankDropdown: false,
      savingBank: false,
      // ===== อัพโหลดสลิป (port จาก deposit มือถือ) =====
      slipFile: null,
      slipTabPreviewUrl: null,
      slipIsConfirmed: false,
      slipIsUploading: false,
      balanceReloading: false,
      cryptoAddress: '',
      withdrawamount: 0,
      rankpoint: 0,
      changepassword: false,
      linelink: "",
      errortext: "",
      trueaccount: null,
      datas: null,
      otpphoneforget: "",
      affpercent: 0,
      counter: 300,
      userrecomend: "",
      historylist: [],
      useradvice: [],
      cashoutlist: [],
      tblnextrank: [],
      tblrankall: [],
      maxwithdrawstatus: 0,
      tblprofile: [],
      prodetail: [],
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
      showChgPwdOld: false,
      showChgPwdNew: false,
      showChgPwdConfirm: false,
      chgPwdLoading: false,
      linkaff: "",
      webnamex: "",
      inviteSet: "",
      truegiftlink: "",
      proderedeem: [],
      proderedeemlist: [],
      buttoncliam: false,
      limit: null,
      rankpic: "1.jpeg",
      rankname: null,
      rankob: null,
      cashoutSet: [],
      tblPopupMenu1: [],
      tblPopupMenu2: [],
      tblPopupMenu: null,
      termAndCondition: false,
      errorstatus: false,
      withdrawtab: 0,
      depositTab: 'qr',
      qrSelectedBank: null,
      showSharePanel: false,
      mobileActivePage: 'home',
      showMemberAction: false,

      // ---- history filter state ----
      historyType: 'all',
      historyDateType: 'today',
      historyDateFrom: new Date().toISOString().split('T')[0],
      historyDateTo: new Date().toISOString().split('T')[0],

      // ---- เมนูซ้าย: เปิด/ปิดแต่ละหมวด ----
      openMenus: {
        cashier: true,   // แคชเชียร์ — เปิดค่าเริ่มต้น
        rewards: false,  // รางวัล
        profile: false,  // โปรไฟล์ของฉัน
        history: false,  // ประวัติ
      },

      // ---- แท็บซ้าย: รายการที่เลือกอยู่ในขณะนี้ ----
      // cashier group : 'deposit' | 'withdraw' | 'transfer' | 'withdrawDetail'
      // rewards group : 'cashback' | 'dailyTask' | 'referral'
      // profile group : 'myAccount' | 'messages' | 'changePassword'
      // history group : 'transferHistory'
      activeLeftTab: 'deposit',
    }
  }
  waitnotify = async () => {
    setTimeout(() => { console.log('World!') }, 5000)
  }
  notify = async (mode, msg) => {
    console.log(mode, msg);
    if (mode == "success") {
      await toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "warning") {
      await toast.warning(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "error") {
      await toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "info") {
      await toast.info(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    await this.waitnotify();
  }
  // ---- toggle เปิด/ปิด เมนูซ้าย ----
  toggleMenu = (menuName) => {
    this.setState(prevState => ({
      openMenus: {
        ...prevState.openMenus,
        [menuName]: !prevState.openMenus[menuName],
      }
    }));
  }

  // ---- เลือก sub-tab ซ้าย (และเปิดเมนูที่เกี่ยวข้องอัตโนมัติ) ----
  setActiveTab = (tab, menuName) => {
    this.setState(prevState => ({
      activeLeftTab: tab,
      openMenus: {
        ...prevState.openMenus,
        [menuName]: true,
      }
    }), () => {
      if (tab === 'referral') {
        this.checkuseradvice();
      }
      // pre-fill ชื่อบัญชีด้วยชื่อสมาชิก (แบบ bk8) เมื่อเข้าแท็บเพิ่มบัญชี
      if (tab === 'withdrawDetail' && !this.state.addAccName) {
        const nm = [this.state.fname || this.state.firstname, this.state.lastname]
          .filter(v => v && v !== 'undefined' && v !== 'null').join(' ');
        if (nm) this.setState({ addAccName: nm });
      }
    });
  }

  // ===== รายการธนาคาร (สำหรับ dropdown เพิ่มบัญชี แบบ bk8) =====
  THAI_BANKS = [
    { code: 'KBANK', name: 'KASIKORNBANK' },
    { code: 'SCB', name: 'ไทยพาณิชย์' },
    { code: 'BBL', name: 'กรุงเทพ' },
    { code: 'KTB', name: 'กรุงไทย' },
    { code: 'BAY', name: 'กรุงศรีอยุธยา' },
    { code: 'TTB', name: 'ทหารไทยธนชาต' },
    { code: 'GSB', name: 'ออมสิน' },
    { code: 'BAAC', name: 'ธ.ก.ส.' },
    { code: 'CIMB', name: 'ซีไอเอ็มบี ไทย' },
    { code: 'UOB', name: 'ยูโอบี' },
    { code: 'KKP', name: 'เกียรตินาคินภัทร' },
    { code: 'TISCO', name: 'ทิสโก้' },
    { code: 'LHFG', name: 'แลนด์ แอนด์ เฮ้าส์' },
    { code: 'GHB', name: 'อาคารสงเคราะห์' }
  ];

  // ===== เลือกธนาคารจาก dropdown =====
  selectAddBank = (bank) => {
    this.setState({
      addBankCode: bank.code,
      addBankName: bank.name,
      showBankDropdown: false
    });
  };

  // ===== บันทึก/เพิ่มบัญชีธนาคาร =====
  // ===== อัพโหลดสลิป (port จาก deposit มือถือ) =====
  handleSlipFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    this.setState({ slipFile: file, slipTabPreviewUrl: previewUrl, slipIsConfirmed: false });
  };

  clearSlipFile = () => {
    this.setState({ slipFile: null, slipTabPreviewUrl: null, slipIsConfirmed: false, slipIsUploading: false });
    if (this._slipInput) this._slipInput.value = '';
  };

  // อัพโหลดสลิปทันทีตอนเลือกไฟล์ (ปุ่ม "อัพโหลด Slip" ในแท็บฝากปกติ)
  handleBankSlipUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const token = localStorage.getItem('auth_token');
    if (!token) { await this.notify('error', 'กรุณาเข้าสู่ระบบใหม่'); return; }
    try {
      const decoded = jwt_decode(token);
      const Username = decoded.message.playerid;
      await this.notify('info', 'กำลังอัปโหลดสลิป...');
      const formData = new FormData();
      formData.append('file', file);
      formData.append('userid', Username);
      formData.append('System', Systems);
      await instance.post('/api/v1/uploadslip', formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      await this.notify('success', 'อัปโหลดสลิปสำเร็จ!');
    } catch (err) {
      await this.notify('error', 'อัปโหลดสลิปไม่สำเร็จ กรุณาลองใหม่');
    }
    if (e.target) e.target.value = '';
  };

  confirmSlipUpload = async () => {
    const { slipFile } = this.state;
    if (!slipFile) { await this.notify('warning', 'กรุณาเลือกสลิปก่อน'); return; }
    const token = localStorage.getItem('auth_token');
    if (!token) { await this.notify('error', 'กรุณาเข้าสู่ระบบใหม่'); return; }
    try {
      const decoded = jwt_decode(token);
      const Username = decoded.message.playerid;
      this.setState({ slipIsUploading: true });
      const formData = new FormData();
      formData.append('file', slipFile);
      formData.append('userid', Username);
      formData.append('System', Systems);
      await instance.post('/api/v1/uploadslip', formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      this.setState({ slipIsConfirmed: true, slipIsUploading: false });
      await this.notify('success', 'อัปโหลดสลิปสำเร็จ!');
    } catch (err) {
      this.setState({ slipIsUploading: false });
      await this.notify('error', 'อัปโหลดสลิปไม่สำเร็จ กรุณาลองใหม่');
    }
  };

  saveBankAccount = async () => {
    const { addBankCode, addBankName, addAccName, addAccNumber } = this.state;

    if (!addBankCode) { await this.notify('warning', 'กรุณาเลือกธนาคาร'); return; }
    if (!addAccName || !addAccName.trim()) { await this.notify('warning', 'กรุณากรอกชื่อบัญชี'); return; }
    if (!addAccNumber || !addAccNumber.trim()) { await this.notify('warning', 'กรุณากรอกเลขที่บัญชี'); return; }

    const token = localStorage.getItem('auth_token');
    if (!token) { await this.notify('error', 'กรุณาเข้าสู่ระบบใหม่'); return; }

    try {
      const decoded = jwt_decode(token);
      const Username = decoded.message.playerid;

      this.setState({ savingBank: true });

      // NOTE: ต่อ endpoint เพิ่มบัญชีจริงตรงนี้ (ถ้าชื่อ/พารามิเตอร์ต่างจากนี้แจ้งได้ เปลี่ยนให้)
      const res = await instance.post('/api/v1/adduserbank', {
        userid: Username,
        System: Systems,
        bankcode: addBankCode,
        bankname: addBankName,
        accname: addAccName,
        accnumber: addAccNumber
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data && (res.data.status === 200 || res.data.status === 201)) {
        await this.notify('success', 'เพิ่มบัญชีเรียบร้อย');
        this.setState({ addBankCode: '', addBankName: '', addAccName: '', addAccNumber: '', savingBank: false });
        this.rechecklogin(Username, token);
      } else {
        this.setState({ savingBank: false });
        await this.notify('error', (res.data && res.data.message) || 'ไม่สามารถเพิ่มบัญชีได้');
      }
    } catch (err) {
      this.setState({ savingBank: false });
      await this.notify('error', 'ไม่สามารถเพิ่มบัญชีได้ กรุณาลองใหม่');
    }
  };

  // ---- รีโหลดยอดเงิน ----
  reloadBalance = async () => {
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await this.rechecklogin(Username, token);
    }
  }

  // ---- กด "โอนเสร็จสิ้น" → ดึงเครดิตใหม่ + หมุนยอดกระเป๋า ----
  handleTransferDone = async () => {
    if (this.state.balanceReloading) return;
    this.setState({ balanceReloading: true });
    try { await this.reloadBalance(); } catch (e) {}
    // คงสปินไว้สักครู่ให้เห็นว่ากำลังอัปเดต
    setTimeout(() => this.setState({ balanceReloading: false }), 1200);
  }

  // ---- ดึงประวัติการโอนเงิน ----
  calllisthistory = (userid) => {
    instance.post("/api/v1/userwithdrawlist", {
      userid: userid,
      Cat_ID: 0,
      System: Systems,
      page: 1,
      type: 1
    }).then((res) => {
      if (res.data.status === 200) {
        const datas = res.data.message;
        this.setState({ historylist: datas.withdrawlist });
      } else {
        this.setState({ historylist: [] });
      }
    });
  }

  // ---- เคลมเงินคืน (cashback) ----
  opencliamcashout = async (e) => {
    var token = localStorage.getItem('auth_token');
    if (token == null) return;
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/cliamcashout", {
      userid: Username,
      System: Systems,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        await this.rechecklogin(Username, token);
        await Swal.fire({ title: 'สำเร็จ!', text: 'ทำรายการรับเงินเรียบร้อย', icon: 'success', confirmButtonText: 'ตกลง' });
      } else if (res.data.status === 201) {
        await Swal.fire({ title: 'แจ้งเตือน', text: 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน', icon: 'warning', confirmButtonText: 'ตกลง' });
      } else {
        await Swal.fire({ title: 'ผิดพลาด', text: 'ไม่สามารถทำรายการได้', icon: 'error', confirmButtonText: 'ตกลง' });
      }
    }).catch(async (err) => {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        localStorage.clear();
        await Swal.fire({ title: 'Warning!', text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง', icon: 'warning', confirmButtonText: 'ตกลง' });
        window.location.href = '/';
      }
    });
  }

  // ---- เคลมรางวัลชวนเพื่อน (affiliate invite) ----
  opencliaminvite = async (e) => {
    var token = localStorage.getItem('auth_token');
    if (token == null) {
      await Swal.fire({ title: 'แจ้งเตือน', text: 'คุณยังไม่ได้เข้าสู่ระบบ', icon: 'warning', confirmButtonText: 'ตกลง' });
      return;
    }
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/cliaminvite", {
      userid: Username,
      System: Systems,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        await this.rechecklogin(Username, token);
        await Swal.fire({ title: 'สำเร็จ!', text: 'ทำรายการรับเงินเรียบร้อย', icon: 'success', confirmButtonText: 'ตกลง' });
      } else if (res.data.status === 201) {
        await Swal.fire({ title: 'แจ้งเตือน', text: 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน', icon: 'warning', confirmButtonText: 'ตกลง' });
      } else {
        await Swal.fire({ title: 'ผิดพลาด', text: 'ไม่สามารถทำรายการได้', icon: 'error', confirmButtonText: 'ตกลง' });
      }
    }).catch(async (err) => {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        localStorage.clear();
        await Swal.fire({ title: 'Warning!', text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง', icon: 'warning', confirmButtonText: 'ตกลง' });
        window.location.href = '/';
      }
    });
  }

  // ---- ดึงรายชื่อเพื่อนที่ถูกแนะนำ ----
  checkuseradvice = () => {
    instance.post("/api/v1/checkuseradvice", {
      User_id: this.state.username,
      page: 1,
      System: Systems,
    }).then((res) => {
      if (res.data.status === 200) {
        this.setState({ useradvice: res.data.message.useradvicelist });
      } else {
        this.setState({ useradvice: [] });
      }
    });
  }

  // ---- ถอนเงิน ----
  submitwithdraw = async (e) => {
    if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
      if (parseFloat(this.state.withdrawamount) >= 10) {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
          var decoded = jwt_decode(token);
          var Username = decoded.message.playerid;
          await instance.post("/api/v1/userwithdraw", {
            User_id: Username,
            System: Systems,
            amount: this.state.withdrawamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              await Swal.fire({
                title: 'Success!',
                text: 'รายการถอนเรียบร้อย',
                icon: 'success',
                confirmButtonText: 'ตกลง'
              });
              this.setState({ withdrawtab: 1 });
              this.calllisthistory(Username);
            } else if (res.data.status === 203) {
              await Swal.fire({
                title: 'Error!',
                text: 'ท่านติด Turnover อีก ' + res.data.amountturnover + ' บาท',
                icon: 'error',
                confirmButtonText: 'ตกลง'
              });
            } else {
              await Swal.fire({
                title: 'Error!',
                text: 'รายการถอนมีปัญหา โปรดติดต่อพนักงาน',
                icon: 'error',
                confirmButtonText: 'ตกลง'
              });
            }
          });
        }
      } else {
        await Swal.fire({
          title: 'Warning!',
          text: 'ขั้นต่ำในการถอน 10 บาท',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        });
      }
    } else {
      await Swal.fire({
        title: 'Warning!',
        text: 'ยอดถอนของท่านไม่เพียงพอในการถอน',
        icon: 'warning',
        confirmButtonText: 'ตกลง'
      });
    }
  }

  // ---- onChange สำหรับช่องกรอก (ถอน/ฝาก) ----
  onChange = async (event) => {
    if (event.target !== undefined) {
      let nam = event.target.name !== undefined ? event.target.name : event.name;
      let val = event.target.value !== undefined ? event.target.value : event.value;
      if (nam === "withdrawamount") {
        if (this.state.maxwithdrawstatus === 1) {
          this.setState({ [nam]: this.state.balance });
          await Swal.fire({
            title: 'Warning!',
            text: 'บังคับถอนยอดทั้งหมด',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          });
        } else if (Number(val) <= Number(this.state.balance)) {
          this.setState({ [nam]: val });
        } else {
          await Swal.fire({
            title: 'Warning!',
            text: 'ยอดถอนของท่านไม่เพียงพอในการถอน',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          });
        }
      } else {
        this.setState({ [nam]: val });
      }
    }
  }

  // ---- เลือกยอดถอนด่วน ----
  handleClick = async (e, price) => {
    if (price <= this.state.balance) {
      this.setState({ withdrawamount: price });
    } else {
      await Swal.fire({
        title: 'Warning!',
        text: 'ยอดถอนของท่านไม่เพียงพอในการถอน',
        icon: 'warning',
        confirmButtonText: 'ตกลง'
      });
    }
  }

  checktab(e, index) {
    if (index == 2 && this.state.tabselectsec == 1) {
      // ไม่ทำอะไร
    } else {
      if (index == 2 && this.state.qrcode != null) {
        this.setState({ tabselect: 0, tabselectsec: 1 });
      } else {
        this.setState({ tabselect: index, tabselectsec: 0 });
      }
    }
  }

  onChangexdep = event => {
    if (event.target !== undefined) {
      this.setState({ depositamount: event.target.value });
    }
  };

  handleClickdeposit = async (e, price) => {
    this.setState({ depositamount: price });
  }

  confirmdeposit = async (e, num) => {
    console.log(493, num)
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;

    if (num === 0) {
      if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
        if (token != null) {
          Username = decoded.message.playerid;
          this.setState({ depositstate: 1 });
          instance.post("/api/v1/getqrcode", {
            username: Username,
            System: Systems,
            paymentstate: 1,
            amount: this.state.depositamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            const d = res.data || {};
            // field อยู่ได้ทั้งระดับบนสุด หรือใน tblpaymentgatewayx (apay24 / type 10)
            const gw = d.tblpaymentgatewayx || {};
            const st = Number(d.status || gw.status);
            const ll = this.state.linelink;
            const lineBtn = ll
              ? `<a href="${ll}" target="_blank" rel="noreferrer" style="display:inline-flex;align-items:center;gap:6px;margin-top:14px;background:#06C755;color:#fff;text-decoration:none;padding:9px 18px;border-radius:8px;font-weight:700;font-size:14px;">💬 แจ้งพนักงาน (LINE)</a>`
              : '';
            const msgX = d.message || gw.message || '';

            // ── เคส QR เก่า / reuse — เช็คก่อน ไม่ว่า success จะ true/false (isOld / state = old|reuse) ──
            const isOld = d.isOld === true || gw.isOld === true
              || ['old', 'reuse', 'exist', 'existing'].includes(String(d.state).toLowerCase())
              || ['old', 'reuse', 'exist', 'existing'].includes(String(gw.state).toLowerCase())
              || /ค้างอยู่|มีรายการฝาก|ยังไม่หมดอายุ|รายการเดิม|รายการฝากเดิม/.test(msgX);
            const oldLink = gw.link || d.link || (d.rows && d.rows.qrcode) || gw.QRcode || d.qrcode || null;

            if (isOld && oldLink) {
              this.setState({ depositstate: 0, qrcode: null, paymentLink: null, paymentInfo: null });
              // ใช้ยอดเงินเก่าจากรายการเดิม (backend ส่ง pg.amount / pg.trueamount) เป็นอันดับแรก
              const oldAmount = gw.amount || gw.trueamount || gw.Amount || d.amount || d.trueamount || (d.rows && (d.rows.amount || d.rows.Amount)) || this.state.depositamount || 0;
              const amtStr = Number(oldAmount || 0).toLocaleString('en', { minimumFractionDigits: 2 });
              const msg = msgX || 'พบรายการฝากเดิมที่ยังไม่หมดอายุ';
              const r = await Swal.fire({
                title: '⚠ พบ QR Code เก่าค้างอยู่',
                html: `<div style="font-size:14px;color:#333;line-height:1.7;">${msg}</div>`
                  + `<div style="background:#fff7ed;border:1px solid #fed7aa;border-radius:10px;padding:12px 16px;margin:14px auto 0;max-width:300px;">`
                  + `<div style="font-size:12.5px;color:#9a3412;">นี่คือ QR Code / รายการเดิมที่ยังไม่หมดอายุ</div>`
                  + `<div style="font-size:26px;font-weight:800;color:#ea580c;margin-top:4px;">฿ ${amtStr}</div>`
                  + `</div>`
                  + `<div style="font-size:13.5px;color:#555;margin-top:14px;">ต้องการเปิดลิงก์ชำระเงินเดิมหรือไม่?</div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: '🔗 เปิดลิงก์ชำระเงิน',
                confirmButtonColor: '#0a5ebd',
                cancelButtonText: '🚫 แจ้งยกเลิก',
                cancelButtonColor: '#e74c3c'
              });
              if (r.isConfirmed) {
                // ตกลง → ตั้งสถานะหน้า "รอดำเนินการ" (เหมือนฝากปกติ) + เปิดลิงก์ชำระเงินเดิม
                const reuseInfo = {
                  Amount: oldAmount,
                  trueamount: gw.trueamount || oldAmount,
                  orderid: gw.orderid || d.orderid || (d.rows && d.rows.orderid) || ''
                };
                this.setState({
                  mainacc: d.mainacc || this.state.mainacc,
                  qrcode: oldLink,
                  paymentLink: oldLink,
                  paymentInfo: reuseInfo,
                  counter: 3000,
                  depositstate: 0,
                  tabselectsec: 1,
                  tabselect: 0,
                  depositTab: 'qr'
                });
                window.open(oldLink, '_blank', 'noopener,noreferrer');
                this.notify('info', 'เปิดลิงก์ชำระเงินรายการเดิม กรุณาดำเนินการชำระเงิน');
              } else if (r.dismiss === Swal.DismissReason.cancel) {
                // ไม่ → แจ้งไปที่ไลน์
                if (ll) {
                  window.open(ll, '_blank', 'noopener,noreferrer');
                } else {
                  await Swal.fire({
                    title: 'แจ้งพนักงาน',
                    html: `<div style="font-size:14px;color:#333;line-height:1.7;">กรุณาติดต่อพนักงานเพื่อยกเลิก/ดำเนินการรายการฝากที่ค้างอยู่</div>`,
                    icon: 'info',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#06C755'
                  });
                }
              }
              return;
            }

            // ── เคส error ทั่วไป — success === false หรือ status >= 202 ──
            const okFalse = d.success === false || gw.success === false;
            if (okFalse || (st && st >= 202)) {
              const msg = msgX || 'ไม่สามารถสร้างรายการฝากได้ กรุณาลองใหม่อีกครั้ง';
              this.setState({ depositstate: 0, qrcode: null, paymentLink: null, paymentInfo: null });
              const r = await Swal.fire({
                title: 'ไม่สามารถสร้างรายการได้',
                html: `<div style="font-size:14.5px;color:#333;line-height:1.7;">${msg}</div>`
                  + `<div style="font-size:13px;color:#d35400;margin-top:10px;line-height:1.6;">โปรดใช้ QR เก่าในการชำระเงิน หรือแจ้งพนักงาน</div>`
                  + lineBtn,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#f5a623',
                cancelButtonText: 'ยกเลิกรายการ',
                cancelButtonColor: '#e74c3c'
              });
              if (r.dismiss === Swal.DismissReason.cancel) {
                await Swal.fire({
                  title: 'แจ้งยกเลิกรายการ',
                  html: `<div style="font-size:14px;color:#333;line-height:1.7;">กรุณาติดต่อพนักงานผ่านไลน์ เพื่อยกเลิกรายการฝากที่ค้างอยู่</div>`
                    + lineBtn,
                  icon: 'info',
                  confirmButtonText: 'ตกลง',
                  confirmButtonColor: '#06C755'
                });
              }
              return;
            }
            const pg = d.tblpaymentgatewayx || {};
            // redirect URL (payment gateway) / qrcode — รองรับหลาย field
            const link = pg.link || (d.rows && d.rows.qrcode) || d.qrcode || null;
            const qrImg = pg.QRcode || d.picture || link || null;
            if (link && /^https?:\/\//.test(link)) {
              window.open(link, "_blank", "noopener,noreferrer");
            }
            this.setState({
              mainacc: d.mainacc || this.state.mainacc,
              qrcode: qrImg,
              paymentLink: link,
              paymentInfo: (d.rows || pg) || null,
              counter: 3000,
              depositstate: 0,
              tabselectsec: 1,
              tabselect: 0
            });
            this.notify('success', 'กรุณาดำเนินการภายใน 50 นาที');
          }).catch(async () => {
            this.setState({ depositstate: 0 });
            this.notify('error', 'ไม่สามารถสร้างรายการได้ กรุณาลองใหม่');
          });
        }
      } else {
        await Swal.fire({
          title: 'Warning!',
          text: 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
      }
    } else if (num === 1) {
      this.setState({ depositstate: 1 });
    } else if (num === 5) {
      document.getElementById("truemonney").click()
    } else {
      this.setState({ depositstate: 0 });
    }
  }

  checklogin() {
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      this.setState({
        userid: decoded.message.playerid,
        username: decoded.message.playerid,
        firstname: decoded.message.firstname,
        lastname: decoded.message.lastname,
        point: decoded.message.Point,
        loginstate: true,
      });
    } else {
      this.setState({ loginstate: false });
    }
  }

  async rechecklogin(Username, token) {
    try {
      const space = window.location.host;
      var userhash = md5(Username);
      const linkaff = "https://" + space + "/register?reg=" + userhash;
      instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'rechecklogin-navbar.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          localStorage.setItem('auth_token', res.data.token);
          this.calllisthistory(Username);
          this.setState({
            tblrankall: res.data.tblrankall,
            rankpic: res.data.tblrank?.image,
            rankname: res.data.tblrank?.name,
            linkaff: linkaff,
            rankob: res.data.tblrank,
            rankpoint: res.data.rankpoint,
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            tblprofile: res.data.message,
            username: res.data.message.playerid,
            fname: res.data.message.firstname,
            fullname: res.data.message.firstname,
            lastname: res.data.message.lastname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
        } else if (res.data.status === 401) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }
      }).catch(async (err) => {
        console.log(err)
        if (err.response && (err.response.status === 401 || err.response.status === 403)) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }
      });
    } catch (ex) { }
  }

  async recheccredit(evt) {
    if (evt?.currentTarget) {
      evt.currentTarget.classList.add("fa-spin");
    }
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    this.setState({
      checkcredit: true,
      userid: decoded.message.playerid,
      username: decoded.message.playerid,
      loginstate: true,
    });
    try {
      const res = await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'recheccredit-profile.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.status === 200) {
        localStorage.setItem('auth_token', res.data.token);
        const space = window.location.host;
        const userhash = md5(res.data.message.playerid || '');
        const linkaff = "https://" + space + "/register?reg=" + userhash;
        this.setState({
          accnumber: res.data.message.accnumber,
          userid: res.data.message.member_id,
          tblprofile: res.data.message,
          username: res.data.message.playerid,
          fname: res.data.message.firstname,
          fullname: res.data.message.firstname,
          lastname: res.data.message.lastname,
          point: res.data.message.Point,
          balance: res.data.databalance,
          loginstate: true,
          checkcredit: false,
          rankpic: res.data.tblrank?.image,
          rankname: res.data.tblrank?.name,
          rankpoint: res.data.rankpoint,
          linkaff: linkaff,
        });
      } else if (res.data.status === 401) {
        localStorage.clear();
        window.location.href = '/';
      }
    } catch (err) {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        localStorage.clear();
        window.location.href = '/';
      }
    } finally {
      if (evt?.currentTarget) {
        evt.currentTarget.classList.remove("fa-spin");
      }
      this.setState({ checkcredit: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this._onVisibilityChange);
  }

  // auto-refresh balance เมื่อผู้ใช้กลับมาที่ tab
  _onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      const token = localStorage.getItem('auth_token');
      if (token) {
        try {
          const decoded = jwt_decode(token);
          this.rechecklogin(decoded.message.playerid, token);
        } catch (e) {}
      }
    }
  };

  async componentDidMount() {
    // ถ้า parent ส่ง defaultPage มา ให้ตั้งค่า activeLeftTab
    if (this.props.defaultPage) {
      this.setState({ activeLeftTab: this.props.defaultPage });
    }
    // refresh balance เมื่อ tab กลับมา visible
    document.addEventListener('visibilitychange', this._onVisibilityChange);
    setInterval(() =>
      this.setState({ counter: this.state.counter - 1 })
      , 1000);
    try {
      var token = localStorage.getItem('auth_token');
      // ถ้าไม่ได้ล็อกอิน (ไม่มี token) และอยู่หน้า /profile จริงๆ → กลับไปหน้าหลัก
      // (เช็ค pathname กันลูป เพราะ component อาจถูก mount ในหน้าอื่นด้วย)
      if (token == null) {
        this.setState({ loginstate: false });
        const path = (window.location.pathname || '').toLowerCase();
        if (path === '/profile' || path.startsWith('/profile/')) {
          window.location.replace('/');
        }
        return;
      }
      if (token != null) {
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await this.rechecklogin(Username, token);
        this.setState({
          userid: decoded.message.playerid,
          username: decoded.message.playerid,
          firstname: decoded.message.firstname,
          lastname: decoded.message.lastname,
          loginstate: true,
        });
      } else {
        this.setState({ loginstate: false });
      }
      if (token != null) {
        var decoded = jwt_decode(token);
        let Username = decoded.message.playerid;
        instance.post("/api/v1/getqrcode", {
          username: Username,
          System: Systems,
          amount: 50
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
          this.setState({ mainacc: res.data.mainacc });
        });
      }
    } catch (error) { }

    try {
      await instance.post("/api/v1/mainsetting", {
        System: Systems,
      }).then((res) => {
        if (res.data.status === 200) {
          const datas = res.data.message;
          var min = res.data.tblcatagoryx[0].limitdeposit;
          var max = res.data.tblcatagoryx[0].maxdeposit;
          var maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax
          var limit = { min, max }
          this.setState({
            maxwithdrawstatus: maxwithdrawstatus,
            linelink: datas[1].value,
            webnamex: datas[7].value,
            System: res.data.tblcatagoryx[0].System,
            cashoutSet: res.data.tblcashoutsetting[0],
            inviteSet: res.data.tblinvitedsetting[0],
            datas: datas,
            limit: limit,
          });
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  }

  // ---- เปลี่ยนรหัสผ่าน (desktop inline form) ----
  handleChangePass = async (e) => {
    e.preventDefault();
    const { oldpassword, newpassword, confirmpassword } = this.state;
    if (!oldpassword || oldpassword.trim() === '') {
      await Swal.fire({ title: 'แจ้งเตือน', text: 'กรุณากรอกรหัสผ่านปัจจุบัน', icon: 'warning', confirmButtonText: 'ตกลง' });
      return;
    }
    if (!newpassword || newpassword.trim() === '') {
      await Swal.fire({ title: 'แจ้งเตือน', text: 'กรุณากรอกรหัสผ่านใหม่', icon: 'warning', confirmButtonText: 'ตกลง' });
      return;
    }
    if (newpassword.length < 6) {
      await Swal.fire({ title: 'แจ้งเตือน', text: 'รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร', icon: 'warning', confirmButtonText: 'ตกลง' });
      return;
    }
    if (newpassword !== confirmpassword) {
      await Swal.fire({ title: 'แจ้งเตือน', text: 'รหัสผ่านใหม่และยืนยันรหัสผ่านไม่ตรงกัน', icon: 'warning', confirmButtonText: 'ตกลง' });
      return;
    }
    this.setState({ chgPwdLoading: true });
    try {
      const token = localStorage.getItem('auth_token');
      if (!token) {
        await Swal.fire({ title: 'แจ้งเตือน', text: 'คุณยังไม่ได้เข้าสู่ระบบ', icon: 'warning', confirmButtonText: 'ตกลง' });
        this.setState({ chgPwdLoading: false });
        return;
      }
      const decoded = jwt_decode(token);
      const Username = decoded.message.playerid;
      await instance.post("/api/v1/resetpassword", {
        username: Username,
        oldpass: oldpassword,
        newpass: newpassword,
        System: Systems,
        type: 1,
      }, { headers: { Authorization: `Bearer ${token}` } }).then(async (res) => {
        if (res.data.status === 200) {
          await Swal.fire({ title: 'สำเร็จ!', text: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้ว', icon: 'success', confirmButtonText: 'ตกลง' });
          this.setState({ oldpassword: '', newpassword: '', confirmpassword: '' });
        } else if (res.data.status === 201) {
          await Swal.fire({ title: 'ผิดพลาด!', text: 'รหัสผ่านเดิมไม่ถูกต้อง', icon: 'error', confirmButtonText: 'ตกลง' });
        } else if (res.data.status === 202) {
          await Swal.fire({ title: 'ผิดพลาด!', text: 'รหัสผ่านใหม่ห้ามเหมือนรหัสเดิม', icon: 'error', confirmButtonText: 'ตกลง' });
        } else {
          await Swal.fire({ title: 'ผิดพลาด!', text: res.data.message || 'ไม่สามารถเปลี่ยนรหัสผ่านได้', icon: 'error', confirmButtonText: 'ตกลง' });
        }
      });
    } catch (err) {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        localStorage.clear();
        window.location.href = '/';
      } else {
        await Swal.fire({ title: 'ผิดพลาด!', text: 'เกิดข้อผิดพลาด กรุณาลองใหม่', icon: 'error', confirmButtonText: 'ตกลง' });
      }
    } finally {
      this.setState({ chgPwdLoading: false });
    }
  };

  // ---- render เนื้อหาฝั่งขวาตาม activeLeftTab ----
  renderRightContent() {
    const { activeLeftTab } = this.state;

    switch (activeLeftTab) {
      // ===== แคชเชียร์ =====
      case 'deposit':
        return this.renderDepositContent();
      case 'withdraw':
        return (
          <section className="st-detail-container withdraw st-detail-deposit-container"><div className="st-tab with-notice "><div className="withdrawal-wrapper"><div className="standard-tab-container st-icon-text-tab withdraw-tab-container"><div className="_withdrawalSummaryContainer_g259c_1"><div className="_remainingTurnoverContainer_g259c_1" id="remainingTurnover"><div className="_titleContainer_g259c_1"><span className="_icon_g259c_83"><svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.74609 1.34681L14.5104 0.710449V6.43772" stroke="#0071E3" strokeWidth="1.27273"></path><path d="M0.420898 8.98318L6.18518 3.89227L8.74708 7.07409L14.5114 0.710449" stroke="#0071E3" strokeWidth="1.27273"></path></svg></span><span>ยอดเทิร์นที่คงเหลือ</span></div><div className="_subTitleContainer_g259c_13"><span className="_currencyLabel_g259c_13">THB</span><span className="_remainingAmount_g259c_31">{parseFloat(this.state.balance || 0).toFixed(2)}</span></div></div><div className="_withdrawalBalanceContainer_g259c_1" id="withdrawalBalance"><div className="_titleContainer_g259c_1"><span className="_icon_g259c_83"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 5.7L5.72222 7.5L8.5 4.5" stroke="#5AE02F"></path><circle cx="6" cy="6" r="5.5" stroke="#5AE02F"></circle></svg></span><span>ยอดคงเหลือที่สามารถถอนได้</span></div><div className="_subTitleContainer_g259c_13"><span className="_currencyLabel_g259c_13">THB</span><span className="_withdrawalAmount_g259c_31">{parseFloat(this.state.balance || 0).toFixed(2)}</span></div></div></div><label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">ตัวเลือกการถอน</label><div className="standard-tab transaction-option" id="transaction-option"><div><div className={`_transactionOptionTabHeader_ktmyr_1 transaction-option-tab-header ${!this.state.withdrawtab || this.state.withdrawtab === 'B' || this.state.withdrawtab === 0 ? '_active_ktmyr_44' : ''}`} data-tutorialkey="B" onClick={() => this.setState({ withdrawtab: 'B' })} style={{ cursor: 'pointer' }}><div className="_transactionOptionImageContainer_ktmyr_30 transaction-option-image-container image-container"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 26.9 24.7" className="beta-option-B" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-option-B .st0{fill:url(#beta-option-B-beta-option-B-SVGID_1_);}\n\t .beta-option-B .st1{fill:url(#beta-option-B-beta-option-B-SVGID_2_);}\n  " }} /><g className="beta-option-B"><g><linearGradient id="beta-option-B-beta-option-B-SVGID_1_" gradientUnits="userSpaceOnUse" x1="10.9063" y1="15.6347" x2="15.9711" y2="15.6347"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st0" d="M13.2,19.5c-1.3,0-2.3-0.7-2.3-1.3c0-0.3,0.3-0.8,0.6-0.8c0.4,0,0.7,0.7,1.7,0.8v-2.1c-1-0.4-2.1-0.8-2.1-2.2
	c0-1.4,1-2,2.1-2.1v-0.3c0-0.1,0.2-0.3,0.4-0.3c0.2,0,0.4,0.1,0.4,0.3v0.3c0.7,0,1.8,0.2,1.8,0.9c0,0.2-0.2,0.7-0.6,0.7
	c-0.3,0-0.6-0.3-1.3-0.4v1.9c1,0.4,2,0.8,2,2.3c0,1.3-0.8,2.1-2,2.3v0.3c0,0.1-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3V19.5z
	 M13.3,14.6V13c-0.5,0.1-0.9,0.3-0.9,0.8C12.4,14.2,12.8,14.4,13.3,14.6 M13.8,16.3v1.9c0.5-0.1,0.8-0.4,0.8-0.9
	C14.7,16.8,14.3,16.5,13.8,16.3"></path><linearGradient id="beta-option-B-beta-option-B-SVGID_2_" gradientUnits="userSpaceOnUse" x1="0" y1="12.3267" x2="26.877" y2="12.3267"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st1" d="M26.9,5.8l-1.4-5.3C25.4,0.2,25.1,0,24.8,0H2.1C1.8,0,1.5,0.2,1.4,0.5L0,5.8C0,6,0,6.2,0.1,6.3
	c0.1,0.2,0.3,0.3,0.5,0.3h1.4h0V24c0,0.4,0.3,0.7,0.7,0.7h21.4c0.4,0,0.7-0.3,0.7-0.7L24.7,6.6h1.5c0.2,0,0.4-0.1,0.5-0.3
	C26.9,6.2,26.9,6,26.9,5.8z M19.8,3.6l-4.3-2.3h8.8l0.9,3.1l0.2,0.9h-5.2V4.2C20.1,4,20,3.7,19.8,3.6z M23.5,6.6l0.1,16.8l0,0h-3.4
	V6.6H23.5L23.5,6.6z M6.8,6.6v2.2v14.6H3.4V6.6H6.8L6.8,6.6z M18.8,23.4H8.1V9.2L13.4,7l5.4,2.1V23.4z M13.7,5.7c-0.1,0-0.2,0-0.3,0
	c-0.1,0-0.2,0-0.3,0L9.5,7.2L8.1,7.8V4.6l5.3-2.9l5.4,2.9v2.3v0.9L13.7,5.7z M1.5,5.3l1.1-4h8.8L7.1,3.6C6.9,3.7,6.7,4,6.7,4.2v1.1
	H2.6H1.5z"></path></g></g></svg></div><div className="_transactionOptionTitle_ktmyr_69 transaction-option-title">โอนผ่านธนาคาร</div></div></div><div><div className={`_transactionOptionTabHeader_ktmyr_1 transaction-option-tab-header ${this.state.withdrawtab === 'R' ? '_active_ktmyr_44' : ''}`} data-tutorialkey="R" onClick={() => this.notify('info', 'ยังไม่เปิดให้บริการ')} style={{ cursor: 'pointer' }}><div className="_transactionOptionImageContainer_ktmyr_30 transaction-option-image-container image-container"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 50" className="beta-option-R" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-option-R .st0{fill:#004A98;}\n\t .beta-option-R .st1{fill:url(#beta-option-R-SVGID_1_);}\n  " }} /><g className="beta-option-R"><g><g><g><g><path className="st0" d="M38.40976,11.95963c-0.33669-0.01158-0.65136-0.15518-0.88175-0.4039
				c-0.23158-0.24928-0.35134-0.57434-0.33732-0.91592c0.02447-0.68566,0.58542-1.22333,1.27708-1.22333l4.52141,0.23155
				l0.45974-4.64141c0.08003-0.64711,0.62446-1.13166,1.26732-1.13166c0.04762,0,0.09592,0.00307,0.14479,0.00857
				c0.69598,0.08616,1.19824,0.71982,1.12128,1.41273l-0.59169,5.81581c-0.04518,0.41309-0.29265,0.77726-0.66238,0.97705
				c-0.18759,0.10268-0.39289,0.15461-0.6092,0.15461L38.40976,11.95963z"></path><path className="st0" d="M9.00622,33.45571c0.32143,0.10024,0.58723,0.32205,0.74366,0.62265
				c0.15705,0.30191,0.18696,0.64711,0.08309,0.97279c-0.2053,0.65506-0.88845,1.02473-1.55508,0.84202l-4.19126-1.39863
				l-1.63057,4.25019c-0.2481,0.60312-0.90134,0.92636-1.52154,0.75648c-0.0458-0.01283-0.09167-0.0281-0.13747-0.04643
				c-0.6483-0.26768-0.96485-1.01128-0.70762-1.65901l2.06876-5.34826c0.15274-0.38619,0.48762-0.67214,0.89702-0.76687
				c0.20774-0.04949,0.41979-0.04524,0.62815,0.01158L9.00622,33.45571z"></path><path className="st0" d="M25.41269,49.5864c-6.56998,0-12.74401-2.55785-17.38611-7.20182
				c-2.42401-2.42401-4.27918-5.2501-5.51409-8.40063c-0.25235-0.64348,0.06539-1.36937,0.70881-1.62172
				c0.64467-0.25298,1.36937,0.06539,1.62172,0.70881c1.10782,2.82672,2.77478,5.36498,4.95376,7.54396
				c4.16918,4.17162,9.715,6.46855,15.6159,6.46855s11.44678-2.29693,15.61534-6.46855
				c4.17163-4.17038,6.46912-9.71625,6.46912-15.61653c0-0.6911,0.56033-1.25142,1.25143-1.25142
				c0.6911,0,1.25142,0.56033,1.25142,1.25142c0,6.56879-2.55785,12.74339-7.20176,17.38611
				C38.1567,47.02855,31.98268,49.5864,25.41269,49.5864z M2.45994,22.01107c-0.07452,0-0.14973-0.00669-0.22607-0.02015
				c-0.67952-0.12408-1.13047-0.77607-1.0064-1.45616c0.89396-4.89876,3.24526-9.36673,6.79974-12.92058
				c4.6421-4.64335,10.81613-7.20057,17.38548-7.20057s12.74338,2.55722,17.38554,7.20057
				c0.7864,0.7864,1.52455,1.62967,2.193,2.50654c0.41923,0.54931,0.31348,1.33452-0.23583,1.75368
				c-0.54994,0.41854-1.33515,0.31411-1.75368-0.23589c-0.60194-0.78821-1.2655-1.54714-1.97312-2.25476
				c-4.16975-4.17037-9.715-6.4673-15.6159-6.4673s-11.44616,2.29693-15.6159,6.4673
				c-3.19332,3.19276-5.30454,7.20426-6.10683,11.60077C3.5794,21.58821,3.05324,22.01107,2.45994,22.01107z"></path></g><g><path className="st0" d="M24.58546,31.57674c-2.22873-0.05544-3.9047-1.25328-3.9047-2.2849
				c0-0.51573,0.4611-1.28871,1.03161-1.28871c0.69907,0,1.25256,1.19639,2.87309,1.38111v-3.666
				c-1.67597-0.62661-3.57361-1.34561-3.57361-3.70289c0-2.33888,1.73213-3.35194,3.57361-3.59071v-0.51573
				c0-0.24015,0.27565-0.46183,0.62661-0.46183c0.31261,0,0.62668,0.22167,0.62668,0.46183v0.47739
				c1.19712,0.03696,3.14947,0.38653,3.14947,1.45648c0,0.42196-0.29486,1.27031-0.97618,1.27031
				c-0.51581,0-0.93929-0.58972-2.1733-0.68204v3.24252c1.63974,0.60813,3.48049,1.43655,3.48049,3.94166
				c0,2.26635-1.41734,3.57361-3.48049,3.90609v0.57124c0,0.2387-0.31407,0.46037-0.62668,0.46037
				c-0.3495,0-0.62661-0.22167-0.62661-0.46037V31.57674z M24.73322,23.26856v-2.78215
				c-0.92147,0.14783-1.4735,0.58972-1.4735,1.29024C23.25972,22.58652,23.8864,22.93754,24.73322,23.26856 M25.69092,26.1602
				v3.20556c0.81067-0.16624,1.38184-0.64508,1.38184-1.51046C27.07275,26.95159,26.48311,26.51115,25.69092,26.1602"></path><path className="st0" d="M25,39.91126c-3.98156,0-7.72609-1.55056-10.54384-4.36653
				c-2.81597-2.81597-4.36653-6.56049-4.36653-10.54384c0-3.98156,1.55056-7.72609,4.36653-10.54206
				c2.81775-2.81775,6.56406-4.3701,10.54384-4.3701s7.72609,1.55235,10.54384,4.3701
				c2.81597,2.81597,4.36653,6.56049,4.36653,10.54206c0,3.98335-1.55056,7.72787-4.36653,10.54384S28.98335,39.91126,25,39.91126z
				 M25,12.42528c-3.35956,0-6.51772,1.30818-8.89347,3.68393c-2.37397,2.37575-3.68215,5.53391-3.68215,8.89169
				c0,3.35956,1.30818,6.51772,3.68215,8.89347C18.48228,36.26833,21.64044,37.5765,25,37.5765s6.51772-1.30818,8.89347-3.68214
				c2.37397-2.37753,3.68214-5.53569,3.68214-8.89347s-1.30817-6.51594-3.68214-8.89169
				C31.51772,13.73346,28.35956,12.42528,25,12.42528z"></path></g></g><g><g><linearGradient id="beta-option-R-SVGID_1_" gradientUnits="userSpaceOnUse" x1="0" y1="25" x2="50" y2="25"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st1" d="M38.40976,11.95963c-0.33669-0.01158-0.65136-0.15518-0.88175-0.4039
				c-0.23158-0.24928-0.35134-0.57434-0.33732-0.91592c0.02447-0.68566,0.58542-1.22333,1.27708-1.22333l4.52141,0.23155
				l0.45974-4.64141c0.08003-0.64711,0.62446-1.13166,1.26732-1.13166c0.04762,0,0.09592,0.00307,0.14479,0.00857
				c0.69598,0.08616,1.19824,0.71982,1.12128,1.41273l-0.59169,5.81581c-0.04518,0.41309-0.29265,0.77726-0.66238,0.97705
				c-0.18759,0.10268-0.39289,0.15461-0.6092,0.15461L38.40976,11.95963z"></path><linearGradient id="beta-option-R-SVGID_00000145766734872638466630000015332761906815240116_" gradientUnits="userSpaceOnUse" x1="0" y1="25" x2="50" y2="25"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path d="M9.00622,33.45571
				c0.32143,0.10024,0.58723,0.32205,0.74366,0.62265c0.15705,0.30191,0.18696,0.64711,0.08309,0.97279
				c-0.2053,0.65506-0.88845,1.02473-1.55508,0.84202l-4.19126-1.39863l-1.63057,4.25019
				c-0.2481,0.60312-0.90134,0.92636-1.52154,0.75648c-0.0458-0.01283-0.09167-0.0281-0.13747-0.04643
				c-0.6483-0.26768-0.96485-1.01128-0.70762-1.65901l2.06876-5.34826c0.15274-0.38619,0.48762-0.67214,0.89702-0.76687
				c0.20774-0.04949,0.41979-0.04524,0.62815,0.01158L9.00622,33.45571z" style={{ fill: 'url(#beta-option-R-SVGID_00000145766734872638466630000015332761906815240116_)' }}></path><linearGradient id="beta-option-R-SVGID_00000168810606506455946410000002741048472538247579_" gradientUnits="userSpaceOnUse" x1="0" y1="25" x2="50" y2="25"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path d="M25.41269,49.5864
				c-6.56998,0-12.74401-2.55785-17.38611-7.20182c-2.42401-2.42401-4.27918-5.2501-5.51409-8.40063
				c-0.25235-0.64348,0.06539-1.36937,0.70881-1.62172c0.64467-0.25298,1.36937,0.06539,1.62172,0.70881
				c1.10782,2.82672,2.77478,5.36498,4.95376,7.54396c4.16918,4.17162,9.715,6.46855,15.6159,6.46855
				s11.44678-2.29693,15.61534-6.46855c4.17163-4.17038,6.46912-9.71625,6.46912-15.61653c0-0.6911,0.56033-1.25142,1.25143-1.25142
				c0.6911,0,1.25142,0.56033,1.25142,1.25142c0,6.56879-2.55785,12.74339-7.20176,17.38611
				C38.1567,47.02855,31.98268,49.5864,25.41269,49.5864z M2.45994,22.01107c-0.07452,0-0.14973-0.00669-0.22607-0.02015
				c-0.67952-0.12408-1.13047-0.77607-1.0064-1.45616c0.89396-4.89876,3.24526-9.36673,6.79974-12.92058
				c4.6421-4.64335,10.81613-7.20057,17.38548-7.20057s12.74338,2.55722,17.38554,7.20057
				c0.7864,0.7864,1.52455,1.62967,2.193,2.50654c0.41923,0.54931,0.31348,1.33452-0.23583,1.75368
				c-0.54994,0.41854-1.33515,0.31411-1.75368-0.23589c-0.60194-0.78821-1.2655-1.54714-1.97312-2.25476
				c-4.16975-4.17037-9.715-6.4673-15.6159-6.4673s-11.44616,2.29693-15.6159,6.4673
				c-3.19332,3.19276-5.30454,7.20426-6.10683,11.60077C3.5794,21.58821,3.05324,22.01107,2.45994,22.01107z" style={{ fill: 'url(#beta-option-R-SVGID_00000168810606506455946410000002741048472538247579_)' }}></path></g><g><linearGradient id="beta-option-R-SVGID_00000094601781506504198130000015771012974097973941_" gradientUnits="userSpaceOnUse" x1="0" y1="25" x2="50" y2="25"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path d="M24.58546,31.57674
				c-2.22873-0.05544-3.9047-1.25328-3.9047-2.2849c0-0.51573,0.4611-1.28871,1.03161-1.28871
				c0.69907,0,1.25256,1.19639,2.87309,1.38111v-3.666c-1.67597-0.62661-3.57361-1.34561-3.57361-3.70289
				c0-2.33888,1.73213-3.35194,3.57361-3.59071v-0.51573c0-0.24015,0.27565-0.46183,0.62661-0.46183
				c0.31261,0,0.62668,0.22167,0.62668,0.46183v0.47739c1.19712,0.03696,3.14947,0.38653,3.14947,1.45648
				c0,0.42196-0.29486,1.27031-0.97618,1.27031c-0.51581,0-0.93929-0.58972-2.1733-0.68204v3.24252
				c1.63974,0.60813,3.48049,1.43655,3.48049,3.94166c0,2.26635-1.41734,3.57361-3.48049,3.90609v0.57124
				c0,0.2387-0.31407,0.46037-0.62668,0.46037c-0.3495,0-0.62661-0.22167-0.62661-0.46037V31.57674z M24.73322,23.26856v-2.78215
				c-0.92147,0.14783-1.4735,0.58972-1.4735,1.29024C23.25972,22.58652,23.8864,22.93754,24.73322,23.26856 M25.69092,26.1602
				v3.20556c0.81067-0.16624,1.38184-0.64508,1.38184-1.51046C27.07275,26.95159,26.48311,26.51115,25.69092,26.1602" style={{ fill: 'url(#beta-option-R-SVGID_00000094601781506504198130000015771012974097973941_)' }}></path><linearGradient id="beta-option-R-SVGID_00000142156779381516876720000007669295289637552037_" gradientUnits="userSpaceOnUse" x1="0" y1="25" x2="50" y2="25"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path d="M25,39.91126
				c-3.98156,0-7.72609-1.55056-10.54384-4.36653c-2.81597-2.81597-4.36653-6.56049-4.36653-10.54384
				c0-3.98156,1.55056-7.72609,4.36653-10.54206c2.81775-2.81775,6.56406-4.3701,10.54384-4.3701s7.72609,1.55235,10.54384,4.3701
				c2.81597,2.81597,4.36653,6.56049,4.36653,10.54206c0,3.98335-1.55056,7.72787-4.36653,10.54384S28.98335,39.91126,25,39.91126z
				 M25,12.42528c-3.35956,0-6.51772,1.30818-8.89347,3.68393c-2.37397,2.37575-3.68215,5.53391-3.68215,8.89169
				c0,3.35956,1.30818,6.51772,3.68215,8.89347C18.48228,36.26833,21.64044,37.5765,25,37.5765s6.51772-1.30818,8.89347-3.68214
				c2.37397-2.37753,3.68214-5.53569,3.68214-8.89347s-1.30817-6.51594-3.68214-8.89169
				C31.51772,13.73346,28.35956,12.42528,25,12.42528z" style={{ fill: 'url(#beta-option-R-SVGID_00000142156779381516876720000007669295289637552037_)' }}></path></g></g></g></g></g></svg></div><div className="_transactionOptionTitle_ktmyr_69 transaction-option-title">E-Wallet</div></div></div><div><div className={`_transactionOptionTabHeader_ktmyr_1 transaction-option-tab-header ${this.state.withdrawtab === 'CT' ? '_active_ktmyr_44' : ''}`} data-tutorialkey="CT" onClick={() => this.notify('info', 'ยังไม่เปิดให้บริการ')} style={{ cursor: 'pointer' }}><div className="_transactionOptionImageContainer_ktmyr_30 transaction-option-image-container image-container"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 50" className="beta-option-CT" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-option-CT .st0{fill:url(#beta-option-CT-SVGID_1_);}\n\t .beta-option-CT .st1{fill:url(#beta-option-CT-SVGID_2_);}\n  " }} /><g className="beta-option-CT"><g><linearGradient id="beta-option-CT-SVGID_1_" gradientUnits="userSpaceOnUse" x1="0" y1="24.9989" x2="50" y2="24.9989"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st0" d="M25,50C11.2,50,0,38.8,0,25C0,11.2,11.2,0,25,0c13.8,0,25,11.2,25,25C50,38.8,38.8,50,25,50z M25,3.1
	C12.9,3.1,3.1,12.9,3.1,25c0,12.1,9.8,21.9,21.9,21.9c12.1,0,21.9-9.8,21.9-21.9C46.9,12.9,37.1,3.1,25,3.1z"></path><linearGradient id="beta-option-CT-SVGID_2_" gradientUnits="userSpaceOnUse" x1="11.8836" y1="24.9983" x2="36.8998" y2="24.9983"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st1" d="M24.5,41.3c-0.1,0-0.1,0-0.2,0l-2.7-0.7c-0.2,0-0.4-0.2-0.5-0.3c-0.1-0.2-0.1-0.4-0.1-0.6L22,36
	c-0.2-0.1-0.5-0.1-0.7-0.2l-0.9,3.7c0,0.2-0.2,0.4-0.3,0.5c-0.2,0.1-0.4,0.1-0.6,0.1l-2.7-0.7c-0.4-0.1-0.6-0.5-0.5-0.9l0.9-3.8l0,0
	c-0.4-0.1-0.8-0.2-1.2-0.3l-3.5-0.9c-0.2-0.1-0.4-0.2-0.5-0.4s-0.1-0.4,0-0.6l1.3-3.1c0.1-0.3,0.5-0.5,0.9-0.4
	c0.8,0.2,1.6,0.4,1.8,0.5c0,0,0.1,0,0.1,0c0.2,0,0.2,0,0.3-0.2l1.8-7c0-0.1,0-0.1,0.1-0.2c0.1-0.4,0.7-2.7,1.2-4.8
	c0-0.3-0.1-0.6-0.7-0.7c0,0-0.1,0-0.1,0c-0.2-0.1-1.1-0.3-1.8-0.4c-0.2,0-0.4-0.2-0.5-0.3s-0.1-0.4-0.1-0.6l0.7-2.9
	c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.1l3.7,0.9c0,0,0.1,0,0.1,0c0.3,0.1,0.6,0.1,0.9,0.2l0.9-3.7c0.1-0.4,0.5-0.6,0.9-0.5
	l2.7,0.7c0.4,0.1,0.6,0.5,0.5,0.9l-0.9,3.6c0.2,0.1,0.5,0.1,0.7,0.2l0.9-3.6c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.1l2.7,0.7
	c0.2,0,0.4,0.2,0.5,0.3c0.1,0.2,0.1,0.4,0.1,0.6l-0.9,3.8c2,0.7,5.9,2.6,5.3,6.8c-0.3,1.9-1.1,3.2-2.5,4c2,1.6,2.5,3.8,1.5,6.6
	c-1.7,4.8-5.7,4.9-9.7,4.3l-0.9,3.8C25.1,41.1,24.8,41.3,24.5,41.3z M22.7,39.3l1.2,0.3l0.9-3.7c0.1-0.4,0.5-0.6,0.9-0.6
	c5.1,1,7.5,0.1,8.7-3.2c0.9-2.7,0.3-4.4-2.1-5.6c-0.3-0.1-0.4-0.4-0.4-0.8c0-0.3,0.3-0.6,0.6-0.6c1.7-0.4,2.6-1.5,2.9-3.3
	c0,0,0,0,0,0c0.4-2.4-1.1-4.1-4.9-5.4c-0.4-0.1-0.6-0.5-0.5-0.9l0.9-3.7l-1.2-0.3l-0.9,3.6c-0.1,0.4-0.5,0.6-0.9,0.5
	c-0.7-0.2-1.4-0.3-2.1-0.5c-0.2,0-0.4-0.2-0.5-0.3s-0.1-0.4-0.1-0.6l0.9-3.6l-1.2-0.3L23.9,14c-0.1,0.4-0.5,0.6-0.9,0.5
	c-0.6-0.1-1.2-0.3-1.7-0.4c0,0-0.1,0-0.1,0l-2.9-0.7l-0.4,1.4c0.6,0.1,1,0.2,1.2,0.3c1.2,0.3,1.9,1.2,1.8,2.3c0,0,0,0.1,0,0.1
	c-0.8,3.4-1.1,4.6-1.3,5.1l-1.8,7c0,0,0,0.1,0,0.1c-0.4,0.9-1.2,1.3-2.1,1.1l0,0c-0.3,0-0.7-0.2-1.4-0.3l-0.7,1.7l2.7,0.7
	c0.4,0.1,0.8,0.2,1.2,0.3l0.8,0.2c0.4,0.1,0.6,0.5,0.5,0.9l-0.9,3.8l1.2,0.3l0.9-3.7c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.1
	c0.7,0.2,1.4,0.4,2.1,0.6c0.4,0.1,0.6,0.5,0.5,0.9L22.7,39.3z M26.6,33.3c-1.7,0-3.5-0.5-4.6-0.8l-0.5-0.1c-0.2,0-0.4-0.2-0.5-0.3
	c-0.1-0.2-0.1-0.4-0.1-0.6l1.5-5.9c0.1-0.4,0.5-0.6,0.9-0.5c0.2,0,0.4,0.1,0.6,0.1c1.9,0.4,5.2,1.2,6.4,3.1c0.5,0.7,0.6,1.6,0.4,2.5
	c-0.2,0.9-0.7,1.5-1.4,2C28.5,33.2,27.6,33.3,26.6,33.3z M22.5,31.1c1.6,0.4,4.5,1.1,5.9,0.3c0.4-0.2,0.6-0.6,0.7-1c0,0,0,0,0,0
	c0.1-0.5,0.1-0.9-0.2-1.3c-0.9-1.4-3.8-2.1-5.4-2.4L22.5,31.1z M27.8,24.5c-1.4,0-2.8-0.4-3.8-0.6l-0.4-0.1
	c-0.4-0.1-0.6-0.5-0.5-0.9l1.3-5.4c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.3,0.1,0.5,0.1c1.6,0.4,4.2,0.9,5.3,2.7
	c0.4,0.7,0.6,1.5,0.3,2.4l0,0c-0.2,0.8-0.7,1.5-1.4,1.9C29.5,24.4,28.6,24.5,27.8,24.5z M24.7,22.5c1.3,0.3,3.5,0.9,4.7,0.2
	c0.4-0.2,0.6-0.5,0.7-1c0.1-0.5,0.1-0.9-0.2-1.2c-0.7-1.1-2.9-1.7-4.2-1.9L24.7,22.5z M30.8,21.9L30.8,21.9L30.8,21.9z"></path></g></g></svg></div><div className="_transactionOptionTitle_ktmyr_69 transaction-option-title">คริปโต</div></div></div></div></div><div className="standard-transaction-container bank-transfer-container"><div className="standard-form-container transaction-form"><div className="withdrawal-container"><div className="standard-form-field acc-name-field add-spacing"><label className="standard-label standard-mandatory">ชื่อบัญชี</label><div className="standard-form-field-wrapper amount-section"><input className="standard-input" type="text" disabled value={this.state.accnumber && this.state.accnumber[0] ? (this.state.accnumber[0].fullname || this.state.accnumber[0].accname || this.state.accnumber[0].name || '') : ''} /></div></div><div className="standard-form-field" id="beta-withdraw-accountNo"><label className="standard-label standard-mandatory">เลขที่บัญชี.</label><div className="standard-form-field-wrapper amount-section"><input className="standard-input" type="text" disabled value={this.state.accnumber && this.state.accnumber[0] ? (this.state.accnumber[0].accnumber || '') : ''} placeholder="Exp : 1234567" /></div><div className="standard-error-validation"></div></div><div className="standard-form-field" id="transaction-form-amount"><label className="standard-label standard-mandatory">จำนวนเงิน</label><div className="standard-form-field-wrapper amount-section"><input className="standard-input" type="number" min="0" max={parseFloat(this.state.balance || 0)} placeholder={`ขั้นต่ำ: ${this.state.limit ? parseFloat(this.state.limit.min).toFixed(0) : '300'} / สูงสุด: ${this.state.limit ? parseFloat(this.state.limit.max).toLocaleString('en') : '300,000'}`} value={this.state.withdrawamount || ''} onChange={(e) => { const val = parseFloat(e.target.value); const bal = parseFloat(this.state.balance || 0); if (e.target.value === '' || val <= bal) { this.setState({ withdrawamount: e.target.value }); } else { this.setState({ withdrawamount: bal.toString() }); } }} /></div><div className="seamless-wallet-balance">ยอดคงเหลือที่สามารถถอนได้: <span>THB {parseFloat(this.state.balance || 0).toFixed(2)}</span></div><div className="standard-error-validation"></div></div></div><section className="transaction-button-section"><div className="standard-button-container "><button id="beta-withdraw-submit" className="standard-submit-button" onClick={this.submitwithdraw} disabled={!this.state.withdrawamount || parseFloat(this.state.withdrawamount) < 10} data-button-category="submit" type="submit"><span>ส่ง</span></button></div></section></div></div><section className="transaction-note-section"><div className="transaction-notes-container"><div className="notes-modal"><div className="note-info-detail"><div id="importance-notice" style={{ display: 'flex', alignItems: 'center', padding: '0.08rem 0.2rem 0.08rem 0.4rem', color: 'rgb(134, 151, 162)', cursor: 'pointer' }}><span className=" lazy-load-image-background opacity lazy-load-image-loaded" style={{ color: 'transparent', display: 'inline-block' }}><img loading="lazy" src="/build/web/igame-index-lobby-wm/img/important-notice.svg" alt="" style={{ width: '0.2rem', height: '0.2rem', margin: '0px 0.1rem 0px 0px' }} /></span><span>ข้อมูลสำคัญ</span><span className=" lazy-load-image-background opacity lazy-load-image-loaded" style={{ color: 'transparent', display: 'inline-block' }}><img loading="lazy" src="/build/web/igame-index-lobby-wm/img/dropdownArrow.svg" alt="" id="importance-dropdown-arrow" /></span></div><ul id="importance-notice-content" className="decimal" style={{ color: 'rgb(134, 151, 162)', fontSize: '0.14rem', padding: '0px 0.7rem', display: 'block' }}><li style={{ listStyle: 'disc', margin: '0px 0px 0.05rem' }}><span style={{ color: '#8697a2' }}>กรุณาติดต่อทาง แชทสดตลอด 24/7 ชั่วโมง หากธุรกรรมของท่านได้รับการดำเนินการมากกว่า 10 นาที</span></li><li style={{ listStyle: 'disc', margin: '0px 0px 0.05rem' }}><span style={{ color: '#8697a2' }}>ชื่อบัญชีธนาคารที่ถอนจะต้องตรงกับชื่อนามสกุลที่ลงทะเบียนสมาชิกไม่อนุญาตให้ถอนไปยังบัญชีธนาคารของบุคคลที่สาม</span></li><li style={{ listStyle: 'disc', margin: '0px 0px 0.05rem' }}><span style={{ color: '#8697a2' }}>ในบางเกมอาจใช้เวลาประมาณ 15 ถึง 30 นาทีในการตรวจสอบรายการเดิมพัน รบกวนรอสำหรับระยะเวลาดังกล่าวในการอัพเดตข้อมูล</span></li><li style={{ listStyle: 'disc', margin: '0px 0px 0.05rem', display: 'none' }}><span style={{ color: '#8697a2' }}>โปรดตรวจสอบให้แน่ใจว่ายอดเทิร์นโอเวอร์ของคุณครบตามงื่อนไขกำห­นด ก่อนทำรายการถอนทุกครั้ง</span></li><li style={{ listStyle: 'disc', margin: '0px 0px 0.05rem', display: 'none' }}><span style={{ color: '#8697a2' }}>หากมีข้อสงสัยหรือข้อมูลสอบถามเพิ่มเติมเกี่ยวกับธุรกรรมการถอน โปรดติดต่อ แชทสดตลอด 24/7 ชั่วโมง ขอบคุณค่ะ</span></li></ul><div id="read-more-button" style={{ display: 'flex', alignItems: 'center', padding: '0.08rem 0.4rem 0.2rem', color: 'rgb(0, 81, 214)', justifyContent: 'center', fontSize: '0.12rem', textDecorationLine: 'underline', cursor: 'pointer' }}><span>อ่านเพิ่มเติม </span></div></div></div></div></section><div className="recent-transaction"><div className="_recentTransactionContainer_yt0gb_1 recent-transaction-container"><div className="_dropdownTitle_uxqg3_1 recent-transaction-title">ธุรกรรมล่าสุดของฉัน<div id="dropdown-arrow" className="_dropdownArrow_uxqg3_21 "><svg className="hAror96dp3eww1cc5ooafn7dr4" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="hAror96dp3eww1cc5ooafn7dr4_dropdown"><path id="hAror96dp3eww1cc5ooafn7dr4_Vector" d="M14.5444 7.10467C14.5444 7.38307 14.4409 7.66252 14.235 7.87536L9.56017 12.7069C9.30038 12.9766 8.95498 13.1228 8.5885 13.1228C8.22093 13.1228 7.87662 12.9744 7.6178 12.7058L2.94304 7.87536C2.53005 7.44963 2.53005 6.75865 2.94304 6.33181C3.35604 5.90502 4.02568 5.90502 4.43759 6.33181L8.5885 10.6219L12.7394 6.33181C13.1523 5.90502 13.821 5.90502 14.235 6.33181C14.4409 6.5447 14.5444 6.82415 14.5444 7.10467Z" fill="#61757E"></path></g></svg></div></div><div id="recent-transaction-table-container" className="_recentTransactionTableContainer_yt0gb_5 "><table className="_recentTransactionTable_yt0gb_5 recent-transaction-table"><thead><tr className="_recentTransactionRow_yt0gb_14 'recent-transaction-row"><th>วันที่โอนเงิน</th><th>จำนวนเงิน</th><th>วิธี</th><th>สถานะ</th></tr></thead><tbody>{this.state.historylist.length === 0 ? (<tr className="_emptyRecord_yt0gb_39 empty-record"><td colSpan={4}>ยังไม่มีรายการ</td></tr>) : this.state.historylist.slice(0, 5).map((item, i) => (<tr key={i} className="_recentTransactionRow_yt0gb_14 recent-transaction-row"><td>{moment(item.createdate).format('DD/MM/YY HH:mm')}</td><td className={item.type === 'DE' ? 'text-success' : 'text-danger'}>{item.amount}</td><td>{item.type === 'BN' ? 'โบนัส' : item.type === 'DE' ? 'ฝากเงิน' : 'ถอนเงิน'}</td><td>{item.status === '1' ? 'สำเร็จ' : item.status === '2' ? 'กำลังดำเนินการ' : item.status === '0' ? 'รอดำเนินการ' : item.status === '4' ? 'ยกเลิก' : 'ไม่สำเร็จ'}</td></tr>))}</tbody></table><div className="_viewMore_yt0gb_43 view-more"><span>อ่านเพิ่มเติม </span></div></div></div></div></div></div></section>
        );
      case 'transfer':
        return (
          <section className="st-detail-container transfer st-detail-deposit-container">
            <div className="st-tab with-notice">
              <div className="transfer-form-and-note-wrapper">
                <div className="standard-transaction-container standard-form-container transfer-form">
                  <div className="reTrigger_step_button" id="needHelpBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 0 36 36" version="1.1">
                      <g id="surface1">
                        <path d="M 18.191406 0.164062 C 8.378906 0.164062 0.378906 7.667969 0.378906 16.90625 C 0.378906 19.964844 1.257812 22.949219 2.933594 25.542969 L 3.054688 25.75 L -0.00390625 34.285156 L 9.378906 31.460938 L 9.578125 31.5625 C 12.191406 32.933594 15.175781 33.644531 18.191406 33.644531 C 28.019531 33.644531 36 26.140625 36 16.90625 C 36 7.667969 28.019531 0.164062 18.191406 0.164062 Z M 17.976562 26.113281 C 17.207031 26.113281 16.589844 25.53125 16.589844 24.800781 C 16.589844 24.074219 17.207031 23.488281 17.976562 23.488281 C 18.742188 23.488281 19.359375 24.074219 19.359375 24.800781 C 19.359375 25.53125 18.742188 26.113281 17.976562 26.113281 Z M 23.789062 13.714844 C 23.480469 14.585938 22.773438 15.140625 21.3125 16.699219 C 20.160156 17.925781 19.144531 18.871094 19.066406 20.460938 C 19.035156 21.160156 18.621094 21.65625 17.789062 21.582031 C 17.050781 21.523438 16.730469 20.851562 16.730469 20.226562 C 16.730469 18.070312 17.730469 16.976562 18.789062 15.855469 C 20.175781 14.398438 21.3125 13.65625 21.359375 12.5625 C 21.40625 11.324219 20.449219 10.203125 18.390625 10.085938 C 16.359375 9.984375 14.636719 11.238281 14.390625 13.101562 C 14.300781 13.726562 13.808594 14.195312 13.128906 14.136719 C 12.46875 14.078125 11.945312 13.523438 11.976562 12.882812 C 12.285156 9.75 15.113281 7.726562 18.480469 7.898438 C 22.171875 8.074219 24.757812 10.914062 23.789062 13.699219 Z M 23.789062 13.714844 " />
                      </g>
                    </svg>
                    <span>รหัสผ่านไม่สามารถเหมือนกับชื่อผู้ใช้ของคุณได้</span>
                  </div>
                  <div className="standard-form-field from-to-container">
                    <div className="standard-form-field-container">
                      <p className="standard-label standard-mandatory">จาก</p>
                      <div className="standard-form-field" id="beta-transfer-from">
                        <div id="dropdownBtn" className="standard-select">กระเป๋าเงิน<span>(0.00)</span></div>
                        <span className="standard-select-arrow "></span>
                      </div>
                    </div>
                    <div className="standard-form-field-container">
                      <p className="standard-label standard-mandatory">ถึง</p>
                      <div className="standard-form-field" id="beta-transfer-to">
                        <div id="dropdownBtn" className="standard-select">กระเป๋าเงิน<span>(0.00)</span></div>
                        <span className="standard-select-arrow "></span>
                      </div>
                    </div>
                  </div>
                  <div className="standard-form-field amount-promo-container">
                    <div className="standard-form-field-container" id="beta-transfer-amount">
                      <div className="_horizontal-standard-form-field_uj5nz_92">
                        <label className="_fieldLabel_uj5nz_17 standard-mandatory"> จำนวนเงิน</label>
                        <input type="text" name="currentPassword" className="false standard-input _correct_28y2b_25 correct" placeholder="จำนวน" defaultValue="0.00" />
                      </div>
                    </div>
                  </div>
                  <div className="standard-form-field promo-code-container">
                    <div className="standard-form-field-container" id="beta-transfer-specialCode">
                      <div className="_horizontal-standard-form-field_uj5nz_92">
                        <label className="_fieldLabel_uj5nz_17 "> โค้ดพิเศษ</label>
                        <input type="text" className="false standard-input  " placeholder="โค้ดพิเศษ" defaultValue="" />
                      </div>
                    </div>
                    <div className="standard-form-field-container" id="beta-transfer-promoCode">
                      <p className="standard-label">กดเพื่อรับโปรโมชั่น</p>
                      <div className="standard-form-field">
                        <div id="dropdownBtn" className="standard-select   ">
                          <span className="">กดเพื่อรับโปรโมชั่น</span>
                          <span className="standard-select-arrow "></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <section className="transaction-button-section">
                    <div className="standard-button-container ">
                      <button id="transfer-submit-button" className="standard-submit-button" data-button-category="submit" type="submit" disabled>
                        <span>ส่ง</span>
                      </button>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>
        );
      case 'withdrawDetail': {
        const wdTab = this.state.withdrawDetailTab || 'bank';
        return (
          <section className="st-detail-container null ">
            <div className="st-tab  ">
              <div className="standard-tab-container bank-detail-tab-container">
                <nav>
                  <div className="standard-tab">
                    <div
                      className={`_tabHeaderTitle_1ivtf_1 tab-header-title${wdTab === 'bank' ? ' _active_1ivtf_22' : ''}`}
                      onClick={() => this.setState({ withdrawDetailTab: 'bank' })}
                      style={{ cursor: 'pointer' }}
                    >
                      <span>ธนาคารสำหรับการถอน</span>
                    </div>
                    <div
                      className="_tabHeaderTitle_1ivtf_1 tab-header-title"
                      onClick={() => this.notify('info', 'ยังไม่เปิดให้บริการ')}
                      style={{ cursor: 'pointer' }}
                    >
                      <span>ที่อยู่คริปโต</span>
                    </div>
                    <div
                      className="_tabHeaderTitle_1ivtf_1 tab-header-title"
                      onClick={() => this.notify('info', 'ยังไม่เปิดให้บริการ')}
                      style={{ cursor: 'pointer' }}
                    >
                      <span>รายละเอียด E-Wallet</span>
                    </div>
                  </div>
                </nav>
              </div>

              {/* ===== แท็บ ธนาคาร ===== */}
              {wdTab === 'bank' && (
                <div className="standard-setting-table-container bank-info-container standard-settings-container">
                  <table>
                    <thead className="st-bwd-table">
                      <tr>
                        <th className="col-bank">ธนาคาร</th>
                        <th className="col-acc-name">ชื่อบัญชี</th>
                        <th className="col-acc-status">เลขที่บัญชี</th>
                        <th className="col-delete"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.accnumber && this.state.accnumber.length > 0 ? (
                        this.state.accnumber.map((acc, idx) => (
                          <tr key={idx} className="bank-row">
                            <td className="col-bank">
                              <div className="bank-cell">
                                <img
                                  loading="lazy"
                                  src={acc.img_path || `https://baryon.million-edge.online/cms/public/payment/icons/Bank/THB/${acc.acro || 'GSB'}.png`}
                                  alt={acc.fullname_th || ''}
                                  style={{ width: 24, height: 24, marginRight: 6 }}
                                />
                                <span>{acc.fullname_th || acc.acro || '-'}</span>
                              </div>
                            </td>
                            <td className="col-acc-name">{acc.account_name || [this.state.fname || this.state.firstname, this.state.lastname].filter(v => v && v !== 'undefined' && v !== 'null').join(' ') || '-'}</td>
                            <td className="col-acc-status">{acc.accno || acc.accnumber || '-'}</td>
                            <td className="col-delete"></td>
                          </tr>
                        ))
                      ) : (
                        <tr className="no-content-container no-bank-container">
                          <td colSpan="5">ยังไม่มีบัญชี!</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}


            </div>

            {/* ===== CSS ลอกจาก bk8 bankdetails (scoped เฉพาะหน้านี้ ไม่กระทบส่วนอื่น) ===== */}
            <style>{`
              .bank-detail-tab-container { margin-top:12px; margin-bottom:16px; }
              .bank-detail-tab-container nav .standard-tab {
                display:inline-flex; flex-direction:row; gap:6px; border:none;
                padding:6px; background:#eef1f5; border-radius:14px;
              }
              .bank-detail-tab-container ._tabHeaderTitle_1ivtf_1 {
                display:flex; align-items:center; justify-content:center;
                padding:10px 22px; border-radius:10px;
                background:transparent; color:#6b7785;
                font-size:13px; font-weight:600; cursor:pointer; white-space:nowrap; line-height:1.2;
                border:none; transition:background .18s, color .18s, box-shadow .18s;
              }
              .bank-detail-tab-container ._tabHeaderTitle_1ivtf_1:hover { color:#0a5ebd; }
              .bank-detail-tab-container ._tabHeaderTitle_1ivtf_1._active_1ivtf_22 {
                background:linear-gradient(135deg,#0a5ebd,#04a9c2); color:#fff;
                box-shadow:0 4px 12px rgba(9,94,189,.30);
              }
              .bank-info-container { background:#fff; }
              .bank-info-container table { width:100%; border-collapse:collapse; }
              .bank-info-container .st-bwd-table th {
                background:#f7f7f7; color:#0f161f; font-size:13px; font-weight:400;
                text-align:left; padding:13px 15px;
              }
              .bank-info-container tbody td { color:#8697a2; font-size:13px; text-align:center; padding:18px 8px; border:none; }
              .bank-info-container tbody td.col-bank { text-align:left; }
              .bank-info-container .bank-cell { display:flex; align-items:center; gap:6px; }
              .bank-info-container .no-content-container td { text-align:center; color:#8697a2; }
              .six-digit-pin-not-set-up-notice {
                display:flex; align-items:center; gap:8px;
                padding:10px 14px; margin:8px 0 0; border-radius:8px;
                background:#fff4f4; color:#e23b3b; font-size:12.5px; line-height:1.4;
              }
              .six-digit-pin-warning-text { color:#e23b3b; }
              .six-digit-pin-redirect { color:#0071e3; cursor:pointer; text-decoration:underline; margin-left:3px; }
              .select-bank-form { padding:24px 0 8px; }
              .select-bank-form .bank-form-wrapper { display:flex; flex-direction:column; max-width:340px; }
              .select-bank-form .standard-form-field-container,
              .select-bank-form ._standardFormField_uj5nz_2 { display:block; margin:0 0 12px; }
              .select-bank-form ._transactionTitle_hzg77_1,
              .select-bank-form ._fieldLabel_uj5nz_17 {
                display:block; color:#8697a2; font-size:13px; font-weight:400; margin:0 0 7px;
              }
              .select-bank-form .standard-mandatory::after { content:" *"; color:#e23b3b; }
              .select-bank-form .standard-select {
                display:flex; align-items:center; justify-content:space-between;
                height:38px; padding:0 10px; background:#fff; color:#8697a2;
                border:1px solid #dbe0e4; border-radius:6px; font-size:13px; box-sizing:border-box;
              }
              .select-bank-form .standard-select-arrow {
                width:0 !important; height:0 !important; background:none !important; transform:none !important;
                border-left:5px solid transparent !important; border-right:5px solid transparent !important;
                border-top:6px solid #8697a2 !important; border-bottom:none !important;
                margin-left:8px; display:inline-block; flex:0 0 auto;
              }
              .select-bank-form .standard-input {
                width:100%; height:38px; padding:0 10px; background:#fff; color:#0f161f;
                border:1px solid #dbe0e4; border-radius:6px; font-size:13px; box-sizing:border-box;
              }
              .select-bank-form .standard-input::placeholder { color:#9aa5ad; }
              .select-bank-form .transaction-button-section { margin:8px 0 0; }
              .select-bank-form .standard-button-container { display:flex; }
              .select-bank-form .standard-submit-button {
                width:auto !important; min-width:160px; height:40px; padding:0 26px;
                background:linear-gradient(to right,#095EBD,#04A9C2) !important; color:#fff !important;
                border:none !important; border-radius:8px !important; font-size:14px; font-weight:700; cursor:pointer;
              }
              .select-bank-form .standard-submit-button:disabled { opacity:.6; cursor:not-allowed; }
              .select-bank-form .bank-select-option:hover { background:#f4f7fa; }
              @media (max-width:760px){
                .bank-detail-tab-container { margin-top:10px; }
                .bank-detail-tab-container nav .standard-tab { gap:5px; padding:5px; display:flex; width:100%; }
                .bank-detail-tab-container ._tabHeaderTitle_1ivtf_1 {
                  flex:1; text-align:center; white-space:normal; line-height:1.25;
                  padding:12px 6px; font-size:14px; border-radius:10px;
                }
                .bank-info-container .st-bwd-table th { font-size:15px; padding:14px 12px; }
                .bank-info-container tbody td { font-size:14px; padding:18px 8px; }
                .select-bank-form { padding:20px 0 8px; }
                .select-bank-form .bank-form-wrapper { max-width:none; }
                .select-bank-form .standard-form-field-container,
                .select-bank-form ._standardFormField_uj5nz_2 { margin:0 0 20px; }
                .select-bank-form ._transactionTitle_hzg77_1,
                .select-bank-form ._fieldLabel_uj5nz_17 { font-size:17px; margin:0 0 12px; }
                .select-bank-form .standard-select { height:54px; font-size:17px; padding:0 16px; border-radius:10px; }
                .select-bank-form .standard-input { height:54px; font-size:17px; padding:0 16px; border-radius:10px; }
                .select-bank-form .standard-select-arrow {
                  border-left-width:6px !important; border-right-width:6px !important; border-top-width:8px !important;
                }
                .select-bank-form .bank-select-option { padding:14px 14px !important; font-size:16px; }
                .select-bank-form .bank-select-option span { font-size:16px !important; }
                .select-bank-form .standard-submit-button { width:100% !important; height:56px; font-size:18px; border-radius:12px; }
              }
            `}</style>
          </section>
        );
      }

      // ===== รางวัล =====
      case 'cashback': {
        const cashbackAmt = parseFloat(this.state.tblprofile && this.state.tblprofile.AffiliateCash ? this.state.tblprofile.AffiliateCash : 0);
        const hasCashback = cashbackAmt > 0;
        return (
          <section className="st-detail-container null ">
            <div className="st-tab  ">
              <div className="standard-tab-container instant-rebate-tab-container">
                <nav>
                  <div className="standard-tab">
                    <div className="_tabHeaderTitle_1ivtf_1 tab-header-title _active_1ivtf_22" id="tab_header_active">
                      <span>เงินคืน</span>
                    </div>
                  </div>
                </nav>
              </div>
              <div className="instant-rebate-tab standard-settings-container">
                <div className="top-container">
                  <div className="top-content">
                    <div className="pending-claim-info">
                      <div className="pending-claim">ยอดเสียที่รอรับคืน</div>
                      <div className="amount">THB {cashbackAmt.toFixed(2)}</div>
                    </div>
                    <div className="pending-claim-button">
                      <section className="transaction-button-section">
                        <div className="standard-button-container ">
                          <button
                            id=""
                            className="standard-submit-button"
                            disabled={!hasCashback}
                            data-button-category="submit"
                            type="button"
                            onClick={this.opencliamcashout}
                            style={{ cursor: hasCashback ? 'pointer' : 'not-allowed', opacity: hasCashback ? 1 : 0.5 }}
                          >
                            <span>รับเงิน</span>
                          </button>
                        </div>
                      </section>
                      <div className="claim-status"></div>
                      <div className="last-update" style={{ cursor: 'pointer' }} onClick={this.reloadBalance}>🔄 อัปเดตยอด</div>
                    </div>
                  </div>
                </div>
                <div className="divider"></div>
                <div className="bottom-container"></div>
              </div>
            </div>
          </section>
        );
      }
      case 'dailyTask':
        return (
          <section className="st-detail-container st-detail-deposit-container">
            <div className="st-tab with-notice">
              <div style={{ padding: '2rem', textAlign: 'center', color: '#8697a2' }}>
                {/* TODO: ใส่เนื้อหาหน้างานประจำวันที่นี่ */}
                <h3>งานประจำวัน</h3>
                <p>ยังไม่มีเนื้อหา — รอนำข้อมูลมาใส่</p>
              </div>
            </div>
          </section>
        );
      // ===== แนะนำเพื่อน =====
      case 'referral': {
        const isMobile = window.innerWidth <= 760;
        const linkaff = this.state.linkaff;
        const tblprofile = this.state.tblprofile;
        const refCode = linkaff ? linkaff.split('reg=')[1] : '-';
        const affiliateCash = parseFloat(
          tblprofile && tblprofile.AffiliateCash
            ? tblprofile.AffiliateCash
            : 0
        );

        const hasAffiliateCash = affiliateCash > 0;
        const friendList = this.state.useradvice || [];

        return (
          <section className={`st-detail-container referral pk-referral ${isMobile ? 'pk-referral-mobile' : 'pk-referral-desktop'}`}>
            <div className="st-tab">
              <div className="referral-container">
                <div className="standard-tab-container referral-tab-container">
                  <div className="standard-tab">
                    <div
                      className="_tabHeaderTitle_1ivtf_1 tab-header-title _active_1ivtf_22"
                      id="tab_header_active"
                    >
                      <span>ผู้แนะนำ</span>
                    </div>

                    <div className="_tabHeaderTitle_1ivtf_1 tab-header-title">
                      <span>โบนัส</span>
                    </div>
                  </div>
                </div>

                {/* รับรางวัล + ยอดคงเหลือ */}
                <div
                  className="ref-status-box"
                  style={{ padding: '12px 16px', marginBottom: 8 }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      gap: 8
                    }}
                  >
                    <div>
                      <label
                        className="standard-label"
                        style={{ marginBottom: 4 }}
                      >
                        รางวัลที่รอรับ
                      </label>

                      <div style={{ fontSize: 20, fontWeight: 600 }}>
                        THB {affiliateCash.toFixed(2)}
                      </div>
                    </div>

                    <button
                      className="standard-submit-button"
                      type="button"
                      disabled={!hasAffiliateCash}
                      onClick={this.opencliaminvite}
                      style={{
                        cursor: hasAffiliateCash ? 'pointer' : 'not-allowed',
                        opacity: hasAffiliateCash ? 1 : 0.5,
                        minWidth: 120
                      }}
                    >
                      รับรางวัล
                    </button>
                  </div>
                </div>

                <div className="referral-content myReferral standard-settings-container">

                  {/* สถานะ */}
                  <div className="ref-status-box">
                    <label className="standard-label">
                      สถานะการอ้างอิงของคุณ
                    </label>

                    <div className="ref-status">
                      <div className="invi-status">
                        <span className="text">เพื่อนที่แนะนำทั้งหมด</span>
                        <span className="value">{friendList.length}</span>
                      </div>

                      <div className="invi-status">
                        <span className="text">แนะนำเพื่อนสำเร็จ</span>

                        <span className="value">
                          {
                            friendList.filter(
                              f => f.status === 1 || f.Status === 1
                            ).length
                          }
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* รหัส + ลิงก์ */}
                  <div className="ref-code-link-container">

                    <div className="ref-code-box">
                      <label className="standard-label">รหัสแนะนำ</label>

                      <div className="standard-form-field-wrapper">
                        <input
                          className="standard-input"
                          type="text"
                          readOnly
                          value={refCode}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            navigator.clipboard.writeText(refCode);

                            Swal.fire({
                              toast: true,
                              position: 'top-end',
                              icon: 'success',
                              title: 'คัดลอกรหัสแล้ว',
                              showConfirmButton: false,
                              timer: 1500
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div className="ref-link-box">
                      <label className="standard-label">ลิงก์แนะนำ</label>

                      <div className="standard-form-field-wrapper">
                        <input
                          className="standard-input"
                          type="text"
                          readOnly
                          value={linkaff || ''}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            navigator.clipboard.writeText(linkaff || '');

                            Swal.fire({
                              toast: true,
                              position: 'top-end',
                              icon: 'success',
                              title: 'คัดลอกลิงก์แล้ว',
                              showConfirmButton: false,
                              timer: 1500
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* รายการชวนเพื่อน */}
                  <div style={{ marginTop: 16 }}>
                    <label className="standard-label">
                      รายการชวนเพื่อน
                    </label>

                    {friendList.length === 0 ? (
                      <div
                        style={{
                          textAlign: 'center',
                          padding: '24px 0',
                          color: '#8697a2'
                        }}
                      >
                        ยังไม่มีรายการ
                      </div>
                    ) : (
                      <div style={{ overflowX: 'auto' }}>
                        <table
                          style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            fontSize: 13
                          }}
                        >
                          <thead>
                            <tr style={{ background: 'rgba(0,0,0,0.15)' }}>
                              <th style={{ padding: '8px 12px', textAlign: 'left' }}>
                                ยูสเซอร์
                              </th>

                              <th style={{ padding: '8px 12px', textAlign: 'left' }}>
                                วันที่สมัคร
                              </th>

                              <th style={{ padding: '8px 12px', textAlign: 'center' }}>
                                สถานะ
                              </th>

                              <th style={{ padding: '8px 12px', textAlign: 'right' }}>
                                โบนัส (THB)
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {friendList.map((f, idx) => (
                              <tr
                                key={idx}
                                style={{
                                  borderBottom:
                                    '1px solid rgba(255,255,255,0.07)'
                                }}
                              >
                                <td style={{ padding: '8px 12px' }}>
                                  {f.playerid || f.username || '-'}
                                </td>

                                <td style={{ padding: '8px 12px' }}>
                                  {f.createdAt
                                    ? moment(f.createdAt).format('DD/MM/YY')
                                    : '-'}
                                </td>

                                <td
                                  style={{
                                    padding: '8px 12px',
                                    textAlign: 'center'
                                  }}
                                >
                                  <span
                                    style={{
                                      color:
                                        (f.status === 1 || f.Status === 1)
                                          ? '#5AE02F'
                                          : '#f0a500'
                                    }}
                                  >
                                    {(f.status === 1 || f.Status === 1)
                                      ? 'สำเร็จ'
                                      : 'รอฝาก'}
                                  </span>
                                </td>

                                <td
                                  style={{
                                    padding: '8px 12px',
                                    textAlign: 'right'
                                  }}
                                >
                                  {parseFloat(
                                    f.bonus || f.Bonus || 0
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>

                  {/* bottom */}
                  <div className="bottom-content">
                    <div className="content-left">

                      <p className="share-title">
                        เลือกแพ็คเกจโบนัสและเริ่มแชร์ทันที
                      </p>

                      <div className="referOption-container">
                        <div className="referOption">
                          <p className="option-remark">
                            โบนัสเครดิตฟรี 50 บาท
                          </p>

                          <p className="option-turnover">
                            ฝาก 300 บาท
                          </p>

                          <p className="option-deposit">
                            ก่อนทำการถอน
                          </p>
                        </div>
                      </div>

                      <div className="ref-share-container">
                        <button
                          className="standard-submit-btn"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            const link = this.state.linkaff || '';
                            if (!link) {
                              this.notify('warning', 'ยังไม่พบลิงก์แนะนำ กรุณารีเฟรช');
                              return;
                            }
                            if (navigator.clipboard && navigator.clipboard.writeText) {
                              navigator.clipboard.writeText(link).then(() => {
                                this.notify('success', 'คัดลอกลิงก์แนะนำเพื่อนแล้ว!');
                              }).catch(() => {
                                this.notify('info', link);
                              });
                            } else {
                              // fallback สำหรับ iOS เก่า
                              const el = document.createElement('textarea');
                              el.value = link;
                              document.body.appendChild(el);
                              el.select();
                              document.execCommand('copy');
                              document.body.removeChild(el);
                              this.notify('success', 'คัดลอกลิงก์แนะนำเพื่อนแล้ว!');
                            }
                          }}
                        >
                          📋 แชร์ลิงก์แนะนำเพื่อน
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              {/* notice */}
              <div className="_noticeContainer_1rhrf_1 notice-container">

                <div className="_dropdownTitle_uxqg3_1 recent-transaction-title">
                  เงื่อนไขและข้อกำหนด

                  <div
                    id="dropdown-arrow"
                    className="_dropdownArrow_uxqg3_21"
                  >
                    ▼
                  </div>
                </div>

                <div className="_noticeContentContainer_1rhrf_9">
                  <ul className="_noticeContent_1rhrf_9">
                    <li>
                      เพื่อนลงทะเบียนผ่านลิงค์แนะนำของคุณ
                      รับเดิมพันฟรี 50 ในคอลัมน์โปรโมชั่น
                    </li>

                    <li>
                      เพื่อนที่ลงทะเบียน ต้องทำการฝากเงิน THB 300
                      จึงจะได้รับโบนัสแนะนำ
                    </li>

                    <li>
                      เพื่อนของคุณและคุณจะได้รับโบนัสแนะนำ THB 50
                      เมื่อทำตามข้อกำหนดสำเร็จ
                    </li>

                    <li>
                      ต้องทำการฝาก THB 300 บาท ภายใน 30 วัน
                      หลังจากที่เพื่อนของคุณลงทะเบียนสำเร็จ
                      มิฉะนั้นจะถูกตัดสิทธิ์รับโบนัสนี้
                    </li>
                  </ul>

                  <div className="_readMoreButton_1rhrf_56 read-more-button" />
                </div>

              </div>
            </div>

            {/* ===== CSS หน้าแนะนำเพื่อน (ลอกสไตล์ bk8) — scoped เฉพาะหน้านี้ แยก mobile/desktop ===== */}
            <style>{`
              .pk-referral { color:#1a1a1a; }
              .pk-referral .referral-container { margin-top:12px; }
              /* แท็บ segmented (เข้าธีมเดียวกับหน้า bankdetails) */
              .pk-referral .referral-tab-container .standard-tab {
                display:inline-flex; gap:6px; padding:6px; background:#eef1f5; border-radius:14px; border:none;
              }
              .pk-referral .referral-tab-container ._tabHeaderTitle_1ivtf_1 {
                display:flex; align-items:center; justify-content:center; padding:10px 22px; border-radius:10px;
                background:transparent; color:#6b7785; font-size:13px; font-weight:600; cursor:pointer; white-space:nowrap;
                border:none; transition:.18s;
              }
              .pk-referral .referral-tab-container ._tabHeaderTitle_1ivtf_1:hover { color:#0a5ebd; }
              .pk-referral .referral-tab-container ._tabHeaderTitle_1ivtf_1._active_1ivtf_22 {
                background:linear-gradient(135deg,#0a5ebd,#04a9c2); color:#fff; box-shadow:0 4px 12px rgba(9,94,189,.30);
              }
              /* เนื้อหา */
              .pk-referral .referral-content { background:#fff; padding:22px !important; display:flex; flex-direction:column; margin-top:14px; border-radius:12px; box-sizing:border-box; }
              .pk-referral .standard-label { display:block; color:#6b7785; font-size:13px; font-weight:600; margin:0 0 10px; }
              /* รางวัลที่รอรับ (ฟีเจอร์ระบบเรา) */
              .pk-referral .ref-status-box { margin-bottom:18px; }
              .pk-referral .ref-status { display:flex !important; flex-direction:column !important; gap:8px !important; width:100% !important; }
              .pk-referral .invi-status {
                display:flex !important; flex-direction:row !important; align-items:center !important; justify-content:space-between !important;
                width:100% !important; padding:12px 14px !important; background:#f7f9fb !important;
                border:1px solid #eef1f4 !important; border-radius:10px !important; position:static !important; margin:0 !important;
              }
              .pk-referral .invi-status .text {
                color:#6b7785 !important; font-size:13px !important; font-weight:400 !important; text-align:left !important;
                width:auto !important; max-width:none !important; white-space:normal !important; background:none !important;
                border:none !important; margin:0 !important; padding:0 !important; position:static !important; line-height:1.3 !important;
              }
              .pk-referral .invi-status .value {
                color:#0a5ebd !important; font-size:16px !important; font-weight:700 !important; text-align:right !important;
                width:auto !important; height:auto !important; min-width:0 !important; flex:0 0 auto !important;
                background:none !important; border:none !important; border-radius:0 !important; box-shadow:none !important;
                margin:0 !important; padding:0 !important; position:static !important; line-height:1.3 !important; display:inline-block !important;
              }
              /* รหัส + ลิงก์ */
              .pk-referral .ref-code-link-container { display:flex !important; flex-direction:row; gap:14px; margin-top:18px; width:100% !important; }
              .pk-referral .ref-code-box, .pk-referral .ref-link-box { flex:1 1 auto !important; width:100% !important; min-width:0 !important; }
              .pk-referral .standard-form-field-wrapper { position:relative; width:100% !important; }
              .pk-referral .ref-code-link-container .standard-input {
                width:100% !important; height:44px !important; padding:0 14px !important; background:#f7f7f7 !important; color:#0f161f !important;
                border:1px solid #e7eaee !important; border-radius:8px !important; font-size:14px !important; box-sizing:border-box !important; cursor:pointer;
                min-width:0 !important; max-width:none !important;
              }
              /* แพ็คเกจโบนัส + ปุ่มเชิญ */
              .pk-referral .bottom-content { display:flex; flex-direction:row; margin-top:24px; }
              .pk-referral .content-left { width:100%; max-width:360px; }
              .pk-referral .share-title { color:#6b7785; font-size:13px; margin:0 0 10px; }
              .pk-referral .referOption-container { margin-top:4px; }
              .pk-referral .referOption {
                display:flex; flex-direction:column; padding:14px 16px; background:#fff7ee;
                border:1px solid #ff8a00; border-radius:10px; text-align:left;
              }
              .pk-referral .option-remark { color:#0071e3; font-size:15px; font-weight:700; margin:0 0 8px; }
              .pk-referral .option-turnover { color:#6b7785; font-size:13px; margin:0; }
              .pk-referral .option-deposit { color:#6b7785; font-size:13px; margin:4px 0 0; }
              .pk-referral .ref-share-container { margin-top:20px; }
              .pk-referral .standard-submit-btn {
                width:auto !important; min-width:220px !important; height:46px !important; padding:0 28px !important;
                background:linear-gradient(135deg,#0a5ebd,#04a9c2) !important; color:#fff !important; border:none !important; border-radius:10px !important;
                font-size:15px !important; font-weight:700 !important; cursor:pointer; display:inline-flex !important;
                align-items:center !important; justify-content:center !important; gap:6px !important; line-height:1 !important;
              }
              .pk-referral .standard-submit-btn:hover { filter:brightness(1.05); }
              /* รางวัลรอรับ ปุ่มรับรางวัล (ฟีเจอร์ระบบเรา) */
              .pk-referral .standard-submit-button {
                background:linear-gradient(135deg,#0a5ebd,#04a9c2) !important; color:#fff !important;
                border:none !important; border-radius:10px !important; height:42px; font-weight:700; cursor:pointer;
              }
              /* เงื่อนไข */
              .pk-referral .notice-container { margin:20px 22px 0 !important; width:auto !important; background:#f7f9fb; border:1px solid #eef1f4; border-radius:12px; padding:14px 16px; box-sizing:border-box; }
              .pk-referral .recent-transaction-title { display:flex; align-items:center; justify-content:space-between; color:#1a1a1a; font-weight:600; font-size:14px; }
              .pk-referral .notice-container ul { margin:10px 0 0; padding-left:18px; }
              .pk-referral .notice-container li { color:#6b7785; font-size:12.5px; line-height:1.6; margin-bottom:6px; }

              /* ===== MOBILE ===== */
              .pk-referral-mobile .referral-content { padding:16px !important; }
              .pk-referral-mobile .notice-container { margin:18px 16px 0 !important; }
              .pk-referral-mobile .referral-tab-container .standard-tab { display:flex; width:100%; }
              .pk-referral-mobile .referral-tab-container ._tabHeaderTitle_1ivtf_1 { flex:1; padding:12px 8px; font-size:14px; white-space:normal; text-align:center; }
              .pk-referral-mobile .standard-label { font-size:15px; }
              .pk-referral-mobile .invi-status { padding:14px 16px; }
              .pk-referral-mobile .invi-status .text { font-size:15px; }
              .pk-referral-mobile .invi-status .value { font-size:18px; }
              .pk-referral-mobile .ref-code-link-container { flex-direction:column !important; gap:16px; }
              .pk-referral-mobile .ref-code-box, .pk-referral-mobile .ref-link-box { width:100% !important; }
              .pk-referral-mobile .ref-code-link-container .standard-input { width:100% !important; height:54px !important; font-size:16px !important; }
              .pk-referral-mobile .bottom-content { flex-direction:column !important; width:100% !important; }
              .pk-referral-mobile .content-left { width:100% !important; max-width:none !important; }
              .pk-referral-mobile .referOption-container { width:100% !important; }
              .pk-referral-mobile .referOption { width:100% !important; min-width:0 !important; box-sizing:border-box !important; }
              .pk-referral-mobile .ref-share-container { width:100% !important; }
              .pk-referral-mobile .option-remark { font-size:16px; }
              .pk-referral-mobile .option-turnover, .pk-referral-mobile .option-deposit { font-size:14px; }
              .pk-referral-mobile .standard-submit-btn { width:100% !important; min-width:0 !important; height:54px !important; font-size:16px !important; }
              .pk-referral-mobile .ref-share-container { margin-top:24px; }
            `}</style>
          </section>
        );
      }

      case 'myAccount':
        return (
          <>

            {/* PROFILE - copied from BK8 with inline styles */}
            {(() => {
              const ROW = { display:'flex', flexWrap:'nowrap', alignItems:'center', marginBottom:10, width:'100%', borderBottom:'1px solid rgba(255,255,255,0.07)', paddingBottom:10 };
              const LBL = { margin:0, flexShrink:0, whiteSpace:'nowrap', color:'#8697a2', fontSize:13, minWidth:120, maxWidth:120 };
              const INP = { flex:'1 1 0', minWidth:0, background:'unset', border:'unset', width:'unset', color:'#e0e6ec', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', padding:0, fontSize:13 };
              const EDITBTN = { flexShrink:0, width:20, height:20, minWidth:20, margin:'0 8px', padding:0, background:'unset', border:'unset', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' };
              const EditSvg = () => (
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 61.62458" className="beta-edit" width="100%" height="100%"><g className="beta-edit"><g><path d="M40.56919,61.62458H2.16796C0.97259,61.62458,0,60.6543,0,59.45893c0-1.19757,0.97259-2.16784,2.16796-2.16784h38.40123c1.19538,0,2.16784,0.97027,2.16784,2.16784C42.73703,60.6543,41.76457,61.62458,40.56919,61.62458"></path><path d="M4.60922,53.02164c-0.47933,0-0.94553-0.174-1.30995-0.48589c-0.5811-0.49903-0.82733-1.3001-0.62707-2.03879l3.30934-12.36077c0.07879-0.29219,0.21997-0.56141,0.42023-0.7945L38.04076,0.69273C38.4216,0.2528,38.97644,0,39.56411,0c0.47933,0,0.94224,0.17072,1.30666,0.48261l8.43422,7.28514c0.40053,0.34144,0.65005,0.84047,0.68945,1.36904c0.03939,0.53842-0.13132,1.05387-0.47933,1.45769L17.87284,47.24671c-0.20027,0.22981-0.44978,0.41367-0.72228,0.53186L5.40373,52.85748C5.15421,52.96582,4.88172,53.02164,4.60922,53.02164z M7.61652,47.52906l5.47617-2.3671l-3.62123-3.48991l-0.22982-0.19698L7.61652,47.52906z M14.11044,42.06274l1.415,1.4741L41.34025,13.9268l-1.41829-1.4741l-0.14445-0.12476L14.11044,42.06274z M10.394,38.85518l1.52006,1.56602l25.81481-29.61004l-1.52007-1.56603l-0.14445-0.12476L10.394,38.85518z M37.85034,7.04876l2.62975,2.5214l2.5017,2.16026l2.06177-2.0946l-5.2759-4.80642L37.85034,7.04876z"></path></g></g></svg>
              );
              return (
                <section className="st-detail-container null " style={{ padding:0 }}>
                  <div className="st-tab" style={{ padding:0 }}>
                    <div className="standard-tab-container myprofile-tab-container" style={{ padding:'12px 20px 0', marginBottom:0, background:'#131c2e' }}>
                      <div className="standard-tab" style={{ display:'flex', gap:4, borderBottom:'2px solid rgba(255,255,255,0.08)' }}>
                        <div className="_tabHeaderTitle_1ivtf_1 tab-header-title _active_1ivtf_22" id="tab_header_active"
                          style={{ padding:'10px 16px', fontSize:13, fontWeight:600, color:'#4db8d0', borderBottom:'2px solid #4db8d0', marginBottom:-2, background:'transparent', cursor:'pointer' }}>
                          <span>ข้อมูลบัญชี</span>
                        </div>
                        <div className="_tabHeaderTitle_1ivtf_1 tab-header-title"
                          style={{ padding:'10px 16px', fontSize:13, fontWeight:400, color:'#8697a2', background:'transparent', cursor:'pointer' }}
                          onClick={() => this.notify('info', 'ยังไม่เปิดให้บริการ')}>
                          <span>การส่ง KYC</span>
                        </div>
                      </div>
                    </div>
                    <div className="standard-account-container profile-container standard-settings-container" style={{ padding:'0 16px 16px', display:'block' }}>

                      {/* ข้อมูลส่วนบุคคล */}
                      <div className="profile-column" style={{ width:'100%', marginBottom:4 }}>
                        <p className="column-title h6 SemiBold" style={{ color:'#cdd6e0', fontSize:13, fontWeight:600, margin:'12px 0 8px' }}>ข้อมูลส่วนบุคคล</p>

                        <div className="standard-form-field" style={ROW}>
                          <p className="standard-label h6" style={LBL}>ยูสเซอร์เนม</p>
                          <input className="standard-input h6" type="text" disabled value={this.state.username || ''} style={INP} />
                        </div>

                        <div className="standard-form-field" style={ROW}>
                          <p className="standard-label h6" style={LBL}>วัน เดือน ปี เกิด</p>
                          <input className="standard-input h6" type="text" disabled value={this.state.tblprofile?.birthday || ''} style={INP} />
                          <button className="edit-btn" style={EDITBTN}><EditSvg /></button>
                        </div>

                        <div className="standard-form-field" style={ROW}>
                          <p className="standard-label h6" style={LBL}>ชื่อ-นามสกุล</p>
                          <input className="standard-input h6" type="text" disabled value={[this.state.fname || this.state.firstname, this.state.lastname].filter(v => v && v !== 'undefined' && v !== 'null').join(' ') || ''} style={INP} />
                        </div>

                        <div className="standard-form-field" style={ROW}>
                          <p className="standard-label h6" style={LBL}>สกุลเงิน</p>
                          <input className="standard-input h6" type="text" disabled value="THB" style={INP} />
                        </div>
                      </div>

                      {/* ข้อมูลการติดต่อ */}
                      <div className="profile-column" id="profile-contact-info" style={{ width:'100%', marginBottom:4 }}>
                        <p className="column-title h6 SemiBold" style={{ color:'#cdd6e0', fontSize:13, fontWeight:600, margin:'12px 0 8px' }}>ข้อมูลการติดต่อ</p>

                        <div className="standard-form-field" style={ROW}>
                          <p className="standard-label h6" style={LBL}>อีเมล</p>
                          <input className="standard-input h6" type="text" disabled value={this.state.tblprofile?.email || ''} style={INP} />
                          <button className="edit-btn" style={EDITBTN}><EditSvg /></button>
                          <div className="text-danger"></div>
                        </div>

                        <div className="standard-form-field" style={ROW}>
                          <p className="standard-label h6" style={LBL}>เบอร์โทรศัพท์</p>
                          <input className="standard-input h6" type="text" disabled value={this.state.tblprofile?.tel || this.state.tblprofile?.phone || this.state.phoneNumber || ''} style={INP} />
                          <button className="edit-btn" style={EDITBTN}><EditSvg /></button>
                        </div>

                        <div className="standard-form-field" style={ROW}>
                          <p className="standard-label" style={LBL}>ไลน์ไอดี</p>
                          <input className="standard-input" type="text" disabled value={this.state.tblprofile?.line || this.state.tblprofile?.lineId || ''} style={INP} />
                        </div>
                      </div>


                      {/* รายละเอียดธนาคาร */}
                      <div className="profile-column" style={{ width:'100%' }}>
                        <p className="column-title h6 SemiBold" style={{ color:'#cdd6e0', fontSize:13, fontWeight:600, margin:'12px 0 8px' }}>รายละเอียดธนาคาร</p>
                        {this.state.accnumber && this.state.accnumber.length > 0 ? (
                          this.state.accnumber.map((acc, idx) => (
                            <div key={idx} style={{ display:'flex', alignItems:'center', padding:'10px 0', borderBottom:'1px solid rgba(255,255,255,0.07)' }}>
                              <img
                                loading="lazy"
                                src={acc.img_path}
                                alt={acc.fullname_th || acc.acro || ''}
                                style={{ width:36, height:36, borderRadius:8, marginRight:12, objectFit:'contain', background:'#fff', padding:3 }}
                              />
                              <div style={{ flex:1 }}>
                                <div style={{ color:'#e0e6ec', fontSize:13, fontWeight:600 }}>{acc.fullname_th || acc.acro || '-'}</div>
                                <div style={{ color:'#8697a2', fontSize:12, marginTop:2 }}>
                                  {[this.state.fname || this.state.firstname, this.state.lastname].filter(v => v && v !== 'undefined').join(' ') || '-'}
                                </div>
                              </div>
                              <div style={{ color:'#4db8d0', fontSize:13, letterSpacing:1 }}>{acc.accno || '-'}</div>
                            </div>
                          ))
                        ) : (
                          <div style={{ color:'#8697a2', fontSize:13, padding:'8px 0' }}>ยังไม่มีบัญชีธนาคาร</div>
                        )}
                      </div>


                    </div>
                  </div>
                </section>
              );
            })()}
          </>
        );
      // ===== ข้อความ =====
      case 'messages': {
        const isMobile = window.innerWidth <= 760;
        return (
          <section className={`st-detail-container pk-message ${isMobile ? 'pk-message-mobile' : 'pk-message-desktop'}`}><div className="st-tab  "><div className="standard-tab-container message-tab-container"><div className="standard-tab"><div className="_tabHeaderTitle_1ivtf_1 tab-header-title _active_1ivtf_22" id="tab_header_active"><span>โปรโมชั่น (0)</span></div><div className="_tabHeaderTitle_1ivtf_1 tab-header-title" id=""><span>การเงิน (0)</span></div><div className="_tabHeaderTitle_1ivtf_1 tab-header-title" id=""><span>ระบบ (0)</span></div><div className="_tabHeaderTitle_1ivtf_1 tab-header-title" id=""><span>การแจ้งเตือน (0)</span></div></div></div><div className="message-table-container standard-setting-table-container message-container standard-settings-container"><div className="header-control"><div className="checkbox-column"><input type="checkbox" className="standard-invisible-checkbox" /><div className="standard-checkbox"><svg width="20px" height="20px" viewBox="0 0 20 20"><path d="M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z"></path><polyline points="4 11 8 15 16 6"></polyline></svg></div><span>เลือก / ไม่เลือกทั้งหมด</span></div><div className="content-column"><div className="mark-action"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 43.479" className="beta-mark-as-read mark-icon" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-mark-as-read .st0{fill:#8697A2;}\n\t .beta-mark-as-read .st1{fill:none;}\n  " }} /><g className="beta-mark-as-read"><g><path className="st0" d="M45.973,43.478H4.023c-2.219,0-4.023-1.81-4.023-4.04V13.376c0-1.494,0.817-2.859,2.131-3.561l20.974-9.337
	c1.186-0.636,2.603-0.636,3.789,0l20.974,9.337c1.314,0.702,2.131,2.067,2.131,3.561v26.062
	C49.998,41.667,48.193,43.478,45.973,43.478 M24.999,2.694c-0.216,0-0.435,0.053-0.632,0.158L3.393,12.189
	c-0.437,0.234-0.71,0.69-0.71,1.186v26.062c0,0.745,0.599,1.349,1.34,1.349h41.95c0.741,0,1.342-0.603,1.342-1.349V13.376
	c0-0.497-0.273-0.952-0.71-1.186L25.631,2.852C25.432,2.745,25.214,2.694,24.999,2.694"></path><path className="st0" d="M24.997,29.162c-0.782,0-1.564-0.187-2.276-0.556l-22-9.682c-0.655-0.343-0.909-1.16-0.567-1.817
	c0.343-0.659,1.156-0.911,1.81-0.569l21.994,9.676c0.64,0.333,1.445,0.333,2.09-0.002l21.99-9.674
	c0.655-0.345,1.466-0.09,1.808,0.569c0.345,0.657,0.09,1.472-0.564,1.817l-21.996,9.678C26.565,28.973,25.781,29.162,24.997,29.162"></path><rect className="st1" width="50" height="43.479"></rect></g></g></svg><span>ทำเครื่องหมายว่าอ่านแล้ว</span></div><div className="delete-action"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 56.217" className="beta-delete delete-icon" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-delete .st0{fill:#8697A2;}\n\t .beta-delete .st1{fill:none;}\n  " }} /><g className="beta-delete"><g><g><path className="st0" d="M48.439,8.091H36.742V6.185C36.742,2.775,33.967,0,30.56,0H19.439c-3.407,0-6.182,2.775-6.182,6.185v1.906
		H1.56c-0.866,0-1.558,0.695-1.558,1.561c0,0.866,0.692,1.561,1.558,1.561h2.821v36.659c0,4.599,3.744,8.343,8.343,8.343h24.55
		c4.599,0,8.343-3.744,8.343-8.343V11.213h2.821c0.866,0,1.561-0.695,1.561-1.561C50,8.786,49.305,8.091,48.439,8.091 M16.379,6.185
		c0-1.689,1.374-3.063,3.06-3.063H30.56c1.686,0,3.06,1.374,3.06,3.063v1.906H16.379V6.185z M42.498,47.872
		c0,2.878-2.346,5.227-5.224,5.227h-24.55c-2.878,0-5.224-2.349-5.224-5.227V11.213h35.008v36.659H42.498z"></path><path className="st0" d="M24.999,47.503c0.866,0,1.561-0.695,1.561-1.561V18.368c0-0.869-0.695-1.564-1.561-1.564
		c-0.866,0-1.558,0.695-1.558,1.564v27.563C23.44,46.798,24.133,47.503,24.999,47.503"></path><path className="st0" d="M15.496,45.78c0.866,0,1.561-0.692,1.561-1.561V20.077c0-0.866-0.695-1.561-1.561-1.561
		c-0.866,0-1.558,0.695-1.558,1.561v24.142C13.938,45.088,14.643,45.78,15.496,45.78"></path><path className="st0" d="M34.454,45.78c0.863,0,1.558-0.692,1.558-1.561V20.077c0-0.866-0.695-1.561-1.558-1.561
		c-0.866,0-1.561,0.695-1.561,1.561v24.142C32.893,45.088,33.588,45.78,34.454,45.78"></path><rect className="st1" y="0.002" width="49.998" height="56.216"></rect></g></g></g></svg><span>ลบ</span></div></div></div><table><thead className="st-ms-table"><tr><th className="t-tick"></th><th className="t-subject">เรื่อง</th><th className="t-date">วันที่</th><th className="t-remark">หมายเหตุ</th></tr></thead><tbody className="st-ms-tbody"><tr className="message-detail"><td className="checkbox-column checkbox"><input type="checkbox" className="standard-invisible-checkbox" /><div className="standard-checkbox"><svg width="20px" height="20px" viewBox="0 0 20 20"><path d="M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z"></path><polyline points="4 11 8 15 16 6"></polyline></svg></div></td><td className="content-column"><p className="msg-detail unreadMsg">หมุนลุ้นรับ iPhone 17 Pro Max หรือ iPhone 17 Air</p></td><td className="t-date"><span className="msg-date ">22/05/2026 19:10</span></td><td className="remark-detail"><span><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 76.636" className="beta-pin pin_false" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-pin .st0{clip-path:url(#beta-pin-SVGID_2_);}\n  " }} /><g className="beta-pin"><g><g><defs><rect id="beta-pin-SVGID_1_" width="50" height="76.636"></rect></defs><clipPath id="beta-pin-SVGID_2_"><use xlinkHref="#beta-pin-SVGID_1_" style={{ overflow: 'visible' }}></use></clipPath><path className="st0" d="M22.655,74.292V53.634c0-1.29,1.052-2.342,2.346-2.342c1.294,0,2.346,1.052,2.346,2.342v20.658
		c0,1.294-1.052,2.346-2.346,2.346C23.707,76.638,22.655,75.586,22.655,74.292"></path><path className="st0" d="M47.72,54.65H2.281c-0.658,0-1.283-0.286-1.717-0.777c-0.431-0.498-0.632-1.156-0.543-1.81
		c0.033-0.271,0.937-6.77,4.465-12.613c2.606-4.32,5.74-7.312,7.257-8.628V14.308c-0.546-0.974-1.725-3.164-2.914-5.784
		C7.099,4.717,7.24,2.449,7.288,2.029c0.126-1.156,1.108-2.03,2.268-2.03h30.892c1.16,0,2.138,0.874,2.264,2.03
		c0.048,0.42,0.193,2.688-1.539,6.494c-1.19,2.621-2.372,4.81-2.911,5.784v16.513c1.513,1.316,4.647,4.309,7.253,8.628
		c3.528,5.844,4.428,12.342,4.465,12.613c0.085,0.654-0.112,1.312-0.543,1.81C48.999,54.364,48.374,54.65,47.72,54.65 M5.069,50.085
		h39.859c-0.543-2.164-1.554-5.353-3.32-8.279v-0.004c-3.059-5.071-6.967-8.056-7.007-8.082c-0.569-0.435-0.903-1.104-0.903-1.822
		v-18.19c0-0.401,0.104-0.792,0.305-1.138c0.015-0.03,1.524-2.658,3.015-5.937c0.364-0.799,0.617-1.494,0.788-2.071h-25.61
		c0.175,0.576,0.42,1.271,0.788,2.071c1.494,3.29,3,5.907,3.015,5.933c0.201,0.349,0.305,0.74,0.305,1.141v18.19
		c0,0.717-0.335,1.387-0.907,1.822c-0.033,0.026-3.967,3.056-7.004,8.086C6.616,44.743,5.608,47.929,5.069,50.085"></path></g></g></g></svg></span><span><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 54.866" className="beta-flag flag_false" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-flag .st0{clip-path:url(#beta-flag-SVGID_2_);}\n  " }} /><g className="beta-flag"><g><g><defs><rect id="beta-flag-SVGID_1_" width="50" height="54.866"></rect></defs><clipPath id="beta-flag-SVGID_2_"><use xlinkHref="#beta-flag-SVGID_1_" style={{ overflow: 'visible' }}></use></clipPath><path className="st0" d="M1.436,54.866C0.643,54.866,0,54.223,0,53.432V1.433C0,0.643,0.643,0,1.436,0
		c0.79,0,22.776,0.023,22.776,0.023c0.793,0,1.436,0.643,1.436,1.436v3.742h22.916c0.535,0,1.02,0.297,1.268,0.77
		c0.251,0.465,0.22,1.033-0.083,1.475L38.915,23.205l10.834,15.757c0.3,0.434,0.333,1.012,0.083,1.48
		c-0.248,0.47-0.733,0.767-1.268,0.767h-30.56c-3.076,0-5.576-2.503-5.576-5.576c0-0.953,0.245-1.875,0.721-2.709H2.869v20.509
		C2.869,54.223,2.226,54.866,1.436,54.866 M18.004,32.924c-1.493,0-2.709,1.214-2.709,2.709c0,1.49,1.216,2.704,2.709,2.704h27.836
		l-9.842-14.321c-0.341-0.491-0.341-1.131,0.003-1.622l9.84-14.321H25.648v23.412c0,0.793-0.643,1.439-1.436,1.439H18.004z
		 M22.782,2.895H2.869v27.164h19.912V2.895z"></path></g></g></g></svg></span><span><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 56.217" className="beta-delete" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-delete .st0{fill:#8697A2;}\n\t .beta-delete .st1{fill:none;}\n  " }} /><g className="beta-delete"><g><g><path className="st0" d="M48.439,8.091H36.742V6.185C36.742,2.775,33.967,0,30.56,0H19.439c-3.407,0-6.182,2.775-6.182,6.185v1.906
		H1.56c-0.866,0-1.558,0.695-1.558,1.561c0,0.866,0.692,1.561,1.558,1.561h2.821v36.659c0,4.599,3.744,8.343,8.343,8.343h24.55
		c4.599,0,8.343-3.744,8.343-8.343V11.213h2.821c0.866,0,1.561-0.695,1.561-1.561C50,8.786,49.305,8.091,48.439,8.091 M16.379,6.185
		c0-1.689,1.374-3.063,3.06-3.063H30.56c1.686,0,3.06,1.374,3.06,3.063v1.906H16.379V6.185z M42.498,47.872
		c0,2.878-2.346,5.227-5.224,5.227h-24.55c-2.878,0-5.224-2.349-5.224-5.227V11.213h35.008v36.659H42.498z"></path><path className="st0" d="M24.999,47.503c0.866,0,1.561-0.695,1.561-1.561V18.368c0-0.869-0.695-1.564-1.561-1.564
		c-0.866,0-1.558,0.695-1.558,1.564v27.563C23.44,46.798,24.133,47.503,24.999,47.503"></path><path className="st0" d="M15.496,45.78c0.866,0,1.561-0.692,1.561-1.561V20.077c0-0.866-0.695-1.561-1.561-1.561
		c-0.866,0-1.558,0.695-1.558,1.561v24.142C13.938,45.088,14.643,45.78,15.496,45.78"></path><path className="st0" d="M34.454,45.78c0.863,0,1.558-0.692,1.558-1.561V20.077c0-0.866-0.695-1.561-1.558-1.561
		c-0.866,0-1.561,0.695-1.561,1.561v24.142C32.893,45.088,33.588,45.78,34.454,45.78"></path><rect className="st1" y="0.002" width="49.998" height="56.216"></rect></g></g></g></svg></span></td></tr></tbody></table><div className="pagination-content"><p className="page-count">ยังไม่มีข้อความ</p><ul className="pagination"><li className="page-item disabled"><a className="arrow-icon" href="#" aria-label="Go to first page"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 48.396" className="" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-double-arrow-left .st0{fill:#8899A4;}\n  " }} /><g className="beta-double-arrow-left"><g><g><path className="st0" d="M45.703,48.396c-1.094,0-2.193-0.421-3.03-1.257L23.679,28.145c-1.06-1.056-1.635-2.459-1.635-3.948
		c0-1.493,0.584-2.892,1.639-3.944l18.99-18.994c1.674-1.678,4.39-1.678,6.068,0c1.678,1.678,1.678,4.399,0,6.072L31.876,24.197
		l16.866,16.866c1.678,1.678,1.678,4.394,0,6.077C47.905,47.975,46.806,48.396,45.703,48.396L45.703,48.396z"></path><path className="st0" d="M23.659,48.396c-1.094,0-2.193-0.421-3.03-1.257L1.635,28.145C0.575,27.089,0,25.686,0,24.197
		c0-1.493,0.584-2.892,1.639-3.944l18.99-18.994c1.674-1.678,4.39-1.678,6.068,0c1.678,1.678,1.678,4.399,0,6.072L9.832,24.197
		l16.866,16.866c1.678,1.678,1.678,4.394,0,6.077C25.86,47.975,24.762,48.396,23.659,48.396L23.659,48.396z"></path></g></g></g></svg></a></li><li className="page-item disabled"><a className="arrow-icon" href="#" aria-label="Go to previous page"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 86.559" className="" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-arrow-left .st0{fill:#8899A4;}\n  " }} /><g className="beta-arrow-left"><g><path className="st0" d="M42.315,86.559c-1.958,0-3.922-0.752-5.419-2.249L2.924,50.338C1.029,48.45,0,45.94,0,43.277
	c0-2.671,1.044-5.173,2.932-7.054L36.896,2.251c2.993-3.001,7.852-3.001,10.853,0c3.001,3.001,3.001,7.868,0,10.861L17.585,43.277
	l30.165,30.165c3.001,3.001,3.001,7.86,0,10.868C46.252,85.807,44.288,86.559,42.315,86.559L42.315,86.559z"></path></g></g></svg></a></li><li className="page-item active"><a className="arrow-icon undefined" href="#" aria-label="Go to page number 1">1</a></li><li className="page-item disabled"><a className="arrow-icon" href="#" aria-label="Go to next page"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 86.559" className="" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-arrow-right .st0{fill:#8899A4;}\n  " }} /><g className="beta-arrow-right"><g><path className="st0" d="M7.685,0c1.958,0,3.922,0.752,5.419,2.249l33.972,33.972C48.972,38.109,50,40.619,50,43.282
	c0,2.671-1.044,5.173-2.932,7.054L13.104,84.308c-2.993,3.001-7.852,3.001-10.853,0c-3.001-3.001-3.001-7.868,0-10.861
	l30.165-30.165L2.251,13.117c-3.001-3.001-3.001-7.86,0-10.868C3.748,0.752,5.712,0,7.685,0L7.685,0z"></path></g></g></svg></a></li><li className="page-item disabled"><a className="arrow-icon" href="#" aria-label="Go to last page"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 48.396" className="" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-double-arrow-right .st0{fill:#8899A4;}\n  " }} /><g className="beta-double-arrow-right"><g><g><path className="st0" d="M4.297,0c1.094,0,2.193,0.421,3.03,1.257l18.994,18.994c1.06,1.056,1.635,2.459,1.635,3.948
		c0,1.493-0.584,2.892-1.639,3.944L7.326,47.138c-1.674,1.678-4.39,1.678-6.068,0c-1.678-1.678-1.678-4.399,0-6.072L18.124,24.2
		L1.258,7.334c-1.678-1.678-1.678-4.394,0-6.077C2.095,0.421,3.194,0,4.297,0L4.297,0z"></path><path className="st0" d="M26.341,0c1.094,0,2.193,0.421,3.03,1.257l18.994,18.994C49.425,21.307,50,22.71,50,24.2
		c0,1.493-0.584,2.892-1.639,3.944l-18.99,18.994c-1.674,1.678-4.39,1.678-6.068,0c-1.678-1.678-1.678-4.399,0-6.072L40.168,24.2
		L23.303,7.334c-1.678-1.678-1.678-4.394,0-6.077C24.14,0.421,25.238,0,26.341,0L26.341,0z"></path></g></g></g></svg></a></li></ul></div></div><style>{`
            /* ===== CSS หน้าข้อความ (เข้าธีมเดียวกับ bankdetails/referral) — scoped + แยก mobile/desktop ===== */
            .pk-message { color:#1a1a1a; }
            .pk-message .message-tab-container { margin-top:12px; }
            .pk-message .message-tab-container .standard-tab {
              display:inline-flex; gap:6px; padding:6px; background:#eef1f5; border-radius:14px; border:none; flex-wrap:wrap;
            }
            .pk-message .message-tab-container ._tabHeaderTitle_1ivtf_1 {
              display:flex; align-items:center; justify-content:center; padding:10px 18px; border-radius:10px;
              background:transparent; color:#6b7785; font-size:13px; font-weight:600; cursor:pointer; white-space:nowrap; border:none; transition:.18s;
            }
            .pk-message .message-tab-container ._tabHeaderTitle_1ivtf_1:hover { color:#0a5ebd; }
            .pk-message .message-tab-container ._tabHeaderTitle_1ivtf_1._active_1ivtf_22 {
              background:linear-gradient(135deg,#0a5ebd,#04a9c2); color:#fff; box-shadow:0 4px 12px rgba(9,94,189,.30);
            }
            .pk-message .message-container { background:#fff; border-radius:12px; padding:14px 16px; margin-top:14px; }
            /* แถบควบคุม: เลือกทั้งหมด / อ่านแล้ว / ลบ */
            .pk-message .header-control {
              display:flex; align-items:center; justify-content:space-between; gap:12px;
              padding:10px 6px; border-bottom:1px solid #eef1f4; flex-wrap:wrap;
            }
            .pk-message .header-control .checkbox-column { display:flex; align-items:center; gap:8px; color:#6b7785; font-size:13px; }
            .pk-message .header-control .content-column { display:flex; align-items:center; gap:18px; }
            .pk-message .mark-action, .pk-message .delete-action { display:flex; align-items:center; gap:6px; color:#8697a2; font-size:13px; cursor:pointer; }
            .pk-message .mark-action:hover, .pk-message .delete-action:hover { color:#0a5ebd; }
            .pk-message .mark-icon, .pk-message .delete-icon { width:18px; height:18px; flex:0 0 auto; }
            .pk-message .standard-checkbox { width:20px; height:20px; flex:0 0 auto; }
            .pk-message .standard-checkbox svg { width:20px; height:20px; }
            .pk-message .standard-checkbox svg path { fill:#fff; stroke:#c7cfd6; stroke-width:1.5; }
            .pk-message .standard-checkbox svg polyline { fill:none; stroke:#c7cfd6; stroke-width:2; }
            /* ตาราง */
            .pk-message .message-container table { width:100%; border-collapse:collapse; margin-top:4px; }
            .pk-message .st-ms-table th { background:#f7f7f7; color:#0f161f; font-size:13px; font-weight:600; text-align:left; padding:12px 14px; }
            .pk-message .st-ms-table th.t-tick { width:40px; }
            .pk-message .st-ms-table th.t-date { width:150px; }
            .pk-message .st-ms-table th.t-remark { width:110px; text-align:right; }
            .pk-message .st-ms-tbody td { padding:14px; border-bottom:1px solid #f0f2f4; vertical-align:middle; color:#6b7785; font-size:13px; }
            .pk-message .msg-detail { color:#1a1a1a; font-size:13.5px; margin:0; }
            .pk-message .msg-detail.unreadMsg { font-weight:700; color:#0a2540; }
            .pk-message .msg-date { color:#8697a2; font-size:12.5px; white-space:nowrap; }
            .pk-message .remark-detail { text-align:right; }
            .pk-message .remark-detail span { display:inline-flex; width:16px; height:16px; margin-left:10px; cursor:pointer; vertical-align:middle; }
            .pk-message .remark-detail svg { width:16px; height:16px; }
            .pk-message .remark-detail svg path { fill:#b6bfc7; }
            /* pagination */
            .pk-message .pagination-content { display:flex; align-items:center; justify-content:space-between; margin-top:16px; flex-wrap:wrap; gap:10px; }
            .pk-message .page-count { color:#8697a2; font-size:12.5px; margin:0; }
            .pk-message .pagination { display:flex; align-items:center; gap:6px; list-style:none; margin:0; padding:0; }
            .pk-message .pagination .page-item a { display:flex; align-items:center; justify-content:center; min-width:30px; height:30px; padding:0 6px; border-radius:8px; color:#6b7785; font-size:13px; text-decoration:none; background:#f2f4f7; }
            .pk-message .pagination .page-item.active a { background:linear-gradient(135deg,#0a5ebd,#04a9c2); color:#fff; font-weight:700; }
            .pk-message .pagination .page-item.disabled a { opacity:.4; cursor:not-allowed; }
            .pk-message .pagination .arrow-icon svg { width:12px; height:12px; }
            /* ยังไม่ผูก API — ซ่อนข้อความ mock เก่า + pagination, โชว์สถานะว่าง */
            .pk-message .st-ms-tbody .message-detail { display:none; }
            .pk-message .pagination { display:none !important; }
            .pk-message .pagination-content { justify-content:center !important; padding:26px 0 8px; }
            .pk-message .page-count { color:#8697a2; font-size:13px; }

            /* ===== MOBILE ===== */
            .pk-message-mobile .message-tab-container .standard-tab { display:flex; width:100%; }
            .pk-message-mobile .message-tab-container ._tabHeaderTitle_1ivtf_1 { flex:1 1 auto; padding:11px 6px; font-size:13px; white-space:normal; text-align:center; }
            .pk-message-mobile .message-container { padding:12px; }
            .pk-message-mobile .header-control .checkbox-column span { display:none; }
            .pk-message-mobile .header-control .content-column { gap:14px; }
            .pk-message-mobile .st-ms-table th.t-date, .pk-message-mobile .st-ms-table td.t-date { display:none; }
            .pk-message-mobile .st-ms-table th, .pk-message-mobile .st-ms-tbody td { padding:12px 8px; font-size:14px; }
            .pk-message-mobile .msg-detail { font-size:14px; }
            .pk-message-mobile .pagination-content { justify-content:center; }
          `}</style></div></section>
        );
      }
      // ===== เปลี่ยนรหัสผ่าน =====
      // mobile → redirect ไปหน้าแยก | desktop → render inline
      case 'changePassword': {
        const isMobileView = window.innerWidth <= 760;
        if (isMobileView) {
          window.location.href = '/changepassword';
          return null;
        }
        const { oldpassword, newpassword, confirmpassword, showChgPwdOld, showChgPwdNew, showChgPwdConfirm, chgPwdLoading } = this.state;
        const EyeIcon = ({ show }) => show ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor">
            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor">
            <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
            <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
            <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.708zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
          </svg>
        );
        return (
          <section className="st-detail-container null">
            <div className="st-tab">
              <form onSubmit={this.handleChangePass}>
                <div className="standard-tab-container change-password-tab-container">
                  <div className="standard-tab">
                    <div className="_tabHeaderTitle_1ivtf_1 tab-header-title _active_1ivtf_22" id="tab_header_active">
                      <span>รหัสผ่านเข้าระบบ</span>
                    </div>
                  </div>
                </div>
                <div className="standard-setting-table-container change-password-container standard-settings-container">
                  <div className="standard-error-container" />
                  <div className="change-password-form">

                    {/* รหัสผ่านปัจจุบัน */}
                    <div className="_standardFormField_uj5nz_2">
                      <label className="_fieldLabel_uj5nz_17 standard-mandatory">รหัสผ่านปัจจุบัน</label>
                      <div style={{ position: 'relative' }}>
                        <input
                          type={showChgPwdOld ? 'text' : 'password'}
                          className="standard-input"
                          placeholder="รหัสผ่านปัจจุบัน"
                          value={oldpassword}
                          onChange={(e) => this.setState({ oldpassword: e.target.value })}
                          style={{ paddingRight: 36 }}
                        />
                        <button type="button" className="_passwordEyes_197f3_1"
                          style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#8697a2' }}
                          onClick={() => this.setState({ showChgPwdOld: !showChgPwdOld })}>
                          <EyeIcon show={showChgPwdOld} />
                        </button>
                      </div>
                    </div>

                    {/* รหัสผ่านใหม่ */}
                    <div className="_standardFormField_uj5nz_2">
                      <label className="_fieldLabel_uj5nz_17 standard-mandatory">รหัสผ่านใหม่</label>
                      <div style={{ position: 'relative' }}>
                        <input
                          type={showChgPwdNew ? 'text' : 'password'}
                          className="standard-input"
                          placeholder="รหัสผ่านใหม่ (อย่างน้อย 6 ตัว)"
                          value={newpassword}
                          onChange={(e) => this.setState({ newpassword: e.target.value })}
                          style={{ paddingRight: 36 }}
                        />
                        <button type="button"
                          style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#8697a2' }}
                          onClick={() => this.setState({ showChgPwdNew: !showChgPwdNew })}>
                          <EyeIcon show={showChgPwdNew} />
                        </button>
                      </div>
                    </div>

                    {/* ยืนยันรหัสผ่านใหม่ */}
                    <div className="_standardFormField_uj5nz_2">
                      <label className="_fieldLabel_uj5nz_17 standard-mandatory">ยืนยันรหัสผ่านใหม่</label>
                      <div style={{ position: 'relative' }}>
                        <input
                          type={showChgPwdConfirm ? 'text' : 'password'}
                          className="standard-input"
                          placeholder="ยืนยันรหัสผ่านใหม่"
                          value={confirmpassword}
                          onChange={(e) => this.setState({ confirmpassword: e.target.value })}
                          style={{ paddingRight: 36 }}
                        />
                        <button type="button"
                          style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#8697a2' }}
                          onClick={() => this.setState({ showChgPwdConfirm: !showChgPwdConfirm })}>
                          <EyeIcon show={showChgPwdConfirm} />
                        </button>
                      </div>
                    </div>

                  </div>
                  <section className="transaction-button-section">
                    <div className="standard-button-container">
                      <button
                        id=""
                        className="standard-submit-button"
                        data-button-category="submit"
                        type="submit"
                        disabled={chgPwdLoading}
                      >
                        <span>{chgPwdLoading ? 'กำลังดำเนินการ...' : 'เปลี่ยนรหัสผ่าน'}</span>
                      </button>
                    </div>
                  </section>
                </div>
              </form>
            </div>
          </section>
        );
      }
      case '_changePassword_disabled':
        return (
          <section className="st-detail-container null "><div className="st-tab  "><form><div className="standard-tab-container change-password-tab-container"><div className="standard-tab"><div className="_tabHeaderTitle_1ivtf_1 tab-header-title _active_1ivtf_22" id="tab_header_active"><span>รหัสผ่านเข้าระบบ</span></div></div></div><div className="standard-setting-table-container change-password-container standard-settings-container"><div className="standard-error-container"></div><div className="change-password-form"><div className="_standardFormField_uj5nz_2"><label className="_fieldLabel_uj5nz_17 standard-mandatory"> รหัสผ่านปัจจุบัน</label><input type="password" name="password" className="false standard-input  " placeholder="รหัสผ่านปัจจุบัน" defaultValue="" /><div className="_passwordEyes_197f3_1"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024" className=" standard-password-eye " width="1em" height="1em" id="" prefix=""><g className="AiOutlineEyeInvisible"><path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z"></path></g></svg></div></div><div className="_standardFormField_uj5nz_2"><label className="_fieldLabel_uj5nz_17 standard-mandatory"> รหัสผ่าน</label><input type="password" name="password" className="false standard-input  " placeholder="รหัสผ่าน" defaultValue="" /><div className="_passwordEyes_197f3_1"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024" className=" standard-password-eye " width="1em" height="1em" id="" prefix=""><g className="AiOutlineEyeInvisible"><path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z"></path></g></svg></div></div><div className="_standardFormField_uj5nz_2"><label className="_fieldLabel_uj5nz_17 standard-mandatory"> ยืนยันรหัสผ่านใหม่</label><input type="password" name="password" className="false standard-input  " placeholder="ยืนยันรหัสผ่านใหม่" defaultValue="" /><div className="_passwordEyes_197f3_1"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024" className=" standard-password-eye " width="1em" height="1em" id="" prefix=""><g className="AiOutlineEyeInvisible"><path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z"></path></g></svg></div></div></div><section className="transaction-button-section"><div className="standard-button-container "><button id="" className="standard-submit-button" disabled data-button-category="submit" type="submit"><span>ส่ง</span></button></div></section></div></form></div></section>
        );

      // ===== ประวัติ =====
      case 'transferHistory': {
        const { historylist, historyType, historyDateFrom, historyDateTo } = this.state;
        const filteredHistory = historyType === 'all'
          ? historylist
          : historylist.filter(item => item.type === historyType);
        return (
          <section className="st-detail-container history">
            <div className="st-tab">
              <div className="history-landing-container">

                {/* ── Filter controls ── */}
                <section className="history-control-section">
                  <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', padding: '12px 16px', background: '#fff', borderBottom: '1px solid #e5e7eb' }}>

                    {/* ประเภทการโอน */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 200 }}>
                      <label style={{ fontSize: 12, color: '#6b7280', fontWeight: 500 }}>ประเภทการโอน</label>
                      <select
                        className="standard-input"
                        style={{ height: 36, cursor: 'pointer', paddingRight: 8, border: '1px solid #d1d5db', borderRadius: 6 }}
                        value={historyType || 'all'}
                        onChange={(e) => this.setState({ historyType: e.target.value })}
                      >
                        <option value="all">ประวัติการเดิมพันทั้งหมด</option>
                        <option value="DE">ฝากเงิน</option>
                        <option value="WD">ถอนเงิน</option>
                        <option value="BN">โบนัส</option>
                      </select>
                    </div>

                    {/* จากวันที่ */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <label style={{ fontSize: 12, color: '#6b7280', fontWeight: 500 }}>จาก <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="date"
                        className="standard-input"
                        style={{ height: 36, cursor: 'pointer', border: '1px solid #d1d5db', borderRadius: 6, padding: '0 8px' }}
                        value={historyDateFrom || new Date().toISOString().split('T')[0]}
                        onChange={(e) => this.setState({ historyDateFrom: e.target.value })}
                      />
                    </div>

                    {/* ถึงวันที่ */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <label style={{ fontSize: 12, color: '#6b7280', fontWeight: 500 }}>ถึง <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="date"
                        className="standard-input"
                        style={{ height: 36, cursor: 'pointer', border: '1px solid #d1d5db', borderRadius: 6, padding: '0 8px' }}
                        value={historyDateTo || new Date().toISOString().split('T')[0]}
                        onChange={(e) => this.setState({ historyDateTo: e.target.value })}
                      />
                    </div>

                    {/* ปุ่มค้นหา */}
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                      <button
                        className="standard-submit-button"
                        style={{ height: 36, padding: '0 24px', cursor: 'pointer', borderRadius: 6, fontSize: 13 }}
                        onClick={() => this.calllisthistory(this.state.userid)}
                      >
                        ส่ง
                      </button>
                    </div>
                  </div>
                </section>

                {/* ── ตารางประวัติ ── */}
                <div style={{ padding: '0 0 16px', overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
                        <th style={{ padding: '10px 14px', textAlign: 'left', color: '#374151', fontWeight: 600, whiteSpace: 'nowrap' }}>ประเภท</th>
                        <th style={{ padding: '10px 14px', textAlign: 'left', color: '#374151', fontWeight: 600, whiteSpace: 'nowrap' }}>วันที่</th>
                        <th style={{ padding: '10px 14px', textAlign: 'right', color: '#374151', fontWeight: 600, whiteSpace: 'nowrap' }}>จำนวนเงิน</th>
                        <th style={{ padding: '10px 14px', textAlign: 'center', color: '#374151', fontWeight: 600, whiteSpace: 'nowrap' }}>สถานะ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredHistory.length === 0 ? (
                        <tr>
                          <td colSpan={4} style={{ padding: '24px', textAlign: 'center', color: '#9ca3af' }}>ยังไม่มีรายการ</td>
                        </tr>
                      ) : filteredHistory.map((item, i) => {
                        const isDeposit = item.type === 'DE';
                        const isBonus = item.type === 'BN';
                        const typeLabel = isBonus ? 'โบนัส' : isDeposit ? 'ฝากเงิน' : 'ถอนเงิน';
                        const amtColor = isDeposit || isBonus ? '#16a34a' : '#dc2626';
                        const statusLabel = item.status === '1' ? 'สำเร็จ' : item.status === '2' ? 'กำลังดำเนินการ' : item.status === '0' ? 'รอดำเนินการ' : item.status === '4' ? 'ยกเลิก' : 'ไม่สำเร็จ';
                        const statusColor = item.status === '1' ? '#16a34a' : item.status === '4' ? '#9ca3af' : '#f59e0b';
                        return (
                          <tr key={i} style={{ borderBottom: '1px solid #f3f4f6', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                            <td style={{ padding: '10px 14px', color: amtColor, fontWeight: 600 }}>{typeLabel}</td>
                            <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{moment(item.createdate).format('DD/MM/YY HH:mm')}</td>
                            <td style={{ padding: '10px 14px', textAlign: 'right', color: amtColor, fontWeight: 700 }}>{parseFloat(item.amount || 0).toFixed(2)}</td>
                            <td style={{ padding: '10px 14px', textAlign: 'center', color: statusColor, fontWeight: 600 }}>{statusLabel}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div style={{ padding: '8px 16px', color: '#6b7280', fontSize: 12 }}>
                  แสดง 1 - {filteredHistory.length} ของ {filteredHistory.length} รายการ
                </div>

              </div>
            </div>
          </section>
        );
      }
      // ===== ประวัติ (OLD STATIC — ลบออก) =====
      case '_transferHistory_old':
        return (
          <section className="st-detail-container history "><div className="st-tab  "><div className="history-landing-container "><section className="history-control-section"><div className="history-control-panel-container"><div className="standard-form-field history-type-field"><p className="title">ประเภทการโอน</p><div id="dropdownBtn" className="standard-select   "><span className="">ประวัติการเดิมพันทั้งหมด</span><span className="standard-select-arrow "></span></div></div><div className="standard-form-field history-type-field"><p className="title title-date">วันที่โอนเงิน</p><div id="dropdownBtn" className="standard-select   "><span className="">ในวันนี้</span><span className="standard-select-arrow "></span></div></div></div><div className="standard-setting-table-container history-container"><div className="standard-form history-form"><div className="standard-form-field-container  date-form-field-container"><p className="standard-label standard-mandatory">จาก</p><div className="standard-form-field"><div className="react-datepicker-wrapper"><div className="react-datepicker__input-container"><div className="standard-input">{this.state.historyDateFrom}<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 43.343" className="beta-calendar icon-calender" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-calendar .st0{fill:#004A98;}\n\t .beta-calendar .st1{fill:url(#beta-calendar-SVGID_1_);}\n\t .beta-calendar .st2{fill:url(#beta-calendar-SVGID_2_);}\n\t .beta-calendar .st3{fill:url(#beta-calendar-SVGID_3_);}\n\t .beta-calendar .st4{fill:url(#beta-calendar-SVGID_4_);}\n  " }} /><g className="beta-calendar"><g><g><g><path className="st0" d="M15.457,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425s-1.425-0.638-1.425-1.425V1.422C12.607,0.636,13.245,0,14.032,0S15.457,0.636,15.457,1.425"></path><path className="st0" d="M37.388,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425s-1.422-0.638-1.422-1.425V1.422C34.541,0.636,35.177,0,35.964,0S37.388,0.636,37.388,1.425"></path><path className="st0" d="M26.423,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425c-0.785,0-1.425-0.638-1.425-1.425V1.422c0-0.787,0.64-1.422,1.425-1.422C25.785,0,26.423,0.636,26.423,1.425"></path><path className="st0" d="M44.024,4.291H5.978c-3.298,0-5.979,2.871-5.979,6.402v24.746v1.803c0,3.553,3.153,6.1,5.979,6.1h38.046c3.294,0,5.977-2.873,5.977-6.404V10.693C50.001,7.163,47.317,4.291,44.024,4.291 M47.434,36.938c0,2.018-1.529,3.657-3.411,3.657H5.978c-1.884,0-3.415-1.639-3.415-3.657V17.117h44.871V36.938z M47.434,14.369H2.563v-3.676c0-2.016,1.531-3.655,3.415-3.655h38.046c1.882,0,3.411,1.639,3.411,3.655V14.369z"></path></g><g><linearGradient id="beta-calendar-SVGID_1_" gradientUnits="userSpaceOnUse" x1="-0.0013" y1="21.6712" x2="50.0008" y2="21.6712"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st1" d="M15.457,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425s-1.425-0.638-1.425-1.425V1.422C12.607,0.636,13.245,0,14.032,0S15.457,0.636,15.457,1.425"></path><linearGradient id="beta-calendar-SVGID_2_" gradientUnits="userSpaceOnUse" x1="-0.0013" y1="21.6712" x2="50.0008" y2="21.6712"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st2" d="M37.388,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425s-1.422-0.638-1.422-1.425V1.422C34.541,0.636,35.177,0,35.964,0S37.388,0.636,37.388,1.425"></path><linearGradient id="beta-calendar-SVGID_3_" gradientUnits="userSpaceOnUse" x1="-0.0013" y1="21.6712" x2="50.0008" y2="21.6712"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st3" d="M26.423,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425c-0.785,0-1.425-0.638-1.425-1.425V1.422c0-0.787,0.64-1.422,1.425-1.422C25.785,0,26.423,0.636,26.423,1.425"></path><linearGradient id="beta-calendar-SVGID_4_" gradientUnits="userSpaceOnUse" x1="-0.0013" y1="21.6712" x2="50.0008" y2="21.6712"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st4" d="M44.024,4.291H5.978c-3.298,0-5.979,2.871-5.979,6.402v24.746v1.803c0,3.553,3.153,6.1,5.979,6.1h38.046c3.294,0,5.977-2.873,5.977-6.404V10.693C50.001,7.163,47.317,4.291,44.024,4.291 M47.434,36.938c0,2.018-1.529,3.657-3.411,3.657H5.978c-1.884,0-3.415-1.639-3.415-3.657V17.117h44.871V36.938z M47.434,14.369H2.563v-3.676c0-2.016,1.531-3.655,3.415-3.655h38.046c1.882,0,3.411,1.639,3.411,3.655V14.369z"></path></g></g></g></g></svg></div></div></div></div></div><div className="standard-form-field-container  date-form-field-container"><p className="standard-label standard-mandatory">ถึง</p><div className="standard-form-field"><div className="react-datepicker-wrapper"><div className="react-datepicker__input-container"><div className="standard-input">{this.state.historyDateTo}<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 43.343" className="beta-calendar icon-calender" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-calendar .st0{fill:#004A98;}\n\t .beta-calendar .st1{fill:url(#beta-calendar-SVGID_1_);}\n\t .beta-calendar .st2{fill:url(#beta-calendar-SVGID_2_);}\n\t .beta-calendar .st3{fill:url(#beta-calendar-SVGID_3_);}\n\t .beta-calendar .st4{fill:url(#beta-calendar-SVGID_4_);}\n  " }} /><g className="beta-calendar"><g><g><g><path className="st0" d="M15.457,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425s-1.425-0.638-1.425-1.425V1.422C12.607,0.636,13.245,0,14.032,0S15.457,0.636,15.457,1.425"></path><path className="st0" d="M37.388,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425s-1.422-0.638-1.422-1.425V1.422C34.541,0.636,35.177,0,35.964,0S37.388,0.636,37.388,1.425"></path><path className="st0" d="M26.423,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425c-0.785,0-1.425-0.638-1.425-1.425V1.422c0-0.787,0.64-1.422,1.425-1.422C25.785,0,26.423,0.636,26.423,1.425"></path><path className="st0" d="M44.024,4.291H5.978c-3.298,0-5.979,2.871-5.979,6.402v24.746v1.803c0,3.553,3.153,6.1,5.979,6.1h38.046c3.294,0,5.977-2.873,5.977-6.404V10.693C50.001,7.163,47.317,4.291,44.024,4.291 M47.434,36.938c0,2.018-1.529,3.657-3.411,3.657H5.978c-1.884,0-3.415-1.639-3.415-3.657V17.117h44.871V36.938z M47.434,14.369H2.563v-3.676c0-2.016,1.531-3.655,3.415-3.655h38.046c1.882,0,3.411,1.639,3.411,3.655V14.369z"></path></g><g><linearGradient id="beta-calendar-SVGID_1_" gradientUnits="userSpaceOnUse" x1="-0.0013" y1="21.6712" x2="50.0008" y2="21.6712"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st1" d="M15.457,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425s-1.425-0.638-1.425-1.425V1.422C12.607,0.636,13.245,0,14.032,0S15.457,0.636,15.457,1.425"></path><linearGradient id="beta-calendar-SVGID_2_" gradientUnits="userSpaceOnUse" x1="-0.0013" y1="21.6712" x2="50.0008" y2="21.6712"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st2" d="M37.388,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425s-1.422-0.638-1.422-1.425V1.422C34.541,0.636,35.177,0,35.964,0S37.388,0.636,37.388,1.425"></path><linearGradient id="beta-calendar-SVGID_3_" gradientUnits="userSpaceOnUse" x1="-0.0013" y1="21.6712" x2="50.0008" y2="21.6712"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st3" d="M26.423,1.425v8.484c0,0.787-0.638,1.425-1.425,1.425c-0.785,0-1.425-0.638-1.425-1.425V1.422c0-0.787,0.64-1.422,1.425-1.422C25.785,0,26.423,0.636,26.423,1.425"></path><linearGradient id="beta-calendar-SVGID_4_" gradientUnits="userSpaceOnUse" x1="-0.0013" y1="21.6712" x2="50.0008" y2="21.6712"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }}></stop><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }}></stop></linearGradient><path className="st4" d="M44.024,4.291H5.978c-3.298,0-5.979,2.871-5.979,6.402v24.746v1.803c0,3.553,3.153,6.1,5.979,6.1h38.046c3.294,0,5.977-2.873,5.977-6.404V10.693C50.001,7.163,47.317,4.291,44.024,4.291 M47.434,36.938c0,2.018-1.529,3.657-3.411,3.657H5.978c-1.884,0-3.415-1.639-3.415-3.657V17.117h44.871V36.938z M47.434,14.369H2.563v-3.676c0-2.016,1.531-3.655,3.415-3.655h38.046c1.882,0,3.411,1.639,3.411,3.655V14.369z"></path></g></g></g></g></svg></div></div></div></div></div></div><section className="transaction-button-section"><div className="standard-button-container "><button id="" className="standard-submit-button" data-button-category="submit" type="submit" onClick={() => this.calllisthistory(this.state.userid)}><span>ส่ง</span></button></div></section></div></section><div className="standard-setting-table-container history-info-container"><div className="standard-setting-table-header header-title"><span className="col-game-provider">ประเภท</span><span className="col-bet-count">วันที่</span><span className="col-bet-amount">จำนวนเงิน</span><span className="col-valid-bet-amount">สถานะ</span><span className="col-bonus-turnover"></span><span className="col-turnover-without-bonus"></span><span className="col-total-bonus"></span><span className="col-total-rebate"></span></div><div className="history-info-content">{this.state.historylist.length === 0 ? (<div className="no-content-container no-msg-container"><span>ยังไม่มีรายการ</span></div>) : this.state.historylist.map((item, i) => (<div key={i} className="history-info-row"><span className={"col-game-provider " + (item.type === 'DE' ? 'text-success' : 'text-danger')}>{item.type === 'BN' ? 'โบนัส' : item.type === 'DE' ? 'ฝากเงิน' : 'ถอนเงิน'}</span><span className="col-bet-count">{moment(item.createdate).format('DD/MM/YY HH:mm')}</span><span className={"col-bet-amount " + (item.type === 'DE' ? 'text-success' : 'text-danger')}>{item.amount}</span><span className="col-valid-bet-amount">{item.status === '1' ? 'สำเร็จ' : item.status === '2' ? 'กำลังดำเนินการ' : item.status === '0' ? 'รอดำเนินการ' : item.status === '4' ? 'ยกเลิก' : 'ไม่สำเร็จ'}</span><span className="col-bonus-turnover"></span><span className="col-turnover-without-bonus"></span><span className="col-total-bonus"></span><span className="col-total-rebate"></span></div>))}</div></div><div className="pagination-content"><p className="page-count">แสดง 1 -  ของ  รายการ.</p><ul className="pagination"><li className="page-item disabled"><a className="arrow-icon" href="#" aria-label="Go to first page"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 48.396" className="" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-double-arrow-left .st0{fill:#8899A4;}\n  " }} /><g className="beta-double-arrow-left"><g><g><path className="st0" d="M45.703,48.396c-1.094,0-2.193-0.421-3.03-1.257L23.679,28.145c-1.06-1.056-1.635-2.459-1.635-3.948c0-1.493,0.584-2.892,1.639-3.944l18.99-18.994c1.674-1.678,4.39-1.678,6.068,0c1.678,1.678,1.678,4.399,0,6.072L31.876,24.197l16.866,16.866c1.678,1.678,1.678,4.394,0,6.077C47.905,47.975,46.806,48.396,45.703,48.396L45.703,48.396z"></path><path className="st0" d="M23.659,48.396c-1.094,0-2.193-0.421-3.03-1.257L1.635,28.145C0.575,27.089,0,25.686,0,24.197c0-1.493,0.584-2.892,1.639-3.944l18.99-18.994c1.674-1.678,4.39-1.678,6.068,0c1.678,1.678,1.678,4.399,0,6.072L9.832,24.197l16.866,16.866c1.678,1.678,1.678,4.394,0,6.077C25.86,47.975,24.762,48.396,23.659,48.396L23.659,48.396z"></path></g></g></g></svg></a></li><li className="page-item disabled"><a className="arrow-icon" href="#" aria-label="Go to previous page"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 86.559" className="" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-arrow-left .st0{fill:#8899A4;}\n  " }} /><g className="beta-arrow-left"><g><path className="st0" d="M42.315,86.559c-1.958,0-3.922-0.752-5.419-2.249L2.924,50.338C1.029,48.45,0,45.94,0,43.277c0-2.671,1.044-5.173,2.932-7.054L36.896,2.251c2.993-3.001,7.852-3.001,10.853,0c3.001,3.001,3.001,7.868,0,10.861L17.585,43.277l30.165,30.165c3.001,3.001,3.001,7.86,0,10.868C46.252,85.807,44.288,86.559,42.315,86.559L42.315,86.559z"></path></g></g></svg></a></li><li className="page-item active"><a className="arrow-icon undefined" href="#" aria-label="Go to page number 1">1</a></li><li className="page-item disabled"><a className="arrow-icon" href="#" aria-label="Go to next page"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 86.559" className="" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-arrow-right .st0{fill:#8899A4;}\n  " }} /><g className="beta-arrow-right"><g><path className="st0" d="M7.685,0c1.958,0,3.922,0.752,5.419,2.249l33.972,33.972C48.972,38.109,50,40.619,50,43.282c0,2.671-1.044,5.173-2.932,7.054L13.104,84.308c-2.993,3.001-7.852,3.001-10.853,0c-3.001-3.001-3.001-7.868,0-10.861l30.165-30.165L2.251,13.117c-3.001-3.001-3.001-7.86,0-10.868C3.748,0.752,5.712,0,7.685,0L7.685,0z"></path></g></g></svg></a></li><li className="page-item disabled"><a className="arrow-icon" href="#" aria-label="Go to last page"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 48.396" className="" width="100%" height="100%" id="" prefix=""><style dangerouslySetInnerHTML={{ __html: "\n.beta-double-arrow-right .st0{fill:#8899A4;}\n  " }} /><g className="beta-double-arrow-right"><g><g><path className="st0" d="M4.297,0c1.094,0,2.193,0.421,3.03,1.257l18.994,18.994c1.06,1.056,1.635,2.459,1.635,3.948c0,1.493-0.584,2.892-1.639,3.944L7.326,47.138c-1.674,1.678-4.39,1.678-6.068,0c-1.678-1.678-1.678-4.399,0-6.072L18.124,24.2L1.258,7.334c-1.678-1.678-1.678-4.394,0-6.077C2.095,0.421,3.194,0,4.297,0L4.297,0z"></path><path className="st0" d="M26.341,0c1.094,0,2.193,0.421,3.03,1.257l18.994,18.994C49.425,21.307,50,22.71,50,24.2c0,1.493-0.584,2.892-1.639,3.944l-18.99,18.994c-1.674,1.678-4.39,1.678-6.068,0c-1.678-1.678-1.678-4.399,0-6.072L40.168,24.2L23.303,7.334c-1.678-1.678-1.678-4.394,0-6.077C24.14,0.421,25.238,0,26.341,0L26.341,0z"></path></g></g></g></svg></a></li></ul></div></div></div></section>
        );

      default:
        return null;
    }
  }

  renderDepositContent() {
    const { depositTab, depositamount, mainacc, qrcode, depositstate, limit, historylist, qrSelectedBank } = this.state;
console.log('renderDepositContent', this.state.mainacc); 
    // ---- clock SVG (ใช้ซ้ำ) ----
    const clockSVG = (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 50" className="" width="100%" height="100%" id="" prefix="">
        <style dangerouslySetInnerHTML={{ __html: "\n.beta-time .st0{fill:#FFFFFF;}\n  " }} />
        <g className="beta-time"><g><g>
          <path className="st0" d="M2,23.65158c0.1175-0.87102,0.19916-1.74864,0.3582-2.612c1.1885-6.45181,4.53026-11.51159,9.94045-15.19425 c3.12622-2.12799,6.60665-3.34789,10.36359-3.72999c3.53803-0.35984,6.98579,0.0968,10.32738,1.32413 c2.23645,0.82142,4.28395,1.98315,6.17352,3.42953c0.77756,0.59519,1.04475,1.45981,0.70655,2.30254 c-0.32626,0.81299-1.11409,1.31346-2.0078,1.16727c-0.39272-0.06424-0.79627-0.26959-1.12037-0.51095 c-1.57022-1.16938-3.24706-2.13469-5.08684-2.81195c-2.93472-1.08032-5.95841-1.40826-9.05486-1.03026 c-3.64452,0.4449-6.89575,1.85869-9.71448,4.19108c-3.59903,2.97807-5.89846,6.77189-6.73211,11.38651 c-0.77844,4.309-0.20764,8.46179,1.88919,12.31697c2.97153,5.46339,7.52628,8.87722,13.67674,9.98228 c5.02639,0.90311,9.72781-0.09441,13.94996-2.96727c4.47654-3.04596,7.26182-7.26511,8.20888-12.62465 c0.69103-3.91062,0.18037-7.68375-1.44854-11.31205c-0.19428-0.43274-0.32899-0.9507-0.29488-1.41471 c0.06151-0.83694,0.7527-1.47695,1.53258-1.59702c0.90474-0.1393,1.72884,0.25099,2.08213,1.12539 c0.55323,1.36923,1.14592,2.74019,1.51273,4.16429c2.95651,11.47819-3.20293,23.21241-14.31344,27.34687 c-2.00207,0.74501-4.07021,1.19953-6.2043,1.34409c-0.13172,0.00891-0.26123,0.05036-0.39177,0.07667 c-0.89862,0-1.79723,0-2.69585,0c-0.11555-0.02539-0.23003-0.06578-0.34679-0.07401 c-3.5829-0.25267-6.93555-1.27527-9.99791-3.1431c-5.98343-3.6495-9.66006-8.92505-10.95368-15.82955 C2.19675,28.09532,2.11742,27.21781,2,26.34743C2,25.44881,2,24.5502,2,23.65158z" />
          <path className="st0" d="M26.91534,23.08875c0.2366,0,0.4121-0.00001,0.58761,0c2.30527,0.0001,4.61057,0.00579,6.91581-0.00281 c0.77932-0.00291,1.40857,0.26281,1.81262,0.9453c0.76842,1.29793-0.14344,2.85426-1.70533,2.87173 c-2.18525,0.02444-4.37096,0.00696-6.55648,0.00725c-0.94307,0.00012-1.88624,0.00877-2.82917-0.00249 c-1.27536-0.01521-2.04057-0.77013-2.04301-2.04651c-0.00838-4.38599-0.00785-8.77202,0.00019-13.15801 c0.00207-1.13007,0.65748-1.88282,1.70136-2.01426c0.92218-0.11612,1.79491,0.46277,2.03776,1.38416 c0.07105,0.26958,0.07516,0.56213,0.07554,0.8442c0.00472,3.51778,0.0031,7.03557,0.00311,10.55336 C26.91535,22.64898,26.91534,22.82731,26.91534,23.08875z" />
        </g></g></g>
      </svg>
    );

    // ---- amount quick-select buttons (shared) ----
    const amountButtons = (amounts) => amounts.map((amt) => (
      <button key={amt} type="button" className="standard-submit-form-button amount-btn"
        onClick={(e) => this.handleClickdeposit(e, amt)}>
        {amt.toLocaleString()}
      </button>
    ));

    // ---- recent transaction table (shared) ----
    const recentTable = (
      <div className="recent-transaction">
        <div className="_recentTransactionContainer_yt0gb_1 recent-transaction-container">
          <div className="_dropdownTitle_uxqg3_1 recent-transaction-title">
            ธุรกรรมล่าสุดของฉัน
            <div id="dropdown-arrow" className="_dropdownArrow_uxqg3_21 ">
              {this.renderDropdownArrow()}
            </div>
          </div>
          <div id="recent-transaction-table-container" className="_recentTransactionTableContainer_yt0gb_5 ">
            <table className="_recentTransactionTable_yt0gb_5 recent-transaction-table">
              <thead>
                <tr className="_recentTransactionRow_yt0gb_14 recent-transaction-row">
                  <th>วันที่โอนเงิน</th>
                  <th>จำนวนเงิน</th>
                  <th>วิธี</th>
                  <th>สถานะ</th>
                </tr>
              </thead>
              <tbody>
                {historylist.length === 0 ? (
                  <tr className="_emptyRecord_yt0gb_39 empty-record">
                    <td colSpan={4}>ยังไม่มีรายการ</td>
                  </tr>
                ) : historylist.filter(x => x.type === 'DE').slice(0, 5).map((item, i) => (
                  <tr key={i} className="_recentTransactionRow_yt0gb_14 recent-transaction-row">
                    <td>{moment(item.createdate).format('DD/MM/YY HH:mm')}</td>
                    <td className="text-success">{item.amount}</td>
                    <td>ฝากเงิน</td>
                    <td>{item.status === '1' ? 'สำเร็จ' : item.status === '2' ? 'กำลังดำเนินการ' : item.status === '0' ? 'รอดำเนินการ' : item.status === '4' ? 'ยกเลิก' : 'ไม่สำเร็จ'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="_viewMore_yt0gb_43 view-more" style={{ cursor: 'pointer' }}
              onClick={() => this.setActiveTab('transferHistory', 'history')}>
              <span>อ่านเพิ่มเติม </span>
            </div>
          </div>
        </div>
      </div>
    );

    // ---- "ปรับปรุงก่อน" state UI ----
    const updatingUI = (
      <div className="standard-transaction-container pk-loading" style={{ textAlign: 'center', padding: '30px 12px' }}>
        <style>{`
          @keyframes pk-spin { to { transform: rotate(360deg); } }
          .pk-loading .pk-spinner { width: 40px; height: 40px; border: 4px solid #e3e9f0; border-top-color: #0071E3; border-radius: 50%; animation: pk-spin .8s linear infinite; margin: 0 auto 14px; box-sizing: border-box; }
          .pk-loading .pk-l-title { font-size: 16px !important; font-weight: 700 !important; color: #0071E3 !important; margin: 0 !important; }
          .pk-loading .pk-l-desc { font-size: 13px !important; color: #8697a2 !important; margin-top: 5px !important; }
        `}</style>
        <div className="pk-spinner" />
        <div className="pk-l-title">กำลังดำเนินการ</div>
        <div className="pk-l-desc">กำลังสร้างรายการชำระเงิน กรุณารอสักครู่...</div>
      </div>
    );

    return (
      <section className="st-detail-container deposit st-detail-deposit-container">
        <style dangerouslySetInnerHTML={{ __html: "\n.deposit-bank-card{background:rgba(255,255,255,0.05);border:1px solid rgba(0,113,227,0.3);border-radius:10px;padding:12px 14px;margin-bottom:12px;box-sizing:border-box;width:100%;}\n.deposit-bank-card .dbc-header{display:flex;align-items:center;gap:8px;margin-bottom:8px;}\n.deposit-bank-card .dbc-header img{width:28px;height:28px;border-radius:50%;object-fit:cover;flex-shrink:0;}\n.deposit-bank-card .dbc-bankname{font-size:13px;font-weight:600;}\n.deposit-bank-card .dbc-row{display:flex;align-items:center;justify-content:space-between;gap:6px;padding:5px 0;border-top:1px solid rgba(255,255,255,0.07);}\n.deposit-bank-card .dbc-label{font-size:11px;color:#8697a2;min-width:60px;flex-shrink:0;}\n.deposit-bank-card .dbc-value{font-size:13px;font-weight:600;flex:1;word-break:break-all;}\n.deposit-bank-card .dbc-accnum{font-size:15px;font-weight:700;letter-spacing:1.5px;flex:1;}\n.deposit-bank-card .dbc-copy-btn{background:#0071E3;color:#fff;border:none;border-radius:5px;padding:3px 10px;font-size:11px;cursor:pointer;flex-shrink:0;}\n.deposit-bank-card .dbc-copy-btn:hover{opacity:0.85;}\n.deposit-equal-btns{display:flex;gap:8px;width:100%;}\n.deposit-equal-btns .standard-submit-button,.deposit-equal-btns label.standard-submit-form-button{flex:1 1 0;min-width:0;box-sizing:border-box;display:flex;align-items:center;justify-content:center;margin:0;cursor:pointer;text-align:center;}\n.standard-amount-btn-container{display:flex;flex-wrap:wrap;gap:6px;margin:6px 0;}\n.standard-amount-btn-container .amount-btn{flex:1 1 50px;min-width:44px;box-sizing:border-box;}\n@media(max-width:600px){.deposit-bank-card .dbc-accnum{font-size:13px;letter-spacing:0.5px;}.deposit-equal-btns{flex-direction:column;}.deposit-equal-btns .standard-submit-button,.deposit-equal-btns label.standard-submit-form-button{width:100%;flex:unset;}}\n" }} />
        <div className="st-tab with-notice ">
          <div id="beta-deposit-landing" style={{}}>
            {/* ===== Tab header ===== */}
            <div className="deposit-tab-header" id="deposit-tab-header">
              <div className="_tabHeaderContainer_9c2z1_1 tab-header-container" id="deposit-tab-header-container">
                {/* Tab 1: ฝาก Payment */}
                <div
                  className={`_tabHeaderTitle_1ivtf_1 tab-header-title${depositTab === 'qr' ? ' _active_1ivtf_22' : ''}`}
                  onClick={() => this.setState({ depositTab: 'qr', depositstate: 0, qrcode: null, qrSelectedBank: null })}
                  style={{ cursor: 'pointer' }}
                  id={depositTab === 'qr' ? 'tab_header_active' : ''}
                >
                  <span className="_titleContent_1ivtf_35">ฝาก Payment </span>
                  <div>{clockSVG}</div>
                  <span className="_titleContent_1ivtf_35"> 5 นาที</span>
                </div>
                {/* Tab 2: ฝากปกติ */}
                <div
                  className={`_tabHeaderTitle_1ivtf_1 tab-header-title${depositTab === 'bank' ? ' _active_1ivtf_22' : ''}`}
                  onClick={() => this.setState({ depositTab: 'bank', depositstate: 0, qrcode: null })}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="_titleContent_1ivtf_35">ฝากปกติ </span>
                  <div>{clockSVG}</div>
                  <span className="_titleContent_1ivtf_35"> 1-5 นาที</span>
                </div>
                {/* Tab 3: อัพโหลดสลิป */}
                <div
                  className={`_tabHeaderTitle_1ivtf_1 tab-header-title${depositTab === 'slip' ? ' _active_1ivtf_22' : ''}`}
                  onClick={() => this.setState({ depositTab: 'slip', depositstate: 0, qrcode: null })}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="_titleContent_1ivtf_35">อัพโหลดสลิป</span>
                </div>
              </div>
            </div>

            <div className="deposit-wrapper">

              {/* ===================================================
                  TAB 1 : QR ฝากด่วน
              =================================================== */}
              {depositTab === 'qr' && (
                depositstate === 1 ? updatingUI : qrcode ? (() => {
                  const link = this.state.paymentLink;
                  const info = this.state.paymentInfo || {};
                  const isRedirect = link && /^https?:\/\//.test(link);
                  const isImg = qrcode && (qrcode.startsWith('data:') || (/\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(qrcode) && !/process\/deposit/i.test(qrcode)));
                  return (
                    <div className="standard-transaction-container qr-display-container" style={{ textAlign: 'center', padding: '1.5rem' }}>
                      {(isRedirect && !isImg) ? (
                        <>
                          <div style={{ fontSize: 40, marginBottom: 6 }}>⏳</div>
                          <div style={{ fontSize: 18, fontWeight: 700, color: '#f59e0b' }}>รอดำเนินการ</div>
                          <div style={{ fontSize: 13, color: this.state.counter > 0 ? '#8697a2' : '#dc2626', marginTop: 4 }}>
                            {this.state.counter > 0
                              ? `กรุณาดำเนินการชำระเงินภายใน ${Math.floor(this.state.counter / 60)}:${('0' + (this.state.counter % 60)).slice(-2)} นาที`
                              : 'หมดเวลาทำรายการ กรุณาดำเนินการใหม่'}
                          </div>
                          <div style={{ background: '#f7f9fb', border: '1px solid #eef1f4', borderRadius: 10, padding: '12px 16px', margin: '16px auto 0', maxWidth: 340, textAlign: 'left', fontSize: 13 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 0', borderBottom: '1px solid #eef1f4' }}>
                              <span style={{ color: '#8697a2' }}>จำนวนเงิน</span>
                              <span style={{ fontWeight: 800, color: '#0071E3', fontSize: 24, lineHeight: 1.1 }}>฿ {info.Amount || info.trueamount || this.state.depositamount}</span>
                            </div>
                            {info.orderid && (
                              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '5px 0', borderBottom: '1px solid #eef1f4' }}>
                                <span style={{ color: '#8697a2', flex: '0 0 auto' }}>เลขที่รายการ</span>
                                <span style={{ fontSize: 11, wordBreak: 'break-all', textAlign: 'right' }}>{info.orderid}</span>
                              </div>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0' }}>
                              <span style={{ color: '#8697a2' }}>สถานะ</span>
                              <span style={{ color: '#f59e0b', fontWeight: 600 }}>รอดำเนินการ</span>
                            </div>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center', marginTop: 16 }}>
                            <button disabled={this.state.balanceReloading} onClick={this.handleTransferDone}
                              style={{ background: 'linear-gradient(135deg,#16a34a,#22c55e)', color: '#fff', border: 'none', borderRadius: 8, padding: '11px 30px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', opacity: this.state.balanceReloading ? 0.6 : 1 }}>
                              {this.state.balanceReloading ? '⏳ กำลังตรวจสอบยอด...' : '✅ โอนเสร็จสิ้น'}
                            </button>
                            {this.state.counter > 0 ? (
                              <button onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
                                style={{ background: 'linear-gradient(135deg,#0a5ebd,#04a9c2)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 26px', fontSize: 13.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                                🔗 เปิดลิงก์ชำระเงินอีกครั้ง
                              </button>
                            ) : (
                              <button onClick={() => this.setState({ depositstate: 0, qrcode: null, qrSelectedBank: null, paymentLink: null, paymentInfo: null })}
                                style={{ background: 'linear-gradient(135deg,#ff9a00,#ff6a00)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 26px', fontSize: 13.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                                🔄 ดำเนินการใหม่อีกครั้ง
                              </button>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ marginBottom: 10, fontWeight: 700, fontSize: 13.5, color: '#1a2540' }}>สแกน QR เพื่อชำระเงิน</div>
                          <img src={qrcode} alt="QR Code" style={{ maxWidth: 150, width: '100%', border: '3px solid #0071E3', borderRadius: 10 }} />
                          <div style={{ marginTop: 8, color: '#8697a2', fontSize: 11 }}>กรุณาสแกนภายใน {Math.floor(this.state.counter / 60)}:{('0' + (this.state.counter % 60)).slice(-2)} นาที</div>
                        </>
                      )}
                      <div style={{ background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 10, padding: '10px 14px', margin: '16px auto 0', maxWidth: 360, textAlign: 'left', fontSize: 12, color: '#9a3412', lineHeight: 1.6 }}>
                        ⚠ <b>ห้ามใช้ QR / ลิงก์นี้ซ้ำ</b> — กรุณาชำระเงินและอัพโหลดสลิปในหน้าชำระเงินภายใน <b>10 นาที</b> เพื่อให้ระบบเติมเงินอัตโนมัติ
                      </div>
                      <div style={{ marginTop: 16 }}>
                        <button type="button" style={{ background: 'linear-gradient(135deg,#ff9a00,#ff6a00)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 30px', fontSize: 13.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
                          onClick={() => this.setState({ depositstate: 0, qrcode: null, qrSelectedBank: null, paymentLink: null, paymentInfo: null })}>
                          กลับ
                        </button>
                      </div>
                    </div>
                  );
                })() : (
                  /* QR deposit form */
                  <div>
                    {/* ---- ตัวเลือกฝากเงิน (QR method card) ---- */}
                    <div className="standard-tab-container st-icon-text-tab deposit-tab-container">
                      <div className="deposit-tab-header">
                        <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">
                          ตัวเลือกฝากเงิน
                          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 90 90" className="transaction-title-icon" width="100%" height="100%" id="" prefix="">
                            <g className="D-referral-important">
                              <path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" />
                            </g>
                          </svg>
                        </label>
                        <div className="deposit-tab-header-right-content">
                          <div className="reTrigger_step_button" id="needHelpBtn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 0 36 36" version="1.1">
                              <g id="surface1">
                                <path d="M 18.191406 0.164062 C 8.378906 0.164062 0.378906 7.667969 0.378906 16.90625 C 0.378906 19.964844 1.257812 22.949219 2.933594 25.542969 L 3.054688 25.75 L -0.00390625 34.285156 L 9.378906 31.460938 L 9.578125 31.5625 C 12.191406 32.933594 15.175781 33.644531 18.191406 33.644531 C 28.019531 33.644531 36 26.140625 36 16.90625 C 36 7.667969 28.019531 0.164062 18.191406 0.164062 Z M 17.976562 26.113281 C 17.207031 26.113281 16.589844 25.53125 16.589844 24.800781 C 16.589844 24.074219 17.207031 23.488281 17.976562 23.488281 C 18.742188 23.488281 19.359375 24.074219 19.359375 24.800781 C 19.359375 25.53125 18.742188 26.113281 17.976562 26.113281 Z M 23.789062 13.714844 C 23.480469 14.585938 22.773438 15.140625 21.3125 16.699219 C 20.160156 17.925781 19.144531 18.871094 19.066406 20.460938 C 19.035156 21.160156 18.621094 21.65625 17.789062 21.582031 C 17.050781 21.523438 16.730469 20.851562 16.730469 20.226562 C 16.730469 18.070312 17.730469 16.976562 18.789062 15.855469 C 20.175781 14.398438 21.3125 13.65625 21.359375 12.5625 C 21.40625 11.324219 20.449219 10.203125 18.390625 10.085938 C 16.359375 9.984375 14.636719 11.238281 14.390625 13.101562 C 14.300781 13.726562 13.808594 14.195312 13.128906 14.136719 C 12.46875 14.078125 11.945312 13.523438 11.976562 12.882812 C 12.285156 9.75 15.113281 7.726562 18.480469 7.898438 C 22.171875 8.074219 24.757812 10.914062 23.789062 13.699219 Z M 23.789062 13.714844 " />
                              </g>
                            </svg>
                            <span>รหัสผ่านไม่สามารถเหมือนกับชื่อผู้ใช้ของคุณได้</span>
                          </div>
                        </div>
                      </div>
                      <div className="deposit-option-container" id="deposit-option-container">
                        <div className="standard-tab transaction-option" id="transaction-option">
                          <div>
                            <div className="_transactionOptionTabHeader_ktmyr_1 transaction-option-tab-header _active_ktmyr_44" data-tutorialkey-selected="QR" data-tutorialkey="QR">
                              <div className="_transactionOptionImageContainer_ktmyr_30 transaction-option-image-container image-container">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 18.6 17.5" className="beta-option-QR" width="100%" height="100%" id="" prefix="">
                                  <style dangerouslySetInnerHTML={{ __html: "\n.beta-option-QR .st0{fill:#004A98;}\n\t .beta-option-QR .st1{fill:url(#beta-option-QR-SVGID_1_);}\n\t .beta-option-QR .st2{fill:url(#beta-option-QR-SVGID_2_);}\n\t .beta-option-QR .st3{fill:url(#beta-option-QR-SVGID_3_);}\n\t .beta-option-QR .st4{fill:url(#beta-option-QR-SVGID_4_);}\n\t .beta-option-QR .st5{fill:url(#beta-option-QR-SVGID_5_);}\n\t .beta-option-QR .st6{fill:url(#beta-option-QR-SVGID_6_);}\n\t .beta-option-QR .st7{fill:url(#beta-option-QR-SVGID_7_);}\n\t .beta-option-QR .st8{fill:url(#beta-option-QR-SVGID_8_);}\n\t .beta-option-QR .st9{fill:url(#beta-option-QR-SVGID_9_);}\n\t .beta-option-QR .st10{fill:url(#beta-option-QR-SVGID_10_);}\n\t .beta-option-QR .st11{fill:url(#beta-option-QR-SVGID_11_);}\n\t .beta-option-QR .st12{fill:url(#beta-option-QR-SVGID_12_);}\n\t .beta-option-QR .st13{fill:url(#beta-option-QR-SVGID_13_);}\n\t .beta-option-QR .st14{fill:url(#beta-option-QR-SVGID_14_);}\n\t .beta-option-QR .st15{fill:url(#beta-option-QR-SVGID_15_);}\n\t .beta-option-QR .st16{fill:url(#beta-option-QR-SVGID_16_);}\n\t .beta-option-QR .st17{fill:url(#beta-option-QR-SVGID_17_);}\n\t .beta-option-QR .st18{fill:url(#beta-option-QR-SVGID_18_);}\n\t .beta-option-QR .st19{fill:url(#beta-option-QR-SVGID_19_);}\n\t .beta-option-QR .st20{fill:url(#beta-option-QR-SVGID_20_);}\n  " }} />
                                  <g className="beta-option-QR"><g><g><g>
                                    <path className="st0" d="M4.9,5.5H0.5C0.2,5.5,0,5.2,0,4.9V0.5C0,0.2,0.2,0,0.5,0h4.4c0.3,0,0.5,0.2,0.5,0.5v4.4 C5.5,5.2,5.2,5.5,4.9,5.5z M1.1,4.4h3.3V1.1H1.1V4.4z" />
                                    <path className="st0" d="M4.9,17.5H0.5C0.2,17.5,0,17.3,0,17v-4.4C0,12.3,0.2,12,0.5,12h4.4c0.3,0,0.5,0.2,0.5,0.5V17 C5.5,17.3,5.2,17.5,4.9,17.5z M1.1,16.4h3.3v-3.3H1.1V16.4z" />
                                    <path className="st0" d="M18.1,5.5h-4.4c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5h4.4c0.3,0,0.5,0.2,0.5,0.5v4.4 C18.6,5.2,18.4,5.5,18.1,5.5z M14.2,4.4h3.3V1.1h-3.3V4.4z" />
                                    <path className="st0" d="M2.2,2.2h1.1v1.1H2.2V2.2z" /><path className="st0" d="M2.2,14.2h1.1v1.1H2.2V14.2z" />
                                    <path className="st0" d="M15.3,2.2h1.1v1.1h-1.1V2.2z" />
                                    <path className="st0" d="M18.1,17.5h-3.8v-1.1h3.3v-1.6H12v-1.1h6c0.3,0,0.5,0.2,0.5,0.5V17C18.6,17.3,18.4,17.5,18.1,17.5z" />
                                    <path className="st0" d="M9.9,13.7h1.1v3.8H9.9V13.7z" /><path className="st0" d="M12,16.4h1.1v1.1H12V16.4z" />
                                    <path className="st0" d="M12,3.8h-1.1V1.1H9.9v2.2c0,0.3-0.2,0.5-0.5,0.5H7.1c-0.3,0-0.5-0.2-0.5-0.5V0h1.1v2.7h1.1V0.5 C8.8,0.2,9,0,9.3,0h2.2C11.8,0,12,0.2,12,0.5V3.8z" />
                                    <path className="st0" d="M18.6,9.9h-7.1c-0.3,0-0.5-0.2-0.5-0.5V5.5H12v3.3h6.6V9.9z" />
                                    <path className="st0" d="M7.1,7.7H4.9V6.6h1.6V5.5h1.1v1.6C7.7,7.4,7.4,7.7,7.1,7.7z" />
                                    <path className="st0" d="M0,6.6h1.6v1.1H0V6.6z" /><path className="st0" d="M2.7,6.6h1.1v1.1H2.7V6.6z" />
                                    <path className="st0" d="M17.5,6.6h1.1v1.1h-1.1V6.6z" /><path className="st0" d="M13.1,6.6h3.3v1.1h-3.3V6.6z" />
                                    <path className="st0" d="M8.2,17.5H7.1V12c0-0.3,0.2-0.5,0.5-0.5h10.9v1.1H8.2V17.5z" />
                                    <path className="st0" d="M8.8,5.5h1.1v2.7H8.8V5.5z" />
                                    <path className="st0" d="M6.6,10.9H5.5V9.9H0V8.8h6c0.3,0,0.5,0.2,0.5,0.5V10.9z" />
                                    <path className="st0" d="M8.8,9.3h1.1v1.1H8.8V9.3z" />
                                  </g><g>
                                      <linearGradient id="beta-option-QR-SVGID_1_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st1" d="M4.9,5.5H0.5C0.2,5.5,0,5.2,0,4.9V0.5C0,0.2,0.2,0,0.5,0h4.4c0.3,0,0.5,0.2,0.5,0.5v4.4 C5.5,5.2,5.2,5.5,4.9,5.5z M1.1,4.4h3.3V1.1H1.1V4.4z" />
                                      <linearGradient id="beta-option-QR-SVGID_2_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st2" d="M4.9,17.5H0.5C0.2,17.5,0,17.3,0,17v-4.4C0,12.3,0.2,12,0.5,12h4.4c0.3,0,0.5,0.2,0.5,0.5V17 C5.5,17.3,5.2,17.5,4.9,17.5z M1.1,16.4h3.3v-3.3H1.1V16.4z" />
                                      <linearGradient id="beta-option-QR-SVGID_3_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st3" d="M18.1,5.5h-4.4c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5h4.4c0.3,0,0.5,0.2,0.5,0.5v4.4 C18.6,5.2,18.4,5.5,18.1,5.5z M14.2,4.4h3.3V1.1h-3.3V4.4z" />
                                      <linearGradient id="beta-option-QR-SVGID_4_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st4" d="M2.2,2.2h1.1v1.1H2.2V2.2z" />
                                      <linearGradient id="beta-option-QR-SVGID_5_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st5" d="M2.2,14.2h1.1v1.1H2.2V14.2z" />
                                      <linearGradient id="beta-option-QR-SVGID_6_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st6" d="M15.3,2.2h1.1v1.1h-1.1V2.2z" />
                                      <linearGradient id="beta-option-QR-SVGID_7_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st7" d="M18.1,17.5h-3.8v-1.1h3.3v-1.6H12v-1.1h6c0.3,0,0.5,0.2,0.5,0.5V17C18.6,17.3,18.4,17.5,18.1,17.5z" />
                                      <linearGradient id="beta-option-QR-SVGID_8_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st8" d="M9.9,13.7h1.1v3.8H9.9V13.7z" />
                                      <linearGradient id="beta-option-QR-SVGID_9_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st9" d="M12,16.4h1.1v1.1H12V16.4z" />
                                      <linearGradient id="beta-option-QR-SVGID_10_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st10" d="M12,3.8h-1.1V1.1H9.9v2.2c0,0.3-0.2,0.5-0.5,0.5H7.1c-0.3,0-0.5-0.2-0.5-0.5V0h1.1v2.7h1.1V0.5 C8.8,0.2,9,0,9.3,0h2.2C11.8,0,12,0.2,12,0.5V3.8z" />
                                      <linearGradient id="beta-option-QR-SVGID_11_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st11" d="M18.6,9.9h-7.1c-0.3,0-0.5-0.2-0.5-0.5V5.5H12v3.3h6.6V9.9z" />
                                      <linearGradient id="beta-option-QR-SVGID_12_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st12" d="M7.1,7.7H4.9V6.6h1.6V5.5h1.1v1.6C7.7,7.4,7.4,7.7,7.1,7.7z" />
                                      <linearGradient id="beta-option-QR-SVGID_13_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st13" d="M0,6.6h1.6v1.1H0V6.6z" />
                                      <linearGradient id="beta-option-QR-SVGID_14_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st14" d="M2.7,6.6h1.1v1.1H2.7V6.6z" />
                                      <linearGradient id="beta-option-QR-SVGID_15_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st15" d="M17.5,6.6h1.1v1.1h-1.1V6.6z" />
                                      <linearGradient id="beta-option-QR-SVGID_16_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st16" d="M13.1,6.6h3.3v1.1h-3.3V6.6z" />
                                      <linearGradient id="beta-option-QR-SVGID_17_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st17" d="M8.2,17.5H7.1V12c0-0.3,0.2-0.5,0.5-0.5h10.9v1.1H8.2V17.5z" />
                                      <linearGradient id="beta-option-QR-SVGID_18_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st18" d="M8.8,5.5h1.1v2.7H8.8V5.5z" />
                                      <linearGradient id="beta-option-QR-SVGID_19_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st19" d="M6.6,10.9H5.5V9.9H0V8.8h6c0.3,0,0.5,0.2,0.5,0.5V10.9z" />
                                      <linearGradient id="beta-option-QR-SVGID_20_" gradientUnits="userSpaceOnUse" x1="0" y1="8.7582" x2="18.6111" y2="8.7582"><stop offset="0" style={{ stopColor: 'rgb(9, 94, 189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4, 169, 194)' }} /></linearGradient>
                                      <path className="st20" d="M8.8,9.3h1.1v1.1H8.8V9.3z" />
                                    </g></g></g></g>
                                </svg>
                              </div>
                              <div className="_transactionOptionTitle_ktmyr_69 transaction-option-title">ฝากผ่าน QR Code</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ---- qrpay form container ---- */}
                    <div className="standard-transaction-container qrpay-container">
                      <div className="standard-form-container transaction-form">

                        {/* เลือกธนาคาร */}
                        <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">เลือกธนาคาร</label>
                        <div className="bank-list-container" id="transaction-form-bank" data-tutorialkey-selected={qrSelectedBank || ''}>
                          <div
                            className={`bank-item _bankItem_1t44k_56${qrSelectedBank === 'PROMPT' ? ' active' : ''}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.setState({ qrSelectedBank: 'PROMPT' })}
                          >
                            <div name="PROMPT" className="img-container _imgContainer_s5o8x_1">
                              <div className="bank-icon undefined" style={{ width: 46, height: 46, borderRadius: 10, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg,#1b3a8f,#003e7e)' }}>
                                <span style={{ display: 'inline-flex', width: 30, height: 30 }}>
                                  <svg viewBox="0 0 100 100" width="30" height="30" style={{ width: 30, height: 30 }} xmlns="http://www.w3.org/2000/svg">
                                    {/* QR finder squares */}
                                    <rect x="8" y="8" width="26" height="26" rx="4" fill="none" stroke="#fff" strokeWidth="6" />
                                    <rect x="17" y="17" width="8" height="8" fill="#fff" />
                                    <rect x="66" y="8" width="26" height="26" rx="4" fill="none" stroke="#fff" strokeWidth="6" />
                                    <rect x="75" y="17" width="8" height="8" fill="#fff" />
                                    <rect x="8" y="66" width="26" height="26" rx="4" fill="none" stroke="#fff" strokeWidth="6" />
                                    <rect x="17" y="75" width="8" height="8" fill="#fff" />
                                    {/* data modules */}
                                    <rect x="44" y="8" width="7" height="7" fill="#fff" />
                                    <rect x="44" y="22" width="7" height="7" fill="#fff" />
                                    <rect x="44" y="44" width="7" height="7" fill="#fff" />
                                    <rect x="58" y="44" width="7" height="7" fill="#fff" />
                                    <rect x="72" y="44" width="7" height="7" fill="#fff" />
                                    <rect x="86" y="44" width="7" height="7" fill="#fff" />
                                    <rect x="44" y="58" width="7" height="7" fill="#fff" />
                                    <rect x="58" y="58" width="7" height="7" fill="#fff" />
                                    <rect x="44" y="72" width="7" height="7" fill="#fff" />
                                    <rect x="58" y="72" width="7" height="7" fill="#fff" />
                                    <rect x="72" y="72" width="7" height="7" fill="#fff" />
                                    <rect x="86" y="72" width="7" height="7" fill="#fff" />
                                    <rect x="72" y="58" width="7" height="7" fill="#fff" />
                                    <rect x="86" y="86" width="7" height="7" fill="#fff" />
                                    <rect x="58" y="86" width="7" height="7" fill="#fff" />
                                  </svg>
                                </span>
                              </div>
                            </div>
                            <div><span>Prompt Pay</span></div>
                          </div>
                        </div>

                        {/* Form fields — แสดงหลังเลือกธนาคาร */}
                        {qrSelectedBank && (
                          <>
                            {/* จำนวนเงินฝาก */}
                            <div className="standard-form-field amount-selection" id="transaction-form-amount">
                              <label className="standard-label standard-mandatory">จำนวนเงินฝาก</label>
                              <div className="standard-form-field-wrapper">
                                <div className="deposit-amount-input">
                                  <input
                                    id="depositamount"
                                    className="standard-input"
                                    type="numeric"
                                    autoComplete="off"
                                    placeholder={`ขั้นต่ำ: ${limit ? parseFloat(limit.min).toFixed(2) : '200.00'} / สูงสุด: ${limit ? parseFloat(limit.max).toLocaleString('en', { minimumFractionDigits: 2 }) : '20,000.00'}`}
                                    min="0"
                                    value={depositamount || ''}
                                    onChange={this.onChangexdep}
                                  />
                                  <div className="deposit-amount-clear-button" onClick={() => this.setState({ depositamount: '' })}>
                                    <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/clear-button.svg" alt="clear-button-img" />
                                  </div>
                                </div>
                                <div className="tool-tip-container">
                                  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 90 90" className="" width="100%" height="100%" id="" prefix="">
                                    <g className="D-referral-important"><path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" /></g>
                                  </svg>
                                  <span>จำกัด ขั้นต่ำ/สูงสุด THB {limit ? parseFloat(limit.min).toFixed(2) : '200.00'} / THB {limit ? parseFloat(limit.max).toLocaleString('en', { minimumFractionDigits: 2 }) : '20,000.00'}</span>
                                </div>
                              </div>
                              <div className="standard-error-validation">จำนวนเงินที่โอนต้องสูงกว่าจำนวนเงินฝากขั้นต่ำ </div>
                              <div className="standard-amount-btn-container">
                                {[100, 200, 300, 500, 1000].map((amt) => (
                                  <button key={amt} className="amount-btn" type="button" onClick={(e) => this.handleClickdeposit(e, amt)}>{amt}</button>
                                ))}
                              </div>
                            </div>

                            {/* Submit */}
                            <section className="transaction-button-section">
                              <div className="standard-button-container">
                                <button
                                  id="deposit-submit-button"
                                  className="standard-submit-button"
                                  data-button-category="submit"
                                  type="submit"
                                  onClick={(e) => this.confirmdeposit(e, 0)}
                                >
                                  <span>ส่ง</span>
                                </button>
                              </div>
                            </section>
                          </>
                        )}
                      </div>
                    </div>
                    {recentTable}
                  </div>
                )
              )}

              {/* ===================================================
                  TAB 2 : ฝากปกติ
              =================================================== */}
              {depositTab === 'bank' && (() => {
                // ---- หลังกดฝาก: โชว์บัญชีให้โอน + ก๊อปปี้ + อัพโหลด slip ----
                const bankAfterSubmitUI = (
                  <div className="standard-transaction-container bank-transfer-container">
                    <div className="standard-form-container transaction-form">
                      <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">โอนเงินไปยังบัญชี</label>

                      {/* Bank card */}
                      <div className="deposit-bank-card">
                        {mainacc ? (
                          <>
                            <div className="dbc-header">
                              <img loading="lazy" src={`https://baryon.million-edge.online/cms/public/payment/icons/Bank/THB/${mainacc.bankcode || 'GSB'}.png`} alt="" />
                              <span className="dbc-bankname">{mainacc.bankname || 'ธนาคาร'}</span>
                            </div>
                            <div className="dbc-row">
                              <span className="dbc-label">ชื่อบัญชี</span>
                              <span className="dbc-value">{mainacc.fullname || mainacc.accname || mainacc.name || '-'}</span>
                            </div>
                            <div className="dbc-row">
                              <span className="dbc-label">เลขบัญชี</span>
                              <span className="dbc-accnum">{mainacc.accnumber || '-'}</span>
                              <button className="dbc-copy-btn" type="button" onClick={() => {
                                if (mainacc && mainacc.accnumber) {
                                  navigator.clipboard.writeText(mainacc.accnumber);
                                  Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'คัดลอกแล้ว', showConfirmButton: false, timer: 1500 });
                                }
                              }}>คัดลอก</button>
                            </div>
                          </>
                        ) : (
                          <div style={{ color: '#8697a2', textAlign: 'center', fontSize: '12px' }}>กำลังโหลดข้อมูลบัญชี...</div>
                        )}
                      </div>

                      {/* Note */}
                      <div className="tool-tip-container _tooltipMessage_1tfld_1" style={{ marginBottom: '1rem' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 90 90" className="" width="100%" height="100%" id="" prefix="">
                          <g className="D-referral-important">
                            <path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" />
                          </g>
                        </svg>
                        <span>การโอนเงินระหว่างธนาคารและเครื่องฝากเงินสด ต้องใช้ใบเสร็จรับเงินเพื่อการอนุมัติการฝากที่รวดเร็วยิ่งขึ้น</span>
                      </div>

                      {/* Buttons: ส่ง + อัพโหลดใบเสร็จ — equal width */}
                      <section className="transaction-button-section">
                        <div className="standard-button-container" style={{ display: 'flex', gap: '0.6rem' }}>
                          <button
                            id="deposit-submit-button"
                            className="standard-submit-button"
                            data-button-category="submit"
                            type="submit"
                            style={{ flex: 1 }}
                            onClick={(e) => this.confirmdeposit(e, 1)}
                          >
                            <span>ส่ง</span>
                          </button>
                          {mainacc && mainacc.autoslip == 1 && (
                            <label htmlFor="slipFileInput" className="standard-submit-form-button" data-button-category="receipt"
                              style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', margin: 0 }}>
                              <span>อัพโหลด Slip</span>
                              <input id="slipFileInput" type="file" accept="image/*,.pdf" style={{ display: "none" }} onChange={this.handleBankSlipUpload} />
                            </label>
                          )}
                        </div>
                      </section>

                      <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                        <button type="button" style={{ background: 'transparent', border: 'none', color: '#8697a2', fontSize: '0.82rem', cursor: 'pointer', textDecoration: 'underline' }}
                          onClick={() => this.setState({ depositstate: 0 })}>
                          กลับ
                        </button>
                      </div>
                    </div>
                  </div>
                );

                return depositstate === 1 ? (
                  <div>
                    {bankAfterSubmitUI}
                    {recentTable}
                  </div>
                ) : (
                  <div className="standard-tab-container st-icon-text-tab deposit-tab-container">
                    <div className="standard-transaction-container bank-transfer-container">
                      <div className="standard-form-container transaction-form">

                        {/* บัญชีรับเงิน */}
                        <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">บัญชีรับเงิน</label>
                        <div className="deposit-bank-card">
                          {mainacc ? (
                            <>
                              <div className="dbc-header">
                                <img loading="lazy" src={mainacc.full_img} alt="" />
                                <span className="dbc-bankname">{mainacc.fullname_th || 'ธนาคาร'}</span>
                              </div>
                              <div className="dbc-row">
                                <span className="dbc-label">ชื่อบัญชี</span>
                                <span className="dbc-value">{mainacc.first_name_en  + ' ' + mainacc.last_name_en || '-'}</span>
                              </div>
                              <div className="dbc-row">
                                <span className="dbc-label">เลขบัญชี</span>
                                <span className="dbc-accnum">{mainacc.accnumber || '-'}</span>
                              </div>
                            </>
                          ) : (
                            <div style={{ color: '#8697a2', textAlign: 'center' }}>กำลังโหลดข้อมูลบัญชี...</div>
                          )}
                        </div>

                        {/* จำนวนเงิน */}
                        <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">จำนวนเงิน</label>
                        <div className="standard-form-field amount-selection">
                          <div className="standard-form-field-wrapper">
                            <div className="deposit-amount-input">
                              <input
                                id="depositamount"
                                className="standard-input"
                                type="numeric"
                                autoComplete="off"
                                placeholder={`ขั้นต่ำ: ${limit ? parseFloat(limit.min).toFixed(2) : '100.00'} / สูงสุด: ${limit ? parseFloat(limit.max).toLocaleString('en', { minimumFractionDigits: 2 }) : '500,000.00'}`}
                                min="0"
                                value={depositamount || ''}
                                onChange={this.onChangexdep}
                                name="depositamount"
                              />
                              <div className="deposit-amount-clear-button" onClick={() => this.setState({ depositamount: '' })}>
                                <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/clear-button.svg" alt="clear-button-img" />
                              </div>
                            </div>
                          </div>
                          <div className="standard-amount-btn-container">
                            {[100, 200, 300, 500, 1000, 5000].map((amt) => (
                              <button key={amt} className="amount-btn" type="button" onClick={(e) => this.handleClickdeposit(e, amt)}>{amt}</button>
                            ))}
                          </div>
                        </div>

                        {/* ธนาคารผู้ส่ง */}
                        <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">ธนาคารผู้ส่ง</label>
                        <div className="standard-input-container">
                          <select className="standard-input" name="senderbank" onChange={this.onChange}>
                            <option value="">-- เลือกธนาคาร --</option>
                            <option value="SCB">ไทยพาณิชย์ (SCB)</option>
                            <option value="KBANK">กสิกรไทย (KBANK)</option>
                            <option value="BBL">กรุงเทพ (BBL)</option>
                            <option value="KTB">กรุงไทย (KTB)</option>
                            <option value="BAY">กรุงศรีอยุธยา (BAY)</option>
                            <option value="GSB">ออมสิน (GSB)</option>
                            <option value="TTB">ทหารไทยธนชาต (TTB)</option>
                            <option value="UOB">ยูโอบี (UOB)</option>
                          </select>
                        </div>

                        {/* หมายเหตุ */}
                        <div className="tool-tip-container _tooltipMessage_1tfld_1" style={{ margin: '0.5rem 0' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 90 90" className="" width="100%" height="100%" id="" prefix="">
                            <g className="D-referral-important">
                              <path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" />
                            </g>
                          </svg>
                          <span>การโอนเงินระหว่างธนาคารและเครื่องฝากเงินสด ต้องใช้ใบเสร็จรับเงินเพื่อการอนุมัติการฝากที่รวดเร็วยิ่งขึ้น</span>
                        </div>

                        {/* Buttons: ส่ง + อัพโหลดใบเสร็จ — equal width */}
                        <section className="transaction-button-section">
                          <div className="standard-button-container deposit-equal-btns">
                            <button
                              id="deposit-submit-button"
                              className="standard-submit-button"
                              data-button-category="submit"
                              type="submit"
                              onClick={(e) => this.confirmdeposit(e, 1)}
                            >
                              <span>ส่ง</span>
                            </button>
                            {mainacc && mainacc.autoslip == 1 && (
                              <label htmlFor="slipFileInput2" className="standard-submit-form-button" data-button-category="receipt"
                              >
                                <span>อัพโหลดใบเสร็จ</span>
                                <input id="slipFileInput2" type="file" accept="image/*,.pdf" style={{ display: "none" }} onChange={this.handleBankSlipUpload} />
                              </label>
                            )}
                          </div>
                        </section>
                      </div>
                    </div>
                    {recentTable}
                  </div>
                );
              })()}

              {/* ===================================================
                  TAB 3 : อัพโหลดสลิป (port จาก deposit มือถือ)
              =================================================== */}
              {depositTab === 'slip' && (
                <div className="standard-transaction-container" style={{ padding: '18px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                    <div style={{ fontSize: 26 }}>📎</div>
                    <div>
                      <div style={{ fontSize: 16, fontWeight: 700, color: '#1a2540' }}>อัพโหลดสลิปโอนเงิน</div>
                      <div style={{ fontSize: 12.5, color: '#8697a2', marginTop: 2 }}>แนบหลักฐานการโอนเงินเพื่อให้ทีมงานตรวจสอบ</div>
                    </div>
                  </div>

                  <input type="file" accept="image/*" style={{ display: 'none' }} ref={el => this._slipInput = el} onChange={this.handleSlipFile} />

                  {this.state.slipIsConfirmed ? (
                    <div style={{ textAlign: 'center', padding: '24px 12px' }}>
                      <div style={{ fontSize: 40, marginBottom: 8 }}>✅</div>
                      <div style={{ fontSize: 16, fontWeight: 700, color: '#16a34a' }}>อัปโหลดสลิปสำเร็จแล้ว</div>
                      <div style={{ fontSize: 13, color: '#8697a2', marginTop: 4 }}>ทีมงานจะตรวจสอบและเติมเงินให้คุณโดยเร็ว</div>
                      <button type="button" onClick={this.clearSlipFile}
                        style={{ marginTop: 16, background: '#f0f2f5', color: '#5a6b7b', border: 'none', borderRadius: 8, padding: '9px 22px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                        ❌ เคลียร์ไฟล์ / ส่งใหม่
                      </button>
                    </div>
                  ) : this.state.slipTabPreviewUrl ? (
                    <div style={{ textAlign: 'center' }}>
                      <img src={this.state.slipTabPreviewUrl} alt="สลิป" style={{ maxWidth: 280, width: '100%', borderRadius: 12, border: '1px solid #e7eaee', marginBottom: 14 }} />
                      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <button type="button" disabled={this.state.slipIsUploading} onClick={this.confirmSlipUpload}
                          style={{ background: 'linear-gradient(135deg,#0a5ebd,#04a9c2)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 26px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', opacity: this.state.slipIsUploading ? 0.6 : 1 }}>
                          {this.state.slipIsUploading ? '⏳ กำลังอัปโหลด...' : 'ยืนยันอัปโหลดสลิป'}
                        </button>
                        <button type="button" onClick={this.clearSlipFile}
                          style={{ background: '#f0f2f5', color: '#5a6b7b', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                          ❌ เคลียร์ไฟล์
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div onClick={() => this._slipInput && this._slipInput.click()}
                      style={{ border: '2px dashed #c7d2e0', borderRadius: 12, padding: '34px 16px', textAlign: 'center', cursor: 'pointer', background: '#f7f9fb' }}>
                      <div style={{ fontSize: 36 }}>🖼️</div>
                      <div style={{ fontSize: 15, fontWeight: 600, color: '#374151', marginTop: 8 }}>แตะเพื่อเลือกสลิป</div>
                      <div style={{ fontSize: 12, color: '#9aa5ad', marginTop: 4 }}>รองรับ JPG, PNG — ขนาดไม่เกิน 10MB</div>
                    </div>
                  )}
                </div>
              )}

              {/* ===================================================
                  TAB 3 : ฝากคริปโต (hidden)
              =================================================== */}
              {false && depositTab === 'crypto' && (
                depositstate === 1 ? updatingUI : (
                  <div className="standard-tab-container st-icon-text-tab deposit-tab-container">
                    <div className="standard-transaction-container bank-transfer-container">
                      <div className="standard-form-container transaction-form">
                        {/* Network selection */}
                        <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">เลือกเครือข่าย</label>
                        <div className="bank-list-container" id="transaction-form-bank" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                          {[
                            { id: 'usdt_erc20', label: 'USDT (ERC20)' },
                            { id: 'eth', label: 'ETH' },
                            { id: 'btc', label: 'BTC' },
                            { id: 'usdt_trc20', label: 'USDT (TRC20)' },
                          ].map((coin) => (
                            <div key={coin.id} className="bank-item _bankItem_1t44k_56" style={{ cursor: 'pointer' }}>
                              <div className="img-container _imgContainer_s5o8x_1 online _online_s5o8x_4">
                                <div className="bank-icon">
                                  <span style={{ fontSize: '0.75rem', fontWeight: 'bold', padding: '4px' }}>{coin.label}</span>
                                </div>
                              </div>
                              <div><span>{coin.label}</span></div>
                            </div>
                          ))}
                        </div>

                        {/* Amount input */}
                        <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">จำนวนเงิน (THB)</label>
                        <div className="standard-input-container">
                          <input
                            type="number"
                            className="standard-input"
                            placeholder={`ขั้นต่ำ ${limit ? limit.min : 100} / สูงสุด ${limit ? limit.max : 500000}`}
                            value={depositamount || ''}
                            onChange={this.onChangexdep}
                            name="depositamount"
                          />
                        </div>
                        <div className="amount-buttons-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', margin: '0.5rem 0' }}>
                          {amountButtons([100, 200, 500, 1000, 2000, 5000])}
                        </div>

                        {/* Promo code */}
                        <label className="_transactionTitle_hzg77_1 transaction-title standard-label">รหัสโปรโมชั่น (ถ้ามี)</label>
                        <div className="standard-input-container">
                          <input type="text" className="standard-input" placeholder="รหัสโปรโมชั่น" name="promocode" onChange={this.onChange} />
                        </div>

                        {/* Channel */}
                        <label className="_transactionTitle_hzg77_1 transaction-title standard-label">ช่องทาง</label>
                        <div className="standard-input-container">
                          <select className="standard-input">
                            <option value="spcs">SPCS</option>
                          </select>
                        </div>

                        {/* Submit */}
                        <section className="transaction-button-section">
                          <div className="standard-button-container ">
                            <button
                              id="deposit-submit-button"
                              className="standard-submit-button"
                              data-button-category="submit"
                              type="submit"
                              onClick={(e) => this.confirmdeposit(e, 0)}
                            >
                              <span>ฝากเงิน</span>
                            </button>
                          </div>
                        </section>
                      </div>
                    </div>
                    {recentTable}
                  </div>
                )
              )}

              {/* ===== Important notes ===== */}
              <section className="transaction-note-section">
                <div className="transaction-notes-container">
                  <div className="notes-modal">
                    <div className="note-info-detail">
                      <div id="importance-notice" style={{ display: "flex", alignItems: "center", padding: "0.08rem 0.2rem 0.08rem 0.4rem", color: "rgb(134, 151, 162)", cursor: "pointer" }}>
                        <span className=" lazy-load-image-background opacity lazy-load-image-loaded" style={{ color: "transparent", display: "inline-block" }}>
                          <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/important-notice.svg" alt="" style={{ width: "0.2rem", height: "0.2rem", margin: "0px 0.1rem 0px 0px" }} />
                        </span>
                        <span>ข้อมูลสำคัญ</span>
                        <span className=" lazy-load-image-background opacity lazy-load-image-loaded" style={{ color: "transparent", display: "inline-block" }}>
                          <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/dropdownArrow.svg" alt="" id="importance-dropdown-arrow" style={{ width: "0.2rem", height: "0.2rem", transform: "rotate(180deg)" }} />
                        </span>
                      </div>
                      <ul id="importance-notice-content" className="decimal" style={{ color: "rgb(134, 151, 162)", fontSize: "0.14rem", padding: "0px 0.7rem", display: "block" }}>
                        <li style={{ listStyle: "disc", margin: "0px 0px 0.05rem", wordBreak: "break-word" }}>
                          <span style={{ color: "#8697a2" }}>กรุณาตรวจสอบเลขบัญชีก่อนการฝากทุกครั้ง</span>
                        </li>
                        <li style={{ listStyle: "disc", margin: "0px 0px 0.05rem", wordBreak: "break-word" }}>
                          <span style={{ color: "#8697a2" }}>สำหรับการฝากเงิน "ผ่านบัญชีธนาคาร" จะต้องทำรายการฝากก่อน แจ้งฝากผ่านหน้าเว็บไซต์เพื่อการปรับยอดที่รวดเร็ว</span>
                        </li>
                        <li style={{ listStyle: "disc", margin: "0px 0px 0.05rem", wordBreak: "break-word" }}>
                          <span style={{ color: "#8697a2" }}>บัญชีธนาคารฝากและถอนของสมาชิจะต้องตรงตามชื่อ-สกุลที่ลงทะเบียนเข้ามาเท่านั้น ไม่อนุญาตให้ใช้ "บัญชีบุคคลอื่น"ในการโอนเงิน</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>

            </div>
          </div>
        </div>
      </section>
    );
  }

  _OLD_renderDepositContent_REMOVED2() {
    return (
      <section className="st-detail-container deposit st-detail-deposit-container">
        <div className="st-tab with-notice ">
          <div id="beta-deposit-landing" style={{}}>
            <div className="deposit-tab-header" id="deposit-tab-header">
              <div
                className="_tabHeaderContainer_9c2z1_1 tab-header-container"
                id="deposit-tab-header-container"
              >
                <div
                  className="_tabHeaderTitle_1ivtf_1 tab-header-title _active_1ivtf_22"
                  id="tab_header_active"
                >
                  <span className="_titleContent_1ivtf_35">ฝากปกติ </span>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 50" className="" width="100%" height="100%" id="" prefix="">
                      <style dangerouslySetInnerHTML={{ __html: "\n.beta-time .st0{fill:#FFFFFF;}\n  " }} />
                      <g className="beta-time"><g><g>
                        <path className="st0" d="M2,23.65158c0.1175-0.87102,0.19916-1.74864,0.3582-2.612c1.1885-6.45181,4.53026-11.51159,9.94045-15.19425 c3.12622-2.12799,6.60665-3.34789,10.36359-3.72999c3.53803-0.35984,6.98579,0.0968,10.32738,1.32413 c2.23645,0.82142,4.28395,1.98315,6.17352,3.42953c0.77756,0.59519,1.04475,1.45981,0.70655,2.30254 c-0.32626,0.81299-1.11409,1.31346-2.0078,1.16727c-0.39272-0.06424-0.79627-0.26959-1.12037-0.51095 c-1.57022-1.16938-3.24706-2.13469-5.08684-2.81195c-2.93472-1.08032-5.95841-1.40826-9.05486-1.03026 c-3.64452,0.4449-6.89575,1.85869-9.71448,4.19108c-3.59903,2.97807-5.89846,6.77189-6.73211,11.38651 c-0.77844,4.309-0.20764,8.46179,1.88919,12.31697c2.97153,5.46339,7.52628,8.87722,13.67674,9.98228 c5.02639,0.90311,9.72781-0.09441,13.94996-2.96727c4.47654-3.04596,7.26182-7.26511,8.20888-12.62465 c0.69103-3.91062,0.18037-7.68375-1.44854-11.31205c-0.19428-0.43274-0.32899-0.9507-0.29488-1.41471 c0.06151-0.83694,0.7527-1.47695,1.53258-1.59702c0.90474-0.1393,1.72884,0.25099,2.08213,1.12539 c0.55323,1.36923,1.14592,2.74019,1.51273,4.16429c2.95651,11.47819-3.20293,23.21241-14.31344,27.34687 c-2.00207,0.74501-4.07021,1.19953-6.2043,1.34409c-0.13172,0.00891-0.26123,0.05036-0.39177,0.07667 c-0.89862,0-1.79723,0-2.69585,0c-0.11555-0.02539-0.23003-0.06578-0.34679-0.07401 c-3.5829-0.25267-6.93555-1.27527-9.99791-3.1431c-5.98343-3.6495-9.66006-8.92505-10.95368-15.82955 C2.19675,28.09532,2.11742,27.21781,2,26.34743C2,25.44881,2,24.5502,2,23.65158z" />
                        <path className="st0" d="M26.91534,23.08875c0.2366,0,0.4121-0.00001,0.58761,0c2.30527,0.0001,4.61057,0.00579,6.91581-0.00281 c0.77932-0.00291,1.40857,0.26281,1.81262,0.9453c0.76842,1.29793-0.14344,2.85426-1.70533,2.87173 c-2.18525,0.02444-4.37096,0.00696-6.55648,0.00725c-0.94307,0.00012-1.88624,0.00877-2.82917-0.00249 c-1.27536-0.01521-2.04057-0.77013-2.04301-2.04651c-0.00838-4.38599-0.00785-8.77202,0.00019-13.15801 c0.00207-1.13007,0.65748-1.88282,1.70136-2.01426c0.92218-0.11612,1.79491,0.46277,2.03776,1.38416 c0.07105,0.26958,0.07516,0.56213,0.07554,0.8442c0.00472,3.51778,0.0031,7.03557,0.00311,10.55336 C26.91535,22.64898,26.91534,22.82731,26.91534,23.08875z" />
                      </g></g></g>
                    </svg>
                  </div>
                  <span className="_titleContent_1ivtf_35"> 5 นาที</span>
                </div>
                <div className="_tabHeaderTitle_1ivtf_1 tab-header-title" id="">
                  <span className="_titleContent_1ivtf_35">ฝากคริปโต </span>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 50" className="" width="100%" height="100%" id="" prefix="">
                      <style dangerouslySetInnerHTML={{ __html: "\n.beta-time .st0{fill:#FFFFFF;}\n  " }} />
                      <g className="beta-time"><g><g>
                        <path className="st0" d="M2,23.65158c0.1175-0.87102,0.19916-1.74864,0.3582-2.612c1.1885-6.45181,4.53026-11.51159,9.94045-15.19425 c3.12622-2.12799,6.60665-3.34789,10.36359-3.72999c3.53803-0.35984,6.98579,0.0968,10.32738,1.32413 c2.23645,0.82142,4.28395,1.98315,6.17352,3.42953c0.77756,0.59519,1.04475,1.45981,0.70655,2.30254 c-0.32626,0.81299-1.11409,1.31346-2.0078,1.16727c-0.39272-0.06424-0.79627-0.26959-1.12037-0.51095 c-1.57022-1.16938-3.24706-2.13469-5.08684-2.81195c-2.93472-1.08032-5.95841-1.40826-9.05486-1.03026 c-3.64452,0.4449-6.89575,1.85869-9.71448,4.19108c-3.59903,2.97807-5.89846,6.77189-6.73211,11.38651 c-0.77844,4.309-0.20764,8.46179,1.88919,12.31697c2.97153,5.46339,7.52628,8.87722,13.67674,9.98228 c5.02639,0.90311,9.72781-0.09441,13.94996-2.96727c4.47654-3.04596,7.26182-7.26511,8.20888-12.62465 c0.69103-3.91062,0.18037-7.68375-1.44854-11.31205c-0.19428-0.43274-0.32899-0.9507-0.29488-1.41471 c0.06151-0.83694,0.7527-1.47695,1.53258-1.59702c0.90474-0.1393,1.72884,0.25099,2.08213,1.12539 c0.55323,1.36923,1.14592,2.74019,1.51273,4.16429c2.95651,11.47819-3.20293,23.21241-14.31344,27.34687 c-2.00207,0.74501-4.07021,1.19953-6.2043,1.34409c-0.13172,0.00891-0.26123,0.05036-0.39177,0.07667 c-0.89862,0-1.79723,0-2.69585,0c-0.11555-0.02539-0.23003-0.06578-0.34679-0.07401 c-3.5829-0.25267-6.93555-1.27527-9.99791-3.1431c-5.98343-3.6495-9.66006-8.92505-10.95368-15.82955 C2.19675,28.09532,2.11742,27.21781,2,26.34743C2,25.44881,2,24.5502,2,23.65158z" />
                        <path className="st0" d="M26.91534,23.08875c0.2366,0,0.4121-0.00001,0.58761,0c2.30527,0.0001,4.61057,0.00579,6.91581-0.00281 c0.77932-0.00291,1.40857,0.26281,1.81262,0.9453c0.76842,1.29793-0.14344,2.85426-1.70533,2.87173 c-2.18525,0.02444-4.37096,0.00696-6.55648,0.00725c-0.94307,0.00012-1.88624,0.00877-2.82917-0.00249 c-1.27536-0.01521-2.04057-0.77013-2.04301-2.04651c-0.00838-4.38599-0.00785-8.77202,0.00019-13.15801 c0.00207-1.13007,0.65748-1.88282,1.70136-2.01426c0.92218-0.11612,1.79491,0.46277,2.03776,1.38416 c0.07105,0.26958,0.07516,0.56213,0.07554,0.8442c0.00472,3.51778,0.0031,7.03557,0.00311,10.55336 C26.91535,22.64898,26.91534,22.82731,26.91534,23.08875z" />
                      </g></g></g>
                    </svg>
                  </div>
                  <span className="_titleContent_1ivtf_35"> 1-15 นาที</span>
                </div>
              </div>
            </div>
            <div className="deposit-wrapper">
              <div className="standard-tab-container st-icon-text-tab deposit-tab-container">
                <div className="deposit-tab-header">
                  <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">
                    ตัวเลือกฝากเงิน
                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 90 90" className="transaction-title-icon" width="100%" height="100%" id="" prefix="">
                      <g className="D-referral-important">
                        <path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" />
                      </g>
                    </svg>
                  </label>
                  <div className="deposit-tab-header-right-content">
                    <div className="reTrigger_step_button" id="needHelpBtn">
                      <svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 0 36 36" version="1.1">
                        <g id="surface1">
                          <path d="M 18.191406 0.164062 C 8.378906 0.164062 0.378906 7.667969 0.378906 16.90625 C 0.378906 19.964844 1.257812 22.949219 2.933594 25.542969 L 3.054688 25.75 L -0.00390625 34.285156 L 9.378906 31.460938 L 9.578125 31.5625 C 12.191406 32.933594 15.175781 33.644531 18.191406 33.644531 C 28.019531 33.644531 36 26.140625 36 16.90625 C 36 7.667969 28.019531 0.164062 18.191406 0.164062 Z M 17.976562 26.113281 C 17.207031 26.113281 16.589844 25.53125 16.589844 24.800781 C 16.589844 24.074219 17.207031 23.488281 17.976562 23.488281 C 18.742188 23.488281 19.359375 24.074219 19.359375 24.800781 C 19.359375 25.53125 18.742188 26.113281 17.976562 26.113281 Z M 23.789062 13.714844 C 23.480469 14.585938 22.773438 15.140625 21.3125 16.699219 C 20.160156 17.925781 19.144531 18.871094 19.066406 20.460938 C 19.035156 21.160156 18.621094 21.65625 17.789062 21.582031 C 17.050781 21.523438 16.730469 20.851562 16.730469 20.226562 C 16.730469 18.070312 17.730469 16.976562 18.789062 15.855469 C 20.175781 14.398438 21.3125 13.65625 21.359375 12.5625 C 21.40625 11.324219 20.449219 10.203125 18.390625 10.085938 C 16.359375 9.984375 14.636719 11.238281 14.390625 13.101562 C 14.300781 13.726562 13.808594 14.195312 13.128906 14.136719 C 12.46875 14.078125 11.945312 13.523438 11.976562 12.882812 C 12.285156 9.75 15.113281 7.726562 18.480469 7.898438 C 22.171875 8.074219 24.757812 10.914062 23.789062 13.699219 Z M 23.789062 13.714844 " />
                        </g>
                      </svg>
                      <span>รหัสผ่านไม่สามารถเหมือนกับชื่อผู้ใช้ของคุณได้</span>
                    </div>
                    <div className="bank-offline-container">
                      <div className="bankoff-btn " disabled="">
                        <div className="img-container">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 26.9 24.7" className="" width="100%" height="100%" id="" prefix="">
                            <style dangerouslySetInnerHTML={{ __html: "\n.beta-option-B .st0{fill:url(#beta-option-B-beta-option-B-SVGID_1_);}\n\t .beta-option-B .st1{fill:url(#beta-option-B-beta-option-B-SVGID_2_);}\n  " }} />
                            <g className="beta-option-B"><g>
                              <linearGradient id="beta-option-B-beta-option-B-SVGID_1_" gradientUnits="userSpaceOnUse" x1="10.9063" y1="15.6347" x2="15.9711" y2="15.6347">
                                <stop offset={0} style={{ stopColor: "rgb(9, 94, 189)" }} />
                                <stop offset={1} style={{ stopColor: "rgb(4, 169, 194)" }} />
                              </linearGradient>
                              <path className="st0" d="M13.2,19.5c-1.3,0-2.3-0.7-2.3-1.3c0-0.3,0.3-0.8,0.6-0.8c0.4,0,0.7,0.7,1.7,0.8v-2.1c-1-0.4-2.1-0.8-2.1-2.2 c0-1.4,1-2,2.1-2.1v-0.3c0-0.1,0.2-0.3,0.4-0.3c0.2,0,0.4,0.1,0.4,0.3v0.3c0.7,0,1.8,0.2,1.8,0.9c0,0.2-0.2,0.7-0.6,0.7 c-0.3,0-0.6-0.3-1.3-0.4v1.9c1,0.4,2,0.8,2,2.3c0,1.3-0.8,2.1-2,2.3v0.3c0,0.1-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3V19.5z M13.3,14.6V13c-0.5,0.1-0.9,0.3-0.9,0.8C12.4,14.2,12.8,14.4,13.3,14.6 M13.8,16.3v1.9c0.5-0.1,0.8-0.4,0.8-0.9 C14.7,16.8,14.3,16.5,13.8,16.3" />
                              <linearGradient id="beta-option-B-beta-option-B-SVGID_2_" gradientUnits="userSpaceOnUse" x1={0} y1="12.3267" x2="26.877" y2="12.3267">
                                <stop offset={0} style={{ stopColor: "rgb(9, 94, 189)" }} />
                                <stop offset={1} style={{ stopColor: "rgb(4, 169, 194)" }} />
                              </linearGradient>
                              <path className="st1" d="M26.9,5.8l-1.4-5.3C25.4,0.2,25.1,0,24.8,0H2.1C1.8,0,1.5,0.2,1.4,0.5L0,5.8C0,6,0,6.2,0.1,6.3 c0.1,0.2,0.3,0.3,0.5,0.3h1.4h0V24c0,0.4,0.3,0.7,0.7,0.7h21.4c0.4,0,0.7-0.3,0.7-0.7L24.7,6.6h1.5c0.2,0,0.4-0.1,0.5-0.3 C26.9,6.2,26.9,6,26.9,5.8z M19.8,3.6l-4.3-2.3h8.8l0.9,3.1l0.2,0.9h-5.2V4.2C20.1,4,20,3.7,19.8,3.6z M23.5,6.6l0.1,16.8l0,0h-3.4 V6.6H23.5L23.5,6.6z M6.8,6.6v2.2v14.6H3.4V6.6H6.8L6.8,6.6z M18.8,23.4H8.1V9.2L13.4,7l5.4,2.1V23.4z M13.7,5.7c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.3,0L9.5,7.2L8.1,7.8V4.6l5.3-2.9l5.4,2.9v2.3v0.9L13.7,5.7z M1.5,5.3l1.1-4h8.8L7.1,3.6C6.9,3.7,6.7,4,6.7,4.2v1.1 H2.6H1.5z" />
                            </g></g>
                          </svg>
                        </div>
                        <span>ธนาคาร สถานะ ออฟไลน์</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="deposit-option-container" id="deposit-option-container">
                  <div className="standard-tab transaction-option" id="transaction-option">
                    <div>
                      <div className="_transactionOptionTabHeader_ktmyr_1 transaction-option-tab-header _active_ktmyr_44" data-tutorialkey-selected="B" data-tutorialkey="B">
                        <div className="_transactionOptionImageContainer_ktmyr_30 transaction-option-image-container image-container">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 26.9 24.7" className="beta-option-B" width="100%" height="100%" id="" prefix="">
                            <style dangerouslySetInnerHTML={{ __html: "\n.beta-option-B .st0{fill:url(#beta-option-B-beta-option-B-SVGID_1_);}\n\t .beta-option-B .st1{fill:url(#beta-option-B-beta-option-B-SVGID_2_);}\n  " }} />
                            <g className="beta-option-B"><g>
                              <linearGradient id="beta-option-B-beta-option-B-SVGID_1_" gradientUnits="userSpaceOnUse" x1="10.9063" y1="15.6347" x2="15.9711" y2="15.6347">
                                <stop offset={0} style={{ stopColor: "rgb(9, 94, 189)" }} />
                                <stop offset={1} style={{ stopColor: "rgb(4, 169, 194)" }} />
                              </linearGradient>
                              <path className="st0" d="M13.2,19.5c-1.3,0-2.3-0.7-2.3-1.3c0-0.3,0.3-0.8,0.6-0.8c0.4,0,0.7,0.7,1.7,0.8v-2.1c-1-0.4-2.1-0.8-2.1-2.2 c0-1.4,1-2,2.1-2.1v-0.3c0-0.1,0.2-0.3,0.4-0.3c0.2,0,0.4,0.1,0.4,0.3v0.3c0.7,0,1.8,0.2,1.8,0.9c0,0.2-0.2,0.7-0.6,0.7 c-0.3,0-0.6-0.3-1.3-0.4v1.9c1,0.4,2,0.8,2,2.3c0,1.3-0.8,2.1-2,2.3v0.3c0,0.1-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.3V19.5z M13.3,14.6V13c-0.5,0.1-0.9,0.3-0.9,0.8C12.4,14.2,12.8,14.4,13.3,14.6 M13.8,16.3v1.9c0.5-0.1,0.8-0.4,0.8-0.9 C14.7,16.8,14.3,16.5,13.8,16.3" />
                              <linearGradient id="beta-option-B-beta-option-B-SVGID_2_" gradientUnits="userSpaceOnUse" x1={0} y1="12.3267" x2="26.877" y2="12.3267">
                                <stop offset={0} style={{ stopColor: "rgb(9, 94, 189)" }} />
                                <stop offset={1} style={{ stopColor: "rgb(4, 169, 194)" }} />
                              </linearGradient>
                              <path className="st1" d="M26.9,5.8l-1.4-5.3C25.4,0.2,25.1,0,24.8,0H2.1C1.8,0,1.5,0.2,1.4,0.5L0,5.8C0,6,0,6.2,0.1,6.3 c0.1,0.2,0.3,0.3,0.5,0.3h1.4h0V24c0,0.4,0.3,0.7,0.7,0.7h21.4c0.4,0,0.7-0.3,0.7-0.7L24.7,6.6h1.5c0.2,0,0.4-0.1,0.5-0.3 C26.9,6.2,26.9,6,26.9,5.8z M19.8,3.6l-4.3-2.3h8.8l0.9,3.1l0.2,0.9h-5.2V4.2C20.1,4,20,3.7,19.8,3.6z M23.5,6.6l0.1,16.8l0,0h-3.4 V6.6H23.5L23.5,6.6z M6.8,6.6v2.2v14.6H3.4V6.6H6.8L6.8,6.6z M18.8,23.4H8.1V9.2L13.4,7l5.4,2.1V23.4z M13.7,5.7c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.3,0L9.5,7.2L8.1,7.8V4.6l5.3-2.9l5.4,2.9v2.3v0.9L13.7,5.7z M1.5,5.3l1.1-4h8.8L7.1,3.6C6.9,3.7,6.7,4,6.7,4.2v1.1 H2.6H1.5z" />
                            </g></g>
                          </svg>
                        </div>
                        <div className="_transactionOptionTitle_ktmyr_69 transaction-option-title">โอนผ่านธนาคาร</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="standard-transaction-container bank-transfer-container">
                <div className="standard-form-container transaction-form">
                  <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label">เลือกธนาคาร</label>
                  <div className="bank-list-container" id="transaction-form-bank">
                    <div className="bank-item _bankItem_1t44k_56  ">
                      <div name="GSB" className="img-container _imgContainer_s5o8x_1 online _online_s5o8x_4">
                        <div className="bank-icon undefined">
                          <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/GSB.png" className="bank-icon" alt="" />
                        </div>
                      </div>
                      <div><span>ธนาคารออมสิน</span></div>
                    </div>
                  </div>
                  <div className="receipt-container">
                    <div className="tool-tip-container _tooltipMessage_1tfld_1">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 90 90" className="" width="100%" height="100%" id="" prefix="">
                        <g className="D-referral-important">
                          <path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" />
                        </g>
                      </svg>
                      <span>การโอนเงินระหว่างธนาคารและเครื่องฝากเงินสด ต้องใช้ใบเสร็จรับเงินเพื่อการอนุมัติการฝากที่รวดเร็วยิ่งขึ้น</span>
                    </div>
                  </div>
                  <section className="transaction-button-section">
                    <div className="standard-button-container ">
                      <div className="receipt-button-container">
                        <button id="" className="standard-submit-form-button" data-button-category="receipt" type="submit">
                          <span>อัพโหลดใบเสร็จ</span>
                          <input className="standard-input" id="hiddenFileInput" type="file" accept="image/*,.pdf" style={{ display: "none" }} />
                        </button>
                      </div>
                      <button id="deposit-submit-button" className="standard-submit-button" disabled="" data-button-category="submit" type="submit">
                        <span>ส่ง</span>
                      </button>
                    </div>
                  </section>
                </div>
              </div>
              <section className="transaction-note-section">
                <div className="transaction-notes-container">
                  <div className="notes-modal">
                    <div className="note-info-detail">
                      <div id="importance-notice" style={{ display: "flex", alignItems: "center", padding: "0.08rem 0.2rem 0.08rem 0.4rem", color: "rgb(134, 151, 162)", cursor: "pointer" }}>
                        <span className=" lazy-load-image-background opacity lazy-load-image-loaded" style={{ color: "transparent", display: "inline-block" }}>
                          <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/important-notice.svg" alt="" style={{ width: "0.2rem", height: "0.2rem", margin: "0px 0.1rem 0px 0px" }} />
                        </span>
                        <span>ข้อมูลสำคัญ</span>
                        <span className=" lazy-load-image-background opacity lazy-load-image-loaded" style={{ color: "transparent", display: "inline-block" }}>
                          <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/dropdownArrow.svg" alt="" id="importance-dropdown-arrow" style={{ width: "0.2rem", height: "0.2rem", transform: "rotate(180deg)" }} />
                        </span>
                      </div>
                      <ul id="importance-notice-content" className="decimal" style={{ color: "rgb(134, 151, 162)", fontSize: "0.14rem", padding: "0px 0.7rem", display: "block" }}>
                        <li style={{ listStyle: "disc", margin: "0px 0px 0.05rem", wordBreak: "break-word" }}>
                          <span style={{ color: "#8697a2" }}>กรุณาตรวจสอบเลขบัญชีก่อนการฝากทุกครั้ง</span>
                        </li>
                        <li style={{ listStyle: "disc", margin: "0px 0px 0.05rem", wordBreak: "break-word" }}>
                          <span style={{ color: "#8697a2" }}> สำหรับการฝากเงิน "ผ่านบัญชีธนาคาร" จะต้องทำรายการฝากก่อน แจ้งฝากผ่านหน้าเว็บไซต์เพื่อการปรับยอดที่รวดเร็ว</span>
                        </li>
                        <li style={{ listStyle: "disc", margin: "0px 0px 0.05rem", wordBreak: "break-word" }}>
                          <span style={{ color: "#8697a2" }}>บัญชีธนาคารฝากและถอนของสมาชิจะต้องตรงตามชื่อ-สกุลที่ลงทะเบียนเข้ามาเท่านั้น ไม่อนุญาตให้ใช้ "บัญชีบุคคลอื่น"ในการโอนเงิน</span>
                        </li>
                      </ul>
                      <div id="read-more-button" style={{ display: "flex", alignItems: "center", padding: "0.08rem 0.4rem 0.2rem", color: "rgb(0, 81, 214)", justifyContent: "center", fontSize: "0.12rem", textDecorationLine: "underline", cursor: "pointer" }}>
                        <span>อ่านเพิ่มเติม </span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="recent-transaction">
                <div className="_recentTransactionContainer_yt0gb_1 recent-transaction-container">
                  <div className="_dropdownTitle_uxqg3_1 recent-transaction-title">
                    ธุรกรรมล่าสุดของฉัน
                    <div id="dropdown-arrow" className="_dropdownArrow_uxqg3_21 ">
                      <svg className="hAror96dp3eww1cc5ooafn7dr4" width={17} height={17} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="hAror96dp3eww1cc5ooafn7dr4_dropdown">
                          <path id="hAror96dp3eww1cc5ooafn7dr4_Vector" d="M14.5444 7.10467C14.5444 7.38307 14.4409 7.66252 14.235 7.87536L9.56017 12.7069C9.30038 12.9766 8.95498 13.1228 8.5885 13.1228C8.22093 13.1228 7.87662 12.9744 7.6178 12.7058L2.94304 7.87536C2.53005 7.44963 2.53005 6.75865 2.94304 6.33181C3.35604 5.90502 4.02568 5.90502 4.43759 6.33181L8.5885 10.6219L12.7394 6.33181C13.1523 5.90502 13.821 5.90502 14.235 6.33181C14.4409 6.5447 14.5444 6.82415 14.5444 7.10467Z" fill="#61757E" />
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div id="recent-transaction-table-container" className="_recentTransactionTableContainer_yt0gb_5 ">
                    <table className="_recentTransactionTable_yt0gb_5 recent-transaction-table">
                      <thead>
                        <tr className="_recentTransactionRow_yt0gb_14 'recent-transaction-row">
                          <th>วันที่โอนเงิน</th>
                          <th>จำนวนเงิน</th>
                          <th>วิธี</th>
                          <th>สถานะ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.historylist.length === 0 ? (
                          <tr className="_emptyRecord_yt0gb_39 empty-record">
                            <td colSpan={4}>ยังไม่มีรายการ</td>
                          </tr>
                        ) : this.state.historylist.filter(x => x.type === 'DE').slice(0, 5).map((item, i) => (
                          <tr key={i} className="_recentTransactionRow_yt0gb_14 recent-transaction-row">
                            <td>{moment(item.createdate).format('DD/MM/YY HH:mm')}</td>
                            <td className="text-success">{item.amount}</td>
                            <td>ฝากเงิน</td>
                            <td>{item.status === '1' ? 'สำเร็จ' : item.status === '2' ? 'กำลังดำเนินการ' : item.status === '0' ? 'รอดำเนินการ' : item.status === '4' ? 'ยกเลิก' : 'ไม่สำเร็จ'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="_viewMore_yt0gb_43 view-more" style={{ cursor: 'pointer' }}
                      onClick={() => this.setActiveTab('transferHistory', 'history')}>
                      <span>อ่านเพิ่มเติม </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // ---- SVG ลูกศร dropdown (ใช้ซ้ำ) ----
  renderDropdownArrow() {
    return (
      <svg className="hAror96dp3eww1cc5ooafn7dr4" width={17} height={17} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="hAror96dp3eww1cc5ooafn7dr4_dropdown">
          <path id="hAror96dp3eww1cc5ooafn7dr4_Vector" d="M14.5444 7.10467C14.5444 7.38307 14.4409 7.66252 14.235 7.87536L9.56017 12.7069C9.30038 12.9766 8.95498 13.1228 8.5885 13.1228C8.22093 13.1228 7.87662 12.9744 7.6178 12.7058L2.94304 7.87536C2.53005 7.44963 2.53005 6.75865 2.94304 6.33181C3.35604 5.90502 4.02568 5.90502 4.43759 6.33181L8.5885 10.6219L12.7394 6.33181C13.1523 5.90502 13.821 5.90502 14.235 6.33181C14.4409 6.5447 14.5444 6.82415 14.5444 7.10467Z" fill="#61757E" />
        </g>
      </svg>
    );
  }

  // ─── Mobile: ไปยัง tab และสลับไปหน้า content ───────────────────────────
  goToTab = (tab, menuName) => {
    this.setActiveTab(tab, menuName);
    this.setState({ mobileActivePage: 'content' });
  };

  // ─── Mobile: หน้า overview แบบ BK8 ─────────────────────────────────────
  renderMobileHome = () => {
    const { username, balance, rankpoint, rankpic, rankname, loginstate } = this.state;
    return (
      <div className="standard-normal-font-size body-content-container m-settings-page mobileTopMargin" data-radium="true" style={{ marginTop: 59, background: '#0d1117', minHeight: '100vh' }}>
        <div className="m-account-container" style={{ padding: '0 0 80px' }}>

          {/* ── Account info ── */}
          <div className="deposit-progress-bar-container" style={{ background: 'linear-gradient(135deg,#0a3a6e 0%,#0e5f8a 100%)', padding: '16px 16px 12px', marginBottom: 8 }}>
            <div className="account-info-container" style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <div className="account-icon" style={{ width: 40, height: 40, background: 'rgba(255,255,255,0.15)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, padding: 8 }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.28567 23.59276" width="100%" height="100%" fill="#fff">
                  <g><g><g>
                    <path d="M2.7136,23.59256c-1.49661,0-2.714-1.21739-2.714-2.714v-0.59097c0-4.49253,3.55439-7.62975,8.64356-7.62975c5.08851,0,8.64291,3.13722,8.64291,7.62975v0.59097c0,1.49661-1.21739,2.714-2.714,2.714H2.7136z M8.64316,13.94322c-4.40147,0-7.35855,2.5496-7.35855,6.34437v0.59097c0,0.78814,0.64151,1.42896,1.429,1.42896h11.85846c0.78749,0,1.429-0.64082,1.429-1.42896v-0.59097C16.00106,16.49282,13.04398,13.94322,8.64316,13.94322z" />
                    <path d="M8.64316,13.9258c-3.83965,0-6.9628-3.12316-6.9628-6.9628s3.12316-6.9628,6.9628-6.9628c3.83899,0,6.96215,3.12316,6.96215,6.9628S12.48215,13.9258,8.64316,13.9258z M8.64316,1.28588c-3.1305,0-5.67777,2.54693-5.67777,5.67712c0,3.1305,2.54727,5.67746,5.67777,5.67746c3.12984,0,5.67712-2.54696,5.67712-5.67746C14.32028,3.83281,11.773,1.28588,8.64316,1.28588z" />
                  </g></g></g>
                </svg>
              </div>
              <span className="account-name" style={{ color: '#fff', fontWeight: 600, fontSize: 15 }}>{username || '-'}</span>
            </div>
            <div className="account-grade-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 0, gap: 6 }}>
              <div className="account-group-container" style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: 1, overflow: 'hidden' }}>
                {rankpic
                  ? <img loading="lazy" src={rankpic} className="group-img" alt="" style={{ width: 36, height: 36, objectFit: 'contain', flexShrink: 0 }} />
                  : <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#f5a623,#f97316)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff', flexShrink: 0 }}>VIP</div>
                }
                <p className="group-level" style={{ color: '#f0c060', fontWeight: 700, fontSize: 13, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{rankname || 'Normal'}</p>
              </div>
              <div className="account-leaderboard-container">
                <div className="icon-leaderboard-svg">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.78551 22.50142" className="beta-leaderboard" width="100%" height="100%">
                    <style dangerouslySetInnerHTML={{ __html: ".beta-leaderboard .st0{fill:#0691C0;}" }} />
                    <g className="beta-leaderboard"><g><g><g>
                      <path className="st0" d="M20.26612,17.64887c1.31785,0,2.38991,1.07274,2.38991,2.39059v0.07166c0,1.31781-1.07206,2.3899-2.38991,2.3899H3.52006c-1.31785,0-2.3899-1.07209-2.3899-2.3899v-0.07166c0-1.31785,1.07206-2.39059,2.3899-2.39059H20.26612z M20.26612,21.19589c0.598,0,1.08482-0.48681,1.08482-1.08478v-0.07166c0-0.59865-0.48682-1.08546-1.08482-1.08546H3.52006c-0.59865,0-1.08546,0.48681-1.08546,1.08546v0.07166c0,0.59797,0.48681,1.08478,1.08546,1.08478H20.26612z" />
                    </g>
                      <path className="st0" d="M23.49642,3.76839c-0.2377-0.1694-0.55645-0.1694-0.79483,0L16.25639,8.35l-3.7432-7.95789l-0.04469-0.00936c-0.01138-0.02143-0.0241-0.04217-0.03751-0.06295c-0.01203-0.01807-0.02479-0.0348-0.03816-0.05156c-0.01406-0.01738-0.0288-0.03346-0.04488-0.04886c-0.01673-0.01677-0.03346-0.03281-0.05222-0.04755c-0.01539-0.01272-0.03147-0.0241-0.0482-0.03548c-0.02143-0.01474-0.04354-0.02815-0.06699-0.04018c-0.00867-0.0047-0.01539-0.01073-0.02475-0.01474c-0.00871-0.00401-0.01742-0.00603-0.02612-0.00936c-0.0241-0.01005-0.0482-0.01875-0.07299-0.02613c-0.0194-0.00535-0.03885-0.01073-0.05894-0.01474c-0.02277-0.00466-0.04618-0.00737-0.06963-0.01005c-0.02074-0.00199-0.04217-0.00333-0.06294-0.00333c-0.02277,0-0.04554,0.00134-0.0683,0.00401c-0.02143,0.00199-0.04286,0.0047-0.06428,0.00871c-0.02143,0.00466-0.04286,0.01005-0.06428,0.01673c-0.02277,0.00669-0.04419,0.01406-0.06631,0.02345c-0.01005,0.00401-0.02006,0.006-0.0301,0.0107c-0.01005,0.0047-0.0181,0.01138-0.02815,0.01673c-0.02074,0.01073-0.04018,0.02277-0.05959,0.03552c-0.01875,0.01272-0.03751,0.02609-0.05492,0.04083c-0.01605,0.01341-0.03079,0.02746-0.04618,0.04217c-0.01741,0.01742-0.0335,0.03483-0.04889,0.05359c-0.01272,0.01539-0.0241,0.03147-0.03548,0.04755c-0.01406,0.02143-0.02746,0.04351-0.03953,0.06627c-0.00466,0.00871-0.0107,0.01608-0.01539,0.02544L7.52914,8.35L1.08329,3.76839c-0.23838-0.1694-0.55713-0.1694-0.79486,0c-0.2377,0.1694-0.34216,0.47073-0.2605,0.75067l4.32848,13.83025c0.08708,0.29934,0.36095,0.49353,0.65759,0.49353c0.06363,0,0.12857-0.00871,0.19285-0.02746c0.36363-0.10649,0.57187-0.48681,0.46607-0.85044L1.89687,6.02904l5.50569,3.91401c0.16608,0.11784,0.37501,0.156,0.57187,0.10447c0.19618-0.05156,0.35958-0.1875,0.44598-0.37165l3.47269-7.38067l3.47136,7.38067c0.08637,0.18414,0.24977,0.32008,0.44663,0.37165c0.19621,0.05153,0.40511,0.01337,0.57119-0.10447l5.50569-3.91401l-3.77536,11.9359c-0.10649,0.36363,0.10244,0.74395,0.46607,0.85044c0.06429,0.01875,0.12857,0.02746,0.19217,0.02746c0.29732,0,0.57054-0.19419,0.65824-0.49353l4.32848-13.83025C23.83927,4.23912,23.73481,3.93779,23.49642,3.76839z" />
                    </g></g></g>
                  </svg>
                </div>
                <p className="leaderboard-desc">&gt;100</p>
              </div>
            </div>
          </div>

          {/* ── Wallet section ── */}
          <MobileWalletSection
            loginstate={loginstate}
            balance={balance}
            checkcredit={this.state.checkcredit}
            showMemberAction={this.state.showMemberAction}
            onRefresh={(e) => this.recheccredit(e)}
            onToggleMemberAction={() => this.setState({ showMemberAction: !this.state.showMemberAction })}
            onStatement={() => window.location.href = '/statement'}
            onMessage={() => window.location.href = '/manager/message'}
          />



          {/* ── Member Profile Info (ชื่อ, เบอร์, ธนาคาร) ── */}
          <section style={{ background: '#1a2234', borderRadius: 10, margin: '8px 12px', padding: '14px 16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
              <span style={{ color: '#cdd6e0', fontSize: 14, fontWeight: 700 }}>ข้อมูลสมาชิก</span>
              <button
                style={{ background: 'none', border: '1px solid #4db8d0', borderRadius: 6, color: '#4db8d0', fontSize: 11, padding: '3px 10px', cursor: 'pointer' }}
                onClick={() => this.goToTab('myAccount', 'profile')}
              >แก้ไข</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                <span style={{ color: '#8697a2', fontSize: 12 }}>ชื่อ-นามสกุล</span>
                <span style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>{this.state.fname || this.state.fullname || this.state.firstname || '-'}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                <span style={{ color: '#8697a2', fontSize: 12 }}>เบอร์โทร / ยูสเซอร์</span>
                <span style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>{this.state.username || this.state.userid || '-'}</span>
              </div>
              {this.state.accnumber && this.state.accnumber.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
                  <span style={{ color: '#8697a2', fontSize: 12 }}>บัญชีธนาคาร</span>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>
                      {this.state.accnumber[0].bankname || '-'}
                    </div>
                    <div style={{ color: '#4db8d0', fontSize: 12, letterSpacing: 1 }}>
                      {this.state.accnumber[0].accnumber || '-'}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>

          {/* ── User verification ── */}
          <section className="m-user-verification-section" style={{ background: '#1a2234', borderRadius: 10, margin: '8px 12px', padding: '12px 16px' }}>
            <div className="user-verification-container m-user-verification-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ color: '#cdd6e0', fontSize: 14, fontWeight: 600 }}>การยืนยันผู้ใช้</span>
              <div className="verification--container">
                <div className="verification-icons" style={{ display: 'flex', gap: 12 }}>
                  <div className="verify-icon" title="โปรไฟล์สมาชิก" style={{ width: 28, height: 28, cursor: 'pointer', opacity: 0.5 }} onClick={() => this.goToTab('myAccount', 'profile')}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.28567 23.59276" width="100%" height="100%" fill="#4db8d0">
                      <g><g><g>
                        <path d="M2.7136,23.59256c-1.49661,0-2.714-1.21739-2.714-2.714v-0.59097c0-4.49253,3.55439-7.62975,8.64356-7.62975c5.08851,0,8.64291,3.13722,8.64291,7.62975v0.59097c0,1.49661-1.21739,2.714-2.714,2.714H2.7136z" />
                        <path d="M8.64316,13.9258c-3.83965,0-6.9628-3.12316-6.9628-6.9628s3.12316-6.9628,6.9628-6.9628c3.83899,0,6.96215,3.12316,6.96215,6.9628S12.48215,13.9258,8.64316,13.9258z" />
                      </g></g></g>
                    </svg>
                  </div>
                  <div className="verify-icon" title="ข้อความ" style={{ width: 28, height: 28, cursor: 'pointer', opacity: 0.5 }} onClick={() => this.goToTab('messages', 'profile')}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 35.5" width="100%" height="100%" fill="#4db8d0">
                      <path d="M45.7,0H4.3C1.9,0,0,1.9,0,4.3v27C0,33.6,1.9,35.5,4.3,35.5h41.5c2.3,0,4.3-1.9,4.3-4.2v-27C50,1.9,48.1,0,45.7,0z M47.2,31.2c0,0.8-0.7,1.5-1.5,1.5H4.3c-0.8,0-1.5-0.7-1.5-1.5V7.4l19.8,15.1c0.7,0.5,1.5,0.8,2.4,0.8c0.8,0,1.7-0.3,2.4-0.8L47.2,7.4V31.2z" />
                    </svg>
                  </div>
                  <div className="verify-icon" title="เปลี่ยนรหัสผ่าน" style={{ width: 28, height: 28, cursor: 'pointer', opacity: 0.5 }} onClick={() => window.location.href = '/changepassword'}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.631 24.818" width="100%" height="100%">
                      <path fill="#4db8d0" d="M13.67469,0.00013H2.95594c-1.62988,0-2.95575,1.3255-2.95575,2.95569v18.90601c0,1.62988,1.32587,2.95605,2.95575,2.95605h10.71875c1.62988,0,2.95612-1.32617,2.95544-2.95605V2.95581C16.63081,1.32563,15.30457,0.00013,13.67469,0.00013z M13.67469,23.5044H2.95594c-0.90631,0-1.64325-0.73657-1.64325-1.64258V2.95581c0-0.90594,0.73694-1.64325,1.64325-1.64325h10.71875c0.90601,0,1.64264,0.7373,1.64264,1.64325v18.90601C15.31867,22.76783,14.58106,23.5044,13.67469,23.5044z" />
                    </svg>
                  </div>
                  <div className="verify-icon" title="รายละเอียดการถอนเงิน" style={{ width: 28, height: 28, cursor: 'pointer', opacity: 0.5 }} onClick={() => this.goToTab('withdrawDetail', 'cashier')}>
                    <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/beta-verify-withdrawal.svg" alt="" style={{ width: '100%', height: '100%', filter: 'brightness(0) saturate(100%) invert(60%) sepia(60%) saturate(400%) hue-rotate(155deg)' }} />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ── Rewards Club ── */}
          <section className="m-rewards-club-section" style={{ background: 'linear-gradient(135deg,#1a2a4a 0%,#1e3d5c 100%)', borderRadius: 10, margin: '8px 12px', padding: '14px 16px' }}>
            <div className="rewards-club-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div className="rewards-club-content-wrapper">
                <p className="rewards-club-title" style={{ color: '#4db8d0', fontWeight: 700, fontSize: 14, margin: '0 0 2px' }}>Rewards Club</p>
                <p className="rewards-club-balance" style={{ color: '#fff', fontWeight: 700, fontSize: 18, margin: 0 }}>{parseFloat(rankpoint || 0).toFixed(2)} pts</p>
              </div>
              <div className="rewards-club-redeem-button-wrapper">
                <button className="rewards-club-redeem-button"
                  style={{ background: 'linear-gradient(90deg,#f97316,#f5a623)', color: '#fff', border: 'none', borderRadius: 20, padding: '8px 16px', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
                  onClick={() => this.goToTab('cashback', 'rewards')}>ข้อมูลเพิ่มเติม</button>
              </div>
            </div>
          </section>

          {/* ── Shortcut menu ── */}
          <section className="account-menu-section" style={{ margin: '8px 12px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
            {[
              {
                label: 'โปรไฟล์สมาชิก', tab: 'myAccount', group: 'profile', icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" className="m-profile" width="100%" height="100%">
                    <defs><linearGradient id="sm1" gradientUnits="userSpaceOnUse" x1="13" y1="0" x2="77" y2="90"><stop offset="0" style={{ stopColor: 'rgb(9,94,189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4,169,194)' }} /></linearGradient></defs>
                    <path fill="url(#sm1)" d="M21.12,84.09c-3.78,0-7.99-3.35-7.99-8.15v-51.8c0-4.71,3.59-8.55,7.99-8.55h47.76c4.41,0,7.99,3.84,7.99,8.55v51.41c0,4.71-3.59,8.55-7.99,8.55H21.12z M21.12,19.55c-2.35,0-4.26,2.05-4.26,4.58v51.41c0,2.53,1.91,4.58,4.26,4.58h47.76c2.35,0,4.26-2.06,4.26-4.58V24.13c0-2.53-1.91-4.58-4.26-4.58H21.12z M60.51,66.91H33.28v-8.82c0-4.37,3.57-7.93,7.94-7.93h7.69c4.37,0,7.94,3.56,7.94,7.94L60.51,66.91z M45,46.49c-4.56,0-8.27-3.71-8.27-8.27s3.71-8.27,8.27-8.27s8.27,3.71,8.27,8.27S49.56,46.49,45,46.49z" />
                  </svg>
                )
              },
              {
                label: 'แนะนำเพื่อน', tab: 'referral', group: 'rewards', icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" className="m-referral" width="100%" height="100%">
                    <defs><linearGradient id="sm2" gradientUnits="userSpaceOnUse" x1="2" y1="0" x2="88" y2="90"><stop offset="0" style={{ stopColor: 'rgb(9,94,189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4,169,194)' }} /></linearGradient></defs>
                    <path fill="url(#sm2)" d="M44.05,45.93c-6.97,0-12.64-5.67-12.64-12.64s5.67-12.64,12.64-12.64s12.64,5.67,12.64,12.64S51.02,45.93,44.05,45.93z M44.05,24.05c-5.1,0-9.25,4.15-9.25,9.25s4.15,9.25,9.25,9.25c5.1,0,9.25-4.15,9.25-9.25S49.15,24.05,44.05,24.05z M44.5,50.68c-10.88,0-19.4,7.42-19.4,16.9v6.35c0,1.91,1.55,3.46,3.46,3.46h31.89c1.91,0,3.46-1.55,3.46-3.46v-6.35C63.9,58.1,55.38,50.68,44.5,50.68z" />
                  </svg>
                )
              },
              {
                label: 'ข้อความ', tab: 'messages', group: 'profile', icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" className="m-messaging" width="100%" height="100%">
                    <defs><linearGradient id="sm3" gradientUnits="userSpaceOnUse" x1="0" y1="45" x2="90" y2="45"><stop offset="0" style={{ stopColor: 'rgb(4,169,194)' }} /><stop offset="1" style={{ stopColor: 'rgb(9,94,189)' }} /></linearGradient></defs>
                    <path fill="url(#sm3)" d="M73.7,8H16.3C10.6,8,6,12.6,6,18.3v37.4c0,5.7,4.6,10.3,10.3,10.3h3.4v14.7c0,0.8,0.9,1.2,1.5,0.7L40.8,66h32.9C79.4,66,84,61.4,84,55.7V18.3C84,12.6,79.4,8,73.7,8z" />
                  </svg>
                )
              },
              {
                label: 'รายละเอียดการถอนเงิน', tab: 'withdrawDetail', group: 'cashier', icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" className="m-bankDetails" width="100%" height="100%">
                    <defs><linearGradient id="sm4" gradientUnits="userSpaceOnUse" x1="7" y1="0" x2="83" y2="90"><stop style={{ stopColor: 'rgb(9,94,189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4,169,194)' }} /></linearGradient></defs>
                    <path fill="url(#sm4)" d="M15.27,84.09c-0.94,0-1.71-0.77-1.71-1.71V33.9H9.51c-0.53,0-1.04-0.25-1.36-0.67c-0.32-0.42-0.43-0.98-0.29-1.49l3.95-14.6c0.2-0.75,0.88-1.27,1.65-1.27h63.08c0.77,0,1.45,0.52,1.65,1.27l3.94,14.6c0.14,0.51,0.03,1.07-0.29,1.49c-0.32,0.42-0.83,0.67-1.36,0.67h-4.05v48.48c0,0.94-0.77,1.71-1.71,1.71H15.27z M63.47,80.67h9.55V33.9h-9.55V80.67z M16.98,80.67h9.55V33.9h-9.55V80.67z M45,31.47c0.22,0,0.44,0.04,0.65,0.13l14.4,5.87v-9.02L45,20.26l-15.05,8.18v9.02l14.4-5.87C44.56,31.51,44.78,31.47,45,31.47z M52.04,20.19l10.54,5.72c0.55,0.3,0.89,0.88,0.89,1.5v3.06h14.78L75.23,19.3H52.27L52.04,20.19z M11.75,30.48h14.78v-3.06c0-0.63,0.34-1.2,0.89-1.5l10.54-5.73l-0.23-0.9H14.77L11.75,30.48z" />
                  </svg>
                )
              },
              {
                label: 'เปลี่ยนรหัสผ่าน', tab: 'changePassword', group: 'profile', icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" className="m-changePassword" width="100%" height="100%">
                    <defs><linearGradient id="sm5" gradientUnits="userSpaceOnUse" x1="8" y1="0" x2="82" y2="90"><stop style={{ stopColor: 'rgb(9,94,189)' }} /><stop offset="1" style={{ stopColor: 'rgb(4,169,194)' }} /></linearGradient></defs>
                    <path fill="url(#sm5)" d="M32.62,56.86c-0.96,0-1.74-0.78-1.74-1.74v-3.35c0-4.99,2.57-9.51,6.88-12.1l0.71-0.43l-0.67-0.49c-1.02-0.75-1.9-1.6-2.61-2.54l-0.09-0.11c-0.18-0.27-0.35-0.56-0.51-0.84c-0.37-0.69-0.68-1.41-0.9-2.14c-0.1-0.32-0.18-0.65-0.25-0.98c-0.07-0.35-0.11-0.63-0.14-0.92l-0.04-0.31c-0.03-0.38-0.06-0.76-0.06-1.15c0-1.66,0.33-3.27,0.97-4.78c1.94-4.57,6.39-7.52,11.34-7.52c4.95,0,9.4,2.95,11.34,7.52c0.64,1.52,0.97,3.13,0.97,4.78c0,0.39-0.02,0.77-0.06,1.15l-0.04,0.31c-0.03,0.29-0.08,0.57-0.13,0.85l-0.06,0.28c-0.07,0.33-0.16,0.66-0.25,0.98l-0.03,0.09c-0.23,0.72-0.53,1.44-0.9,2.14c-0.16,0.29-0.33,0.57-0.51,0.85l-0.31,0.46c-0.74,0.97-1.62,1.83-2.64,2.57l-0.67,0.49l0.71,0.43c4.31,2.59,6.88,7.11,6.88,12.1v3.35c0,0.96-0.78,1.74-1.74,1.74H32.62z M45,41.12c-5.87,0-10.64,4.77-10.64,10.64v1.62h21.29v-1.62C55.65,45.9,50.87,41.12,45,41.12z M45,19.99c-4.87,0-8.83,3.96-8.83,8.83S40.13,37.65,45,37.65s8.83-3.96,8.83-8.83S49.87,19.99,45,19.99z M14.93,85.02c-3.51,0-6.37-2.86-6.37-6.37V67.49c0-3.51,2.86-6.37,6.37-6.37h60.14c3.51,0,6.37,2.86,6.37,6.37v11.16c0,3.51-2.86,6.37-6.37,6.37H14.93z M14.93,64.6c-1.59,0-2.89,1.3-2.89,2.89v11.16c0,1.59,1.3,2.89,2.89,2.89h60.14c1.59,0,2.89-1.3,2.89-2.89V67.49c0-1.59-1.3-2.89-2.89-2.89H14.93z" />
                  </svg>
                )
              },
              {
                label: 'ภารกิจประจำวัน', tab: 'dailyTask', group: 'rewards', icon: (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111 37" className="m-missiondiary" width="100%" height="100%">
                    <defs><linearGradient id="sm6" x1="36" y1="37" x2="74.967" y2="37" gradientUnits="userSpaceOnUse"><stop stopColor="#0A5EBD" /><stop offset="1" stopColor="#05A8C2" /></linearGradient></defs>
                    <path fillRule="evenodd" clipRule="evenodd" d="M65.167 3.34h5.174C72.91 3.34 75 5.57 75 8.316v20.418c0 2.744-2.09 4.976-4.66 4.976h-7.428C61.072 35.727 58.452 37 55.5 37a9.955 9.955 0 0 1-7.412-3.29h-7.429c-2.205 0-4.659-1.984-4.659-4.745V8.315c0-2.744 2.09-4.975 4.66-4.975h5.173V1.108A1.11 1.11 0 0 1 46.943 0a1.11 1.11 0 0 1 1.112 1.108V3.34h6.334V1.108A1.11 1.11 0 0 1 55.5 0a1.11 1.11 0 0 1 1.111 1.108V3.34h6.334V1.108A1.11 1.11 0 0 1 64.056 0a1.11 1.11 0 0 1 1.111 1.108V3.34ZM55.5 19.194c-4.328 0-7.86 3.522-7.86 7.837s3.532 7.836 7.86 7.836 7.86-3.521 7.86-7.836-3.532-7.837-7.86-7.837Z" fill="url(#sm6)" />
                  </svg>
                )
              },
            ].map(({ label, tab, group, icon }) => (
              <div key={tab} className="shortcut-menu" style={{ cursor: 'pointer', background: '#1a2234', borderRadius: 10, padding: '14px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }} onClick={() => this.goToTab(tab, group)}>
                <div className="menu-img-wrapper" style={{ width: 44, height: 44 }}>{icon}</div>
                <span className="shortcut-label" style={{ color: '#cdd6e0', fontSize: 11, textAlign: 'center', lineHeight: 1.3 }}>{label}</span>
              </div>
            ))}
          </section>

        </div>
      </div>
    );
  };

  // ─── Mobile: สลับระหว่าง home overview กับ content ──────────────────────
  renderMobile = () => {
    const { mobileActivePage, activeLeftTab } = this.state;

    const tabTitles = {
      deposit: 'ฝากเงิน',
      withdraw: 'ถอนเงิน',
      transfer: 'โอนเงิน',
      withdrawDetail: 'รายละเอียดการถอนเงิน',
      cashback: 'เงินคืนทันที',
      dailyTask: 'ภารกิจประจำวัน',
      referral: 'แนะนำเพื่อน',
      myAccount: 'บัญชีของฉัน',
      messages: 'ข้อความ',
      changePassword: 'เปลี่ยนรหัสผ่าน',
      transferHistory: 'ประวัติการโอนเงิน',
    };

    if (mobileActivePage === 'home') {
      return this.renderMobileHome();
    }

    return (
      <div className="standard-normal-font-size body-content-container m-settings-page mobileTopMargin" data-radium="true" style={{ marginTop: 59 }}>
        <nav className="mobile-nav header-grey" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <div className="col-left" style={{ width: 40, display: 'flex', alignItems: 'center', zIndex: 1 }}>
            <svg
              className="menu-icon beta-back"
              onClick={() => this.setState({ mobileActivePage: 'home' })}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24" height="24"
              fill="currentColor"
            >
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
            </svg>
          </div>
          <span
            className="nav-title"
            style={{ position: 'absolute', left: 0, right: 0, textAlign: 'center', fontSize: 15, fontWeight: 600, color: '#fff', pointerEvents: 'none' }}
          >
            {tabTitles[activeLeftTab] || 'บัญชี'}
          </span>
        </nav>
        <div style={{ padding: '0 20px 24px' }}>
          {this.renderRightContent()}
        </div>
      </div>
    );
  };

  render() {
    const isMobileView = window.innerWidth <= 760;
    if (isMobileView) return this.renderMobile();

    const { loginstate, userid, username, point, accnumber, firstname, rankpoint, mainacc, lastname, balance, proderedeemlist, linkaff, tblprofile, webnamex, showSharePanel } = this.state
    const { openMenus, activeLeftTab } = this.state;
    const shareTitle = `สมัครสมาชิก ${webnamex || ''} รับโบนัสทันที!`;
    const shareUrl = linkaff || window.location.origin;

    var accnumberx;
    if (accnumber != null) {
      accnumberx = accnumber[0];
    }

    return (
      <>
        <div className="standard-normal-font-size body-content-container" data-radium="true">
          <main className="settings-container beta">
            <section className="settings-container-section">

              {/* ===== LEFT SIDE ===== */}
              <div className="left-side-container">
                <div className="menu-categories-container">
                  <section className="_menuAccountContainer_wb7zv_1 menu-account-container">

                    {/* ---- แคชเชียร์ ---- */}
                    <div className="_menuAccountHeader_wb7zv_26 menu-account-header">
                      <div
                        className="_menuAccountHeaderTitle_wb7zv_36 menu-account-header-title"
                        onClick={() => this.toggleMenu('cashier')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="_menuAccountSVG_wb7zv_63">
                          <div className="_svgIcon_1ncl5_1 undefined undefined">
                            <svg width={21} height={19} viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M13.125 11.3095C13.125 13.5543 14.8916 15.381 17.0625 15.381H19.25V17.1905C19.25 18.1884 18.4651 19 17.5 19H2.625C1.17775 19 0 17.7822 0 16.2857V2.4881C0 2.42314 0.0165078 2.3635 0.0329949 2.30392C0.0369488 2.28964 0.0409015 2.27535 0.044625 2.261C0.254625 0.980759 1.32738 0 2.625 0H14.875C15.8401 0 16.625 0.811571 16.625 1.80953V3.61905H17.5C18.4651 3.61905 19.25 4.43062 19.25 5.42857V7.23812H17.0625C14.8916 7.23812 13.125 9.06483 13.125 11.3095ZM2.625 1.80953C2.142 1.80953 1.75 2.21576 1.75 2.71429C1.75 3.21281 2.142 3.61905 2.625 3.61905H14.875V1.80953H2.625ZM17.0625 8.59533H20.3438C20.706 8.59533 21 8.89933 21 9.2739V13.3453C21 13.7199 20.706 14.0239 20.3438 14.0239H17.0625C15.6153 14.0239 14.4375 12.8061 14.4375 11.3096C14.4375 9.81309 15.6153 8.59533 17.0625 8.59533ZM16.1875 11.3096C16.1875 11.809 16.5795 12.2144 17.0625 12.2144C17.5455 12.2144 17.9375 11.809 17.9375 11.3096C17.9375 10.8102 17.5455 10.4048 17.0625 10.4048C16.5795 10.4048 16.1875 10.8102 16.1875 11.3096Z" fill="url(#paint0_linear_7980_1330)" />
                              <defs>
                                <linearGradient id="paint0_linear_7980_1330" x1="0.4375" y1={19} x2={21} y2={19} gradientUnits="userSpaceOnUse">
                                  <stop offset="0.0434783" stopColor="#095EBD" />
                                  <stop offset={1} stopColor="#04A9C2" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                        <span className="_menuAccountName_wb7zv_67 menu-account-name">แคชเชียร์</span>
                        <div className={`_dropdownArrow_wb7zv_78 dropdown-arrow${openMenus.cashier ? ' _active_wb7zv_78' : ''}`}>
                          {this.renderDropdownArrow()}
                        </div>
                      </div>
                      <div className={`_submenuAccount_wb7zv_85 submenu-account${openMenus.cashier ? ' _active_wb7zv_78' : ''}`}>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'deposit' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('deposit', 'cashier')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>ฝากเงิน</span>
                        </div>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'withdraw' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('withdraw', 'cashier')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>ถอน</span>
                        </div>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'transfer' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('transfer', 'cashier')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>โอนเงิน</span>
                        </div>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'withdrawDetail' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('withdrawDetail', 'cashier')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>รายละเอียดการถอนเงิน</span>
                        </div>
                      </div>
                    </div>

                    {/* ---- รางวัล ---- */}
                    <div className="_menuAccountHeader_wb7zv_26 menu-account-header">
                      <div
                        className="_menuAccountHeaderTitle_wb7zv_36 menu-account-header-title"
                        onClick={() => this.toggleMenu('rewards')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="_dots_wb7zv_47" />
                        <div className="_menuAccountSVG_wb7zv_63">
                          <div className="_svgIcon_1ncl5_1 undefined undefined">
                            <svg width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M8.6543 3.07188C8.6543 1.40715 10.8861 0.489777 12.5425 0.204158C16.3335 -0.5087 21 0.692363 21 3.07188V17.9231C21 20.0568 17.3932 21 14.8066 21C13.487 21 12.6152 20.8433 11.6567 20.5815C11.6538 20.5807 11.6509 20.5798 11.6482 20.5789C11.6419 20.5768 11.636 20.5746 11.6291 20.5727C12.4064 19.9799 12.4946 19.8616 12.5995 19.7208C12.632 19.6773 12.666 19.6316 12.7225 19.5691C12.7253 19.5694 12.728 19.57 12.7307 19.5707C12.7335 19.5713 12.7364 19.572 12.7395 19.5723C12.8147 19.4925 12.8784 19.4049 12.942 19.3174C12.9821 19.2623 13.0222 19.2071 13.0652 19.1538C13.0772 19.1387 13.094 19.1185 13.1152 19.0931C13.2889 18.8854 13.7523 18.3311 14.1791 17.3446C14.1791 17.3342 14.1898 17.3049 14.1937 17.2955C16.5848 17.4343 18.8741 16.7608 19.7695 16.1138V14.2308C19.7695 14.7547 18.9497 15.1945 18.4733 15.4124C17.326 15.9259 15.8592 16.0849 14.5861 16.0647C14.8001 15.1569 14.8325 14.4328 14.782 13.5745C17.2253 13.5745 19.0558 12.8961 19.7695 12.3806V10.8791C19.671 10.8914 19.5727 10.9529 19.4988 11.0268C19.2773 11.2606 18.9041 11.4821 18.4734 11.679C17.3242 12.1934 15.8543 12.3519 14.5852 12.3314C14.3418 11.3846 14.1074 10.7784 13.49 9.80831C16.1995 10.1179 18.7802 9.40295 19.7695 8.68829V7.18679C19.6711 7.19906 19.5727 7.26062 19.4988 7.33445C18.4853 8.40433 15.3828 8.96569 12.7641 8.46674C12.6722 8.44837 12.5833 8.42691 12.4943 8.40551C12.4078 8.38464 12.3214 8.36384 12.2321 8.34579C11.4835 7.6501 10.7067 7.15404 9.92171 6.81752C9.91554 6.81752 9.90938 6.8145 9.90327 6.81142C9.8971 6.80833 9.89093 6.80525 9.88477 6.80525V6.80682C9.48485 6.63954 9.07305 6.51305 8.6543 6.41414V6.41135V3.07188ZM16.8482 4.7353C17.6936 4.57612 18.9535 4.18207 19.5045 3.6055C19.68 3.42043 19.7695 3.24074 19.7695 3.07188C19.7695 2.53641 18.9629 2.11147 18.4728 1.894C17.3871 1.41055 16.0028 1.22573 14.8066 1.22573C13.6052 1.22573 12.2219 1.41211 11.1411 1.894C10.6711 2.10228 9.88477 2.55811 9.88477 3.07188C9.88477 3.24074 9.97428 3.42043 10.1503 3.6055C10.7393 4.22342 11.9268 4.57747 12.765 4.7353C14.0568 4.97808 15.5564 4.97808 16.8482 4.7353ZM4.13539 7.95349C5.80448 7.24559 7.77171 7.24559 9.44075 7.95349C11.8701 8.98347 13.5762 11.3773 13.5762 14.2306C13.5762 17.9737 10.5326 20.9999 6.80859 20.9999C2.96424 20.9999 0 17.9108 0 14.2306C0 11.3857 1.69804 8.98688 4.13539 7.95349ZM6.90736 13.5802C6.70543 13.5675 6.53647 13.5569 6.37361 13.394C5.79274 12.813 6.69126 11.7186 7.60705 12.8086C7.8246 13.0695 8.21271 13.1043 8.47343 12.8844C8.73357 12.6662 8.76783 12.278 8.54917 12.0178C8.21907 11.6242 7.84042 11.3541 7.42383 11.215V10.4974C7.42383 10.1572 7.14866 9.88201 6.80859 9.88201C6.46852 9.88201 6.19335 10.1572 6.19335 10.4974V11.2238C5.41249 11.5006 4.96288 12.2136 4.96288 12.9589C4.96288 13.5398 5.26664 14.0682 5.50367 14.3051C5.93005 14.7316 6.30681 14.7719 6.62727 14.806C6.86444 14.8314 7.07083 14.8534 7.24362 15.0263C7.78929 15.5721 7.02023 16.6023 6.14232 15.7552C5.8996 15.5191 5.50847 15.5263 5.27296 15.7703C5.03683 16.0143 5.04343 16.4043 5.28797 16.6399C5.56396 16.907 5.87105 17.0763 6.19339 17.1847V17.9229C6.19339 18.263 6.46856 18.5383 6.80859 18.5383C7.14866 18.5383 7.42383 18.263 7.42383 17.9229V17.1866C7.43689 17.1819 7.45067 17.1804 7.46445 17.179C7.47948 17.1773 7.49451 17.1757 7.50855 17.1699C8.72077 16.6736 9.04962 15.0924 8.11355 14.1562C7.58002 13.6224 7.20733 13.599 6.90736 13.5802Z" fill="url(#paint0_linear_2839_15402)" />
                              <defs>
                                <linearGradient id="paint0_linear_2839_15402" x1="0.4375" y1={21} x2={21} y2={21} gradientUnits="userSpaceOnUse">
                                  <stop offset="0.0434783" stopColor="#095EBD" />
                                  <stop offset={1} stopColor="#04A9C2" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                        <span className="_menuAccountName_wb7zv_67 menu-account-name">รางวัล</span>
                        <div className={`_dropdownArrow_wb7zv_78 dropdown-arrow${openMenus.rewards ? ' _active_wb7zv_78' : ''}`}>
                          {this.renderDropdownArrow()}
                        </div>
                      </div>
                      <div className={`_submenuAccount_wb7zv_85 submenu-account${openMenus.rewards ? ' _active_wb7zv_78' : ''}`}>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'cashback' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('cashback', 'rewards')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>เงินคืนทันที</span>
                        </div>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'dailyTask' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('dailyTask', 'rewards')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>งานประจำวัน<span className="_count_wb7zv_117 count">(1)</span></span>
                        </div>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'referral' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('referral', 'rewards')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>แนะนำเพื่อน</span>
                        </div>
                      </div>
                    </div>

                    {/* ---- โปรไฟล์ของฉัน ---- */}
                    <div className="_menuAccountHeader_wb7zv_26 menu-account-header">
                      <div
                        className="_menuAccountHeaderTitle_wb7zv_36 menu-account-header-title"
                        onClick={() => this.toggleMenu('profile')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="_menuAccountSVG_wb7zv_63">
                          <div className="_svgIcon_1ncl5_1 undefined undefined">
                            <svg width={19} height={19} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.6299 14.2856L12.597 13.5272L12.3389 12.4949C13.1504 11.6914 13.7061 10.5877 13.8708 9.45565C14.3204 9.329 14.6688 8.94342 14.7289 8.45975L14.9268 6.8764C14.9688 6.54229 14.8658 6.20427 14.6442 5.95092C14.5143 5.80209 14.3505 5.68969 14.1692 5.62081L14.242 4.13009L14.5381 3.83321C14.9839 3.35899 15.3535 2.54596 14.5809 1.36637C13.9871 0.459971 12.9786 0 11.5821 0C11.0311 0 9.76285 0 8.58171 0.79325C5.20915 0.863722 4.75 2.4304 4.75 3.95835C4.75 4.31382 4.83628 5.11419 4.89328 5.5971C4.68981 5.66122 4.50537 5.77997 4.36128 5.94385C4.13565 6.19958 4.03115 6.53921 4.07312 6.87723L4.27103 8.46058C4.33594 8.97673 4.72781 9.38285 5.2234 9.47946C5.38728 10.568 5.91453 11.636 6.67927 12.4261L6.40377 13.5288L3.3709 14.2872C1.3854 14.782 0 16.5569 0 18.6041C0 18.8226 0.177345 19 0.395845 19H18.6042C18.8227 19 19.0001 18.8211 19.0001 18.6026C19 16.5569 17.6146 14.782 15.6299 14.2856Z" fill="url(#paint0_linear_2839_15407)" />
                              <defs>
                                <linearGradient id="paint0_linear_2839_15407" x1="0.395835" y1={19} x2="19.0001" y2={19} gradientUnits="userSpaceOnUse">
                                  <stop offset="0.0434783" stopColor="#095EBD" />
                                  <stop offset={1} stopColor="#04A9C2" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                        <span className="_menuAccountName_wb7zv_67 menu-account-name">โปรไฟล์ของฉัน</span>
                        <div className={`_dropdownArrow_wb7zv_78 dropdown-arrow${openMenus.profile ? ' _active_wb7zv_78' : ''}`}>
                          {this.renderDropdownArrow()}
                        </div>
                      </div>
                      <div className={`_submenuAccount_wb7zv_85 submenu-account${openMenus.profile ? ' _active_wb7zv_78' : ''}`}>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'myAccount' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('myAccount', 'profile')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>บัญชีของฉัน</span>
                        </div>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'messages' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('messages', 'profile')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>ข้อความ</span>
                        </div>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'changePassword' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('changePassword', 'profile')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>เปลี่ยนรหัสผ่าน</span>
                        </div>
                      </div>
                    </div>

                    {/* ---- ประวัติ ---- */}
                    <div className="_menuAccountHeader_wb7zv_26 menu-account-header">
                      <div
                        className="_menuAccountHeaderTitle_wb7zv_36 menu-account-header-title"
                        onClick={() => this.toggleMenu('history')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="_menuAccountSVG_wb7zv_63">
                          <div className="_svgIcon_1ncl5_1 undefined undefined">
                            <svg width={16} height={20} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M9.6 4.49219C9.6 5.24606 10.2441 5.85938 11.0359 5.85938H16V17.8516C16 19.0362 14.9878 20 13.7436 20H2.25641C1.01223 20 0 19.0362 0 17.8516V2.14844C0 0.963787 1.01223 0 2.25641 0H9.6V4.49219ZM6.34751 14.0625H3.3641C3.02425 14.0625 2.74872 14.3249 2.74872 14.6484C2.74872 14.972 3.02425 15.2344 3.3641 15.2344H6.34751C6.68732 15.2344 6.96289 14.972 6.96289 14.6484C6.96289 14.3249 6.68732 14.0625 6.34751 14.0625ZM3.3641 10.9375C3.02425 10.9375 2.74872 11.1999 2.74872 11.5234C2.74872 11.847 3.02425 12.1094 3.3641 12.1094H12.3897C12.7296 12.1094 13.0051 11.847 13.0051 11.5234C13.0051 11.1999 12.7296 10.9375 12.3897 10.9375H3.3641ZM13.0051 8.39844C13.0051 8.07487 12.7296 7.8125 12.3897 7.8125H3.3641C3.02425 7.8125 2.74872 8.07487 2.74872 8.39844C2.74872 8.722 3.02425 8.98438 3.3641 8.98438H12.3897C12.7296 8.98438 13.0051 8.722 13.0051 8.39844ZM11.0359 4.68741C10.9228 4.68741 10.8308 4.59979 10.8308 4.4921L10.8308 0.24292C11.014 0.334014 11.185 0.449365 11.3385 0.587646L15.2943 4.15101C15.4683 4.30776 15.6131 4.48952 15.7257 4.68741H11.0359Z" fill="url(#paint0_linear_2839_15411)" />
                              <defs>
                                <linearGradient id="paint0_linear_2839_15411" x1="0.333333" y1={20} x2={16} y2={20} gradientUnits="userSpaceOnUse">
                                  <stop offset="0.0434783" stopColor="#095EBD" />
                                  <stop offset={1} stopColor="#04A9C2" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                        <span className="_menuAccountName_wb7zv_67 menu-account-name">ประวัติ</span>
                        <div className={`_dropdownArrow_wb7zv_78 dropdown-arrow${openMenus.history ? ' _active_wb7zv_78' : ''}`}>
                          {this.renderDropdownArrow()}
                        </div>
                      </div>
                      <div className={`_submenuAccount_wb7zv_85 submenu-account${openMenus.history ? ' _active_wb7zv_78' : ''}`}>
                        <div
                          className={`_submenuAccountHeader_wb7zv_101 submenu-account-header${activeLeftTab === 'transferHistory' ? ' _selected_wb7zv_104' : ''}`}
                          onClick={() => this.setActiveTab('transferHistory', 'history')}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>ประวัติการโอนเงิน</span>
                        </div>
                      </div>
                    </div>

                  </section>
                </div>

                {/* referral code block */}
                <div className="referral-code-container">
                  <div className="_referralDetailContainer_1w7kh_1 referral-detail-container">
                    <p className="_referralDetailContainerTitle_1w7kh_22 _referralDetailContainerTitle_beta_1w7kh_57 referral-detail-title">ส่งต่อความสุขให้เพื่อนของคุณ </p>
                    <p>แนะนำเพื่อนสมัคร โดยให้รหัสอ้างอิงกับเพื่อนของคุณ รับโบนัสทั้งคุณและเพื่อน</p>
                    <div className="_referralCopyDetailContainer_1w7kh_31 referral-copy-detail-container">
                      <div className="_referralCopyDetail_1w7kh_31 referral-copy-detail"
                        style={{ cursor: 'pointer', position: 'relative' }}
                        onClick={() => this.setState({ showSharePanel: !showSharePanel })}>
                        <div className="undefined referral-copy-detail-title">
                          <span style={{ fontSize: '11px', wordBreak: 'break-all' }}>{username || '-'}</span>
                        </div>
                        <div className="_arrow_1w7kh_46 arrow">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 12.723 22.026" className="" width="100%" height="100%" id="" prefix="">
                            <style dangerouslySetInnerHTML={{ __html: "\n.beta-arrow-right .st0{fill:#FFFFFF;}\n  " }} />
                            <g className="beta-arrow-right"><g>
                              <path className="st0" d="M1.95544,0.00004c0.4981,0,0.9981,0.1914,1.3789,0.5722l8.64462,8.64462 c0.4824,0.4804,0.7441,1.1191,0.7441,1.7968c0,0.6797-0.2656,1.3164-0.7461,1.795l-8.64262,8.64452 c-0.7617,0.7637-1.998,0.7637-2.7617,0c-0.7636-0.7637-0.7636-2.002,0-2.7637l7.67582-7.67582L0.57264,3.33784 c-0.7636-0.7636-0.7636-2,0-2.7656C0.95354,0.19144,1.45354,0.00004,1.95544,0.00004L1.95544,0.00004z M1.95544,0.00004" />
                            </g></g>
                          </svg>
                        </div>

                        {/* Share floating panel */}
                        {showSharePanel && (
                          <div className="_referralDetailFloating_jlh8j_1 referral-detail-floating floating-referral"
                            onClick={(e) => e.stopPropagation()}
                            style={{ position: 'absolute', top: '100%', left: 0, zIndex: 999 }}>
                            <div className="_triangle_jlh8j_6 triangle" />
                            <div className="share-dropdown">
                              {/* Copy link */}
                              <span className="ref-copy" style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  navigator.clipboard.writeText(shareUrl);
                                  Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'คัดลอกลิงก์แล้ว', showConfirmButton: false, timer: 1500 });
                                  this.setState({ showSharePanel: false });
                                }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 146.9 162.8" className="beta-copy share-icon" width="100%" height="100%">
                                  <style dangerouslySetInnerHTML={{ __html: "\n.beta-copy .st0{fill:#0071E3;}\n  " }} />
                                  <g className="beta-copy"><g><g>
                                    <path className="st0" d="M17.7,162.8c-9.8,0-17.7-7.9-17.7-17.7V42.4c0-9.8,7.9-17.7,17.7-17.7h22.9v-7C40.6,7.9,48.5,0,58.3,0h49.6c1,0,2,0.4,2.7,1.1l35.3,35.2c0.7,0.7,1.1,1.7,1.1,2.7v81.4c0,9.8-7.9,17.7-17.7,17.7h-22.9v7c0,9.8-7.9,17.7-17.7,17.7H17.7z" />
                                  </g></g></g>
                                </svg>
                                <span>คัดลอกโค้ด</span>
                              </span>

                              {/* Facebook */}
                              <button className="ref-share-link" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', color: 'inherit' }}
                                onClick={() => { window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank', 'width=600,height=400'); this.setState({ showSharePanel: false }); }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 458.50677 458.50677" className="beta-facebook share-icon" width="100%" height="100%">
                                  <style dangerouslySetInnerHTML={{ __html: "\n.beta-facebook .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#3A589B;}\n.beta-facebook .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n  " }} />
                                  <g className="beta-facebook"><g>
                                    <path className="st0" d="M229.25339,458.50711c-126.60921,0-229.25372-102.64453-229.25372-229.25372c0-126.61685,102.64452-229.25372,229.25372-229.25372s229.25372,102.63687,229.25372,229.25372C458.50711,355.86258,355.86258,458.50711,229.25339,458.50711z" />
                                    <path className="st1" d="M196.8904,353.96741h51.53624V229.2381h34.3804l4.55453-42.97742h-38.93494l0.0535-21.51929c0-11.20288,1.06982-17.21698,17.14816-17.21698H287.117v-42.98505h-34.38806c-41.30388,0-55.83855,20.85443-55.83855,55.91498v25.80634H171.1452v42.98508h25.74519V353.96741z" />
                                  </g></g>
                                </svg>
                                <span>Facebook</span>
                              </button>

                              {/* WhatsApp */}
                              <button className="ref-share-link" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', color: 'inherit' }}
                                onClick={() => { window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareTitle + ' ' + shareUrl)}`, '_blank'); this.setState({ showSharePanel: false }); }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" className="beta-whatsapp share-icon" width="100%" height="100%">
                                  <style dangerouslySetInnerHTML={{ __html: "\n.beta-whatsapp .st0{fill:#25D366;}\n.beta-whatsapp .st1{fill:#FFFFFF;}\n  " }} />
                                  <g className="beta-whatsapp"><g><g>
                                    <path d="M45.6,5c-22.1,0-40,17.9-40,40c0,8.1,2.4,15.6,6.5,21.9L7,84.4l18.1-5c6,3.6,13,5.6,20.5,5.6c22.1,0,40-17.9,40-40C85.6,22.9,67.7,5,45.6,5z" />
                                    <path className="st1" d="M67.6,56c0-0.5-0.4-1-0.8-1.2c-3.2-1.5-6.5-3-9.7-4.4c-0.4-0.2-0.8-0.1-1.1,0.2l-4.4,4.9c-0.3,0.4-0.9,0.5-1.4,0.3c-2.3-0.9-5.3-2.5-8.4-5.2c-3.7-3.2-5.9-6.6-7.1-8.8c0.6-0.4,2.3-1.6,3-3.9c0,0,0,0,0,0c0.5-1.4,0.4-2.9-0.1-4.3c-0.9-2.3-2.6-6.8-3.3-7.5c-0.1-0.1-0.2-0.2-0.2-0.2c-0.5-0.4-1.1-0.7-1.8-0.7c-0.2,0-0.5,0-0.7,0c-0.8,0-1.4,0-1.9,0c-1.4,0.2-2.4,1.1-3.1,1.9c-0.8,0.9-1.7,2.3-2.3,4.2c0,0.2-0.1,0.3-0.1,0.5c-0.7,2.3-0.5,4.8,0.3,7.1c0.8,2.2,1.9,4.7,3.5,7.4c2.8,4.6,5.9,7.5,8,9.4c2.3,2.2,5.2,4.8,9.8,7c4.2,2,8.1,2.8,10.7,3.1c1.1,0.1,3,0.1,5.2-0.7c1-0.4,1.9-0.9,2.6-1.4c1.8-1.3,3.1-3.3,3.4-5.5v0C67.7,57.3,67.7,56.6,67.6,56L67.6,56z" />
                                  </g></g></g>
                                </svg>
                                <span>Whatsapp</span>
                              </button>

                              {/* Telegram */}
                              <button className="ref-share-link" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', color: 'inherit' }}
                                onClick={() => { window.open(`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`, '_blank'); this.setState({ showSharePanel: false }); }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 533.7627 533.76318" className="beta-telegram share-icon" width="100%" height="100%">
                                  <style dangerouslySetInnerHTML={{ __html: "\n.beta-telegram .st1{fill:#FFFFFF;}\n  " }} />
                                  <g className="beta-telegram"><g><g>
                                    <circle cx="266.88107" cy="266.88171" r="266.88129" fill="url(#tg-grad)" />
                                    <defs><linearGradient id="tg-grad" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#42BCE8" /><stop offset="1" stopColor="#23A7DC" /></linearGradient></defs>
                                    <path className="st1" d="M396.74121,153.5215l-47.66702,240.33351c0,0-6.66699,16.66599-25,8.66599L214.0742,318.18701l-40-19.332l-67.333-22.668c0,0-10.3335-3.66602-11.3335-11.6655c-1-8,11.6665-12.33401,11.6665-12.33401l267.66699-105C374.74121,147.1875,396.74121,137.5215,396.74121,153.5215z" />
                                  </g></g></g>
                                </svg>
                                <span>Telegram</span>
                              </button>

                              {/* Line */}
                              <button className="ref-share-link" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', color: 'inherit' }}
                                onClick={() => { window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(shareUrl)}`, '_blank'); this.setState({ showSharePanel: false }); }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 346.65448 323.02771" className="beta-line share-icon" width="100%" height="100%">
                                  <style dangerouslySetInnerHTML={{ __html: "\n.beta-line .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#3ACE00;}\n.beta-line .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n  " }} />
                                  <g className="beta-line"><g><g>
                                    <path className="st0" d="M154.26251,1.22393C67.57468,10.70541-28.59462,81.13924,7.9768,177.30858c33.86243,90.75133,140.86771,94.8148,148.99469,101.5873c14.89948,10.836-13.54497,54.1799,20.31746,41.98941c59.5979-23.02643,166.6032-108.35979,169.31218-178.79366C349.31015,52.69482,249.07732-9.61204,154.26251,1.22393z" />
                                    <path className="st1" d="M284.29428,113.64718h-33.86247v18.96297h31.15346c4.06351,0,6.77249,2.70898,6.77249,6.77148c0,2.70898-2.70898,5.41797-6.77249,5.41797h-31.15346v21.67197h33.86247c4.06348,0,8.12698,2.70898,8.12698,8.12698c0,4.06348-4.06351,8.12698-8.12698,8.12698h-39.28044c-4.06351,0-8.12698-1.35449-9.48147-4.06348V107.87471h48.76092c4.06351,0,6.77249,2.70898,6.77249,6.77249C291.06677,116.35616,288.35776,113.64718,284.29428,113.64718z" />
                                  </g></g></g>
                                </svg>
                                <span>Line</span>
                              </button>

                              {/* Email */}
                              <button className="ref-share-link" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', color: 'inherit' }}
                                onClick={() => { window.location.href = `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareUrl)}`; this.setState({ showSharePanel: false }); }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132.5 94" className="beta-email share-icon" width="100%" height="100%">
                                  <style dangerouslySetInnerHTML={{ __html: "\n.beta-email .st0{fill:#0071E3;}\n  " }} />
                                  <g className="beta-email"><g>
                                    <path d="M121.3,0h-0.9H12.1h-0.9C5.1,0,0,5.1,0,11.3v71.4C0,88.9,5.1,94,11.3,94h110c6.2,0,11.3-5.1,11.3-11.3V11.3C132.5,5.1,127.5,0,121.3,0z M120.4,7.4c1.9,0,2.6,1.5,2.8,2c0.2,0.5,0.5,2.1-1,3.2L68,53.9c-0.5,0.4-1.1,0.6-1.8,0.6c-0.6,0-1.3-0.2-1.8-0.6L10.4,12.6c-1.5-1.2-1.1-2.8-1-3.2c0.2-0.5,0.8-2,2.7-2H120.4z M125.1,82.7c0,2.1-1.7,3.9-3.9,3.9h-110c-2.1,0-3.9-1.7-3.9-3.9v-63L60,59.8c1.8,1.4,4,2.1,6.3,2.1c2.2,0,4.5-0.7,6.3-2.1l52.6-40.1V82.7z" />
                                  </g></g>
                                </svg>
                                <span>Email</span>
                              </button>

                            </div>
                            <div className="hover-overlay" onClick={() => this.setState({ showSharePanel: false })} />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===== RIGHT SIDE ===== */}
              <div className="right-side-container-section">
                {/* banner slider */}
                <div>
                  <div className="slick-slider slick-initialized" dir="ltr">
                    <div className="slick-list">
                      <div className="slick-track" style={{ width: 3960, opacity: 1, transform: "translate3d(-792px, 0px, 0px)" }}>
                        <div data-index={-1} tabIndex={-1} className="slick-slide slick-cloned" aria-hidden="true" style={{ width: 792 }}>
                          <div><div className="_banner-container_l0ga8_1" tabIndex={-1} style={{ width: "100%", display: "inline-block" }}>
                            <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/banner20250411034616349.webp" className="_banner-img_l0ga8_14" alt="banner-img" />
                            <div className="_banner-content_l0ga8_5 "><p className="_banner-title_l0ga8_18" /><div className="_banner-desc_l0ga8_25" /></div>
                            <div><div /></div>
                          </div></div>
                        </div>
                        <div data-index={0} className="slick-slide slick-active slick-current" tabIndex={-1} aria-hidden="false" style={{ outline: "none", width: 792 }}>
                          <div><div className="_banner-container_l0ga8_1" tabIndex={-1} style={{ width: "100%", display: "inline-block" }}>
                            <img loading="lazy" src="https://s3.newworld.center/image/b52acf85-5c99-4a40-a55b-babb8b50e006.webp" className="_banner-img_l0ga8_14" alt="banner-img" />
                            <div className="_banner-content_l0ga8_5 "><p className="_banner-title_l0ga8_18" /><div className="_banner-desc_l0ga8_25" /></div>
                            <div><div /></div>
                          </div></div>
                        </div>
                        <div data-index={1} className="slick-slide" tabIndex={-1} aria-hidden="true" style={{ outline: "none", width: 792 }}>
                          <div><div className="_banner-container_l0ga8_1" tabIndex={-1} style={{ width: "100%", display: "inline-block" }}>
                            <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/banner20250411034616349.webp" className="_banner-img_l0ga8_14" alt="banner-img" />
                            <div className="_banner-content_l0ga8_5 "><p className="_banner-title_l0ga8_18" /><div className="_banner-desc_l0ga8_25" /></div>
                            <div><div /></div>
                          </div></div>
                        </div>
                      </div>
                    </div>
                    <div className="_dotsContainer_l0ga8_31">
                      <button className="_dots_l0ga8_31 _active_l0ga8_45" aria-label="slide 1 bullet" />
                      <button className="_dots_l0ga8_31 " aria-label="slide 2 bullet" />
                    </div>
                  </div>
                </div>

                {/* wallet */}
                <div className="main-wallet-container">
                  <div className="_seamlessMainWallet_19rt2_9 _availableToBetWallet_19rt2_68" id="seamlessMainWallet">
                    <div className="_upperSection_19rt2_82">
                      <div className="_mainWalletTitle_19rt2_26">ยอดกระเป๋าคงเหลือ</div>
                    </div>
                    <div className="_lowerSection_19rt2_91">
                      <div className="_mainWalletAmountContainer_19rt2_30">
                        <style>{`@keyframes pk-wallet-spin{to{transform:rotate(360deg)}}`}</style>
                        <span className="_amountCurrency_19rt2_112">THB</span>
                        <span className="_mainWalletAmount_19rt2_30" style={this.state.balanceReloading ? { opacity: 0.45, transition: 'opacity .2s' } : {}}>{parseFloat(balance || 0).toFixed(2)}</span>{" "}
                        <div className="_mainWalletRefresh_19rt2_375 " style={{ cursor: 'pointer', display: 'inline-flex', ...(this.state.balanceReloading ? { animation: 'pk-wallet-spin .7s linear infinite' } : {}) }} onClick={this.reloadBalance} title="รีเฟรชยอดเงิน">
                          <svg className="hsrfni6eo-098c25eef5f4rhe" width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.8606 20.2863C8.28372 20.2863 5.86893 19.2993 4.04291 17.4941C3.52241 16.9795 3.07017 16.4143 2.68619 15.8069L2.63499 15.7225L2.27662 16.6589C2.15716 16.9457 1.88411 17.1313 1.57692 17.1313C1.50866 17.1313 1.4404 17.1229 1.38067 17.106L1.29534 17.0807C0.919897 16.9289 0.732175 16.4986 0.885766 16.119L1.84144 13.6558C1.9353 13.428 2.13156 13.2593 2.37048 13.2087C2.42167 13.1918 2.4814 13.1918 2.54113 13.1918C2.6094 13.1918 2.67766 13.2003 2.73739 13.2171L5.24604 14.0354C5.43376 14.0945 5.58735 14.221 5.68121 14.3981C5.77507 14.5753 5.79214 14.7777 5.73241 14.9633C5.63855 15.2755 5.34843 15.4779 5.01565 15.4779C4.94739 15.4779 4.87913 15.4695 4.81086 15.4526L4.05144 15.208L4.12824 15.3261C4.40982 15.731 4.73407 16.119 5.09245 16.4733C6.62835 17.9918 8.67623 18.8353 10.8521 18.8353C13.028 18.8353 15.0758 18.0002 16.6118 16.4733C18.1477 14.9465 19.0009 12.9219 19.0009 10.7708C19.0009 10.3659 19.3337 10.0369 19.7433 10.0369C20.1529 10.0369 20.4857 10.3659 20.4857 10.7708C20.4857 13.3184 19.4873 15.7057 17.6613 17.5025C15.8438 19.2993 13.4205 20.2947 10.8436 20.2947L10.8606 20.2863Z" fill="url(#hsrfni6eo-098c25eef5f4rhe_paint0_linear_225_7227)" />
                            <path d="M1.56657 10.3911C1.157 10.3911 0.824219 10.0622 0.824219 9.65724C0.824219 7.10965 1.82256 4.72234 3.64858 2.92553C5.46607 1.12028 7.88939 0.133301 10.4578 0.133301C13.0262 0.133301 15.4495 1.12028 17.2755 2.92553C17.7875 3.43167 18.2482 4.0053 18.6322 4.61267L18.6834 4.69703L19.0418 3.76066C19.1613 3.47385 19.4343 3.28826 19.7415 3.28826C19.8097 3.28826 19.878 3.2967 19.9377 3.31357L20.0231 3.34731C20.3985 3.49916 20.5862 3.92938 20.4326 4.30899L19.477 6.77222C19.3831 6.99999 19.1868 7.1687 18.9479 7.21931C18.8967 7.23619 18.837 7.23619 18.7773 7.23619C18.709 7.23619 18.6407 7.22775 18.581 7.21088L16.0724 6.39261C15.8846 6.33356 15.7311 6.20703 15.6372 6.02988C15.5433 5.85273 15.5263 5.65027 15.586 5.46468C15.6884 5.15256 15.97 4.9501 16.3028 4.9501C16.371 4.9501 16.4393 4.95854 16.5075 4.97541L17.267 5.22005L17.1902 5.10195C16.9086 4.69703 16.5843 4.30899 16.226 3.95469C14.6901 2.43626 12.6422 1.59268 10.4663 1.59268C8.29044 1.59268 6.24256 2.42782 4.70665 3.95469C3.17074 5.47312 2.31746 7.49769 2.31746 9.6488C2.31746 10.0537 1.98468 10.3827 1.57511 10.3827L1.56657 10.3911Z" fill="url(#hsrfni6eo-098c25eef5f4rhe_paint1_linear_225_7227)" />
                            <defs>
                              <linearGradient id="hsrfni6eo-098c25eef5f4rhe_paint0_linear_225_7227" x1="0.826036" y1="10.214" x2="20.4942" y2="10.214" gradientUnits="userSpaceOnUse">
                                <stop stopColor="#095EBD" /><stop offset={1} stopColor="#04A9C2" />
                              </linearGradient>
                              <linearGradient id="hsrfni6eo-098c25eef5f4rhe_paint1_linear_225_7227" x1="0.824219" y1="10.214" x2="20.4924" y2="10.214" gradientUnits="userSpaceOnUse">
                                <stop stopColor="#095EBD" /><stop offset={1} stopColor="#04A9C2" />
                              </linearGradient>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="_separateLine_19rt2_197" />
                  <div className="_lockedBonusWallet_19rt2_16" id="lockedBonusWallet">
                    <div className="_upperSection_19rt2_82">
                      <div className="_mainWalletTitle_19rt2_26">ยอดล็อคคงเหลือ</div>
                    </div>
                    <div className="_lowerSection_19rt2_91">
                      <div className="_mainWalletAmountContainer_19rt2_30">
                        <span className="_amountCurrency_19rt2_112">THB</span>
                        <span className="_mainWalletAmount_19rt2_30">0.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ===== เนื้อหาขวา — เปลี่ยนตาม activeLeftTab ===== */}
                <div className="menu-categories-details">
                  {this.renderRightContent()}
                </div>

              </div>
            </section>
          </main>
        </div>
      </>
    );
  }
}

export default App;
